import React, { useState, useEffect, useMemo, createRef, createContext, useRef, useContext, forwardRef, isValidElement, useCallback } from 'react';
import { Flex, Button, Icon, Text, Box, RefreshedSelectInput, RefreshedButtonInput, Popover, PopoverTrigger, PopoverContent, ToggleButtonGroup, useMediaQuery, Grid, Alert, Modal, Heading, ListItem, Loader, List, useDisclosure, RefreshedInput, usePopper, Portal, ModalHeader, ModalBody } from '@spothero/ui';
import dayjs from 'dayjs';
import ReactDatePicker from 'react-datepicker';
import { ChevronLeft, ChevronRight, Clock, Calendar, ArrowLeft, X, ChevronDown, ChevronUp, Center, AirplaneFilled, Search, TicketEvent, XCircleFilled, FilledInfoCircle } from '@spothero/icons';
import debounce from 'lodash.debounce';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React,
    k = Symbol.for("react.element"),
    l = Symbol.for("react.fragment"),
    m = Object.prototype.hasOwnProperty,
    n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function q(c, a, g) {
    var b,
      d = {},
      e = null,
      h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return {
      $$typeof: k,
      type: c,
      key: e,
      ref: h,
      props: d,
      _owner: n.current
    };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      var React$1 = React;

      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.
      var REACT_ELEMENT_TYPE = Symbol.for('react.element');
      var REACT_PORTAL_TYPE = Symbol.for('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
      var REACT_CONTEXT_TYPE = Symbol.for('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol.for('react.memo');
      var REACT_LAZY_TYPE = Symbol.for('react.lazy');
      var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      // -----------------------------------------------------------------------------

      var enableScopeAPI = false; // Experimental Create Event Handle API.
      var enableCacheElement = false;
      var enableTransitionTracing = false; // No known bugs, but needs performance testing

      var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
      }
      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      } // Keep in sync with react-reconciler/getComponentNameFromFiber

      function getContextName(type) {
        return type.displayName || 'Context';
      } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

      function getComponentNameFromType(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return 'Profiler';
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }

            // eslint-disable-next-line no-fallthrough
          }
        }
        return null;
      }
      var assign = Object.assign;

      // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {}
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }
          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.

          return '\n' + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function () {
              throw Error();
            }; // $FlowFixMe

            Object.defineProperty(Fake.prototype, 'props', {
              set: function () {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });
            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                      // but we have a user-provided "displayName"
                      // splice it in to make the stack more readable.

                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }
                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.

        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }
        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }
        return '';
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  // eslint-disable-next-line react-internal/prod-error-codes
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a);
      }

      /*
       * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
       * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
       *
       * The functions in this module will throw an easier-to-understand,
       * easier-to-debug exception with a clear errors message message explaining the
       * problem. (Instead of a confusing exception thrown inside the implementation
       * of the `value` object).
       */
      // $FlowFixMe only called in DEV, so void return is not possible.
      function typeName(value) {
        {
          // toStringTag is needed for namespaced types like Temporal.Instant
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      } // $FlowFixMe only called in DEV, so void return is not possible.

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function () {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function () {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */

      var ReactElement = function (type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */

      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = '' + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = '' + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object

          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props

          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }
          return '';
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */

      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */

      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */

      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */

      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }
          var propTypes;
          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }
          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */

      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = 'null';
            } else if (isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }
            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)

          if (validType) {
            var children = props.children;
            if (children !== undefined) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.

      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === 'production') {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

var utc$2 = {exports: {}};

var utc$1 = utc$2.exports;
var hasRequiredUtc;
function requireUtc() {
  if (hasRequiredUtc) return utc$2.exports;
  hasRequiredUtc = 1;
  (function (module, exports) {
    !function (t, i) {
      module.exports = i() ;
    }(utc$1, function () {

      var t = "minute",
        i = /[+-]\d\d(?::?\d\d)?/g,
        e = /([+-]|\d\d)/g;
      return function (s, f, n) {
        var u = f.prototype;
        n.utc = function (t) {
          var i = {
            date: t,
            utc: !0,
            args: arguments
          };
          return new f(i);
        }, u.utc = function (i) {
          var e = n(this.toDate(), {
            locale: this.$L,
            utc: !0
          });
          return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function () {
          return n(this.toDate(), {
            locale: this.$L,
            utc: !1
          });
        };
        var o = u.parse;
        u.parse = function (t) {
          t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function () {
          if (this.$u) {
            var t = this.$d;
            this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
          } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function (s, f) {
          var n = this.$utils().u;
          if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
          if ("string" == typeof s && (s = function (t) {
            void 0 === t && (t = "");
            var s = t.match(i);
            if (!s) return null;
            var f = ("" + s[0]).match(e) || ["-", 0, 0],
              n = f[0],
              u = 60 * +f[1] + +f[2];
            return 0 === u ? 0 : "+" === n ? u : -u;
          }(s), null === s)) return this;
          var u = Math.abs(s) <= 16 ? 60 * s : s,
            o = this;
          if (f) return o.$offset = u, o.$u = 0 === s, o;
          if (0 !== s) {
            var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
          } else o = this.utc();
          return o;
        };
        var h = u.format;
        u.format = function (t) {
          var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, i);
        }, u.valueOf = function () {
          var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function () {
          return !!this.$u;
        }, u.toISOString = function () {
          return this.toDate().toISOString();
        }, u.toString = function () {
          return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function (t) {
          return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function (t, i, e) {
          if (t && this.$u === t.$u) return c.call(this, t, i, e);
          var s = this.local(),
            f = n(t).local();
          return c.call(s, f, i, e);
        };
      };
    });
  })(utc$2);
  return utc$2.exports;
}

var utcExports = requireUtc();
var utc = /*@__PURE__*/getDefaultExportFromCjs(utcExports);

var timezone$2 = {exports: {}};

var timezone$1 = timezone$2.exports;
var hasRequiredTimezone;
function requireTimezone() {
  if (hasRequiredTimezone) return timezone$2.exports;
  hasRequiredTimezone = 1;
  (function (module, exports) {
    !function (t, e) {
      module.exports = e() ;
    }(timezone$1, function () {

      var t = {
          year: 0,
          month: 1,
          day: 2,
          hour: 3,
          minute: 4,
          second: 5
        },
        e = {};
      return function (n, i, o) {
        var r,
          a = function (t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t),
              r = function (t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short",
                  o = t + "|" + i,
                  r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                  hour12: !1,
                  timeZone: t,
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  timeZoneName: i
                }), e[o] = r), r;
              }(n, i);
            return r.formatToParts(o);
          },
          u = function (e, n) {
            for (var i = a(e, n), r = [], u = 0; u < i.length; u += 1) {
              var f = i[u],
                s = f.type,
                m = f.value,
                c = t[s];
              c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3],
              l = 24 === d ? 0 : d,
              h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000",
              v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
          },
          f = i.prototype;
        f.tz = function (t, e) {
          void 0 === t && (t = r);
          var n,
            i = this.utcOffset(),
            a = this.toDate(),
            u = a.toLocaleString("en-US", {
              timeZone: t
            }),
            f = Math.round((a - new Date(u)) / 1e3 / 60),
            s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
          if (!Number(s)) n = this.utcOffset(0, e);else if (n = o(u, {
            locale: this.$L
          }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
            var m = n.utcOffset();
            n = n.add(i - m, "minute");
          }
          return n.$x.$timezone = t, n;
        }, f.offsetName = function (t) {
          var e = this.$x.$timezone || o.tz.guess(),
            n = a(this.valueOf(), e, {
              timeZoneName: t
            }).find(function (t) {
              return "timezonename" === t.type.toLowerCase();
            });
          return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function (t, e) {
          if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
          var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
            locale: this.$L
          });
          return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function (t, e, n) {
          var i = n && e,
            a = n || e || r,
            f = u(+o(), a);
          if ("string" != typeof t) return o(t).tz(a);
          var s = function (t, e, n) {
              var i = t - 60 * e * 1e3,
                o = u(i, n);
              if (e === o) return [i, e];
              var r = u(i -= 60 * (o - e) * 1e3, n);
              return o === r ? [i, o] : [t - 60 * Math.min(o, r) * 1e3, Math.max(o, r)];
            }(o.utc(t, i).valueOf(), f, a),
            m = s[0],
            c = s[1],
            d = o(m).utcOffset(c);
          return d.$x.$timezone = a, d;
        }, o.tz.guess = function () {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function (t) {
          r = t;
        };
      };
    });
  })(timezone$2);
  return timezone$2.exports;
}

var timezoneExports = requireTimezone();
var timezone = /*@__PURE__*/getDefaultExportFromCjs(timezoneExports);

var duration$2 = {exports: {}};

var duration$1 = duration$2.exports;
var hasRequiredDuration;
function requireDuration() {
  if (hasRequiredDuration) return duration$2.exports;
  hasRequiredDuration = 1;
  (function (module, exports) {
    !function (t, s) {
      module.exports = s() ;
    }(duration$1, function () {

      var t,
        s,
        n = 1e3,
        i = 6e4,
        e = 36e5,
        r = 864e5,
        o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        u = 31536e6,
        d = 2628e6,
        a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,
        h = {
          years: u,
          months: d,
          days: r,
          hours: e,
          minutes: i,
          seconds: n,
          milliseconds: 1,
          weeks: 6048e5
        },
        c = function (t) {
          return t instanceof g;
        },
        f = function (t, s, n) {
          return new g(t, n, s.$l);
        },
        m = function (t) {
          return s.p(t) + "s";
        },
        l = function (t) {
          return t < 0;
        },
        $ = function (t) {
          return l(t) ? Math.ceil(t) : Math.floor(t);
        },
        y = function (t) {
          return Math.abs(t);
        },
        v = function (t, s) {
          return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
          } : {
            negative: !1,
            format: "" + t + s
          } : {
            negative: !1,
            format: ""
          };
        },
        g = function () {
          function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function (s) {
              i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
              var e = t.match(a);
              if (e) {
                var r = e.slice(2).map(function (t) {
                  return null != t ? Number(t) : 0;
                });
                return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
              }
            }
            return this;
          }
          var y = l.prototype;
          return y.calMilliseconds = function () {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function (s, n) {
              return s + (t.$d[n] || 0) * h[n];
            }, 0);
          }, y.parseFromMilliseconds = function () {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
          }, y.toISOString = function () {
            var t = v(this.$d.years, "Y"),
              s = v(this.$d.months, "M"),
              n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"),
              e = v(this.$d.hours, "H"),
              r = v(this.$d.minutes, "M"),
              o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"),
              d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative,
              a = e.format || r.format || u.format ? "T" : "",
              h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
          }, y.toJSON = function () {
            return this.toISOString();
          }, y.format = function (t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss",
              i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
              };
            return n.replace(o, function (t, s) {
              return s || String(i[t]);
            });
          }, y.as = function (t) {
            return this.$ms / h[m(t)];
          }, y.get = function (t) {
            var s = this.$ms,
              n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
          }, y.add = function (t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
          }, y.subtract = function (t, s) {
            return this.add(t, s, !0);
          }, y.locale = function (t) {
            var s = this.clone();
            return s.$l = t, s;
          }, y.clone = function () {
            return f(this.$ms, this);
          }, y.humanize = function (s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
          }, y.valueOf = function () {
            return this.asMilliseconds();
          }, y.milliseconds = function () {
            return this.get("milliseconds");
          }, y.asMilliseconds = function () {
            return this.as("milliseconds");
          }, y.seconds = function () {
            return this.get("seconds");
          }, y.asSeconds = function () {
            return this.as("seconds");
          }, y.minutes = function () {
            return this.get("minutes");
          }, y.asMinutes = function () {
            return this.as("minutes");
          }, y.hours = function () {
            return this.get("hours");
          }, y.asHours = function () {
            return this.as("hours");
          }, y.days = function () {
            return this.get("days");
          }, y.asDays = function () {
            return this.as("days");
          }, y.weeks = function () {
            return this.get("weeks");
          }, y.asWeeks = function () {
            return this.as("weeks");
          }, y.months = function () {
            return this.get("months");
          }, y.asMonths = function () {
            return this.as("months");
          }, y.years = function () {
            return this.get("years");
          }, y.asYears = function () {
            return this.as("years");
          }, l;
        }(),
        p = function (t, s, n) {
          return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
        };
      return function (n, i, e) {
        t = e, s = e().$utils(), e.duration = function (t, s) {
          var n = e.locale();
          return f(t, {
            $l: n
          }, s);
        }, e.isDuration = c;
        var r = i.prototype.add,
          o = i.prototype.subtract;
        i.prototype.add = function (t, s) {
          return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function (t, s) {
          return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
      };
    });
  })(duration$2);
  return duration$2.exports;
}

var durationExports = requireDuration();
var duration = /*@__PURE__*/getDefaultExportFromCjs(durationExports);

/**
 * This file is used for any timezone related dayjs functions by leveraging the utc and timezone plugins
 *
 * @module dayjs-timezone
 */
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

const DatePickerHeader$1 = ({
  date,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
  decreaseMonth,
  increaseMonth,
  multipleDatesCount,
  errorMessage
}) => {
  const monthYear = dayjs(date).format('MMMM YYYY');
  const multipleDatesCountText = multipleDatesCount ? `${multipleDatesCount} ${multipleDatesCount === 1 ? 'day' : 'days'} selected` : '';
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsxs(Flex, {
      justifyContent: "center",
      alignItems: "center",
      gap: 2,
      "data-testid": "DatePickerHeader",
      children: [jsxRuntimeExports.jsx(Button, {
        "aria-label": "Previous month",
        variant: "tertiary",
        isDisabled: prevMonthButtonDisabled,
        onClick: decreaseMonth,
        color: "black",
        sx: {
          '&:hover': {
            color: 'black'
          }
        },
        "data-testid": "DatePickerHeader-prev-month-button",
        children: jsxRuntimeExports.jsx(Icon, {
          as: ChevronLeft,
          width: 6,
          height: 6,
          "data-testid": "DatePickerHeader-left-chevron-icon"
        })
      }), jsxRuntimeExports.jsx(Text, {
        fontWeight: "bold",
        fontSize: "base",
        "data-testid": "DatePickerHeader-month-year-text",
        children: monthYear
      }), jsxRuntimeExports.jsx(Button, {
        "aria-label": "Next month",
        variant: "tertiary",
        isDisabled: nextMonthButtonDisabled,
        onClick: increaseMonth,
        color: "black",
        sx: {
          '&:hover': {
            color: 'black'
          }
        },
        "data-testid": "DatePickerHeader-next-month-button",
        children: jsxRuntimeExports.jsx(Icon, {
          as: ChevronRight,
          width: 6,
          height: 6,
          "data-testid": "DatePickerHeader-right-chevron-icon"
        })
      })]
    }), !errorMessage && multipleDatesCount ? jsxRuntimeExports.jsx(Text, {
      textAlign: "center",
      variant: "caption",
      "data-testid": "DatePickerHeader-selected-count-text",
      children: multipleDatesCountText
    }) : null, errorMessage ? jsxRuntimeExports.jsx(Text, {
      textAlign: "center",
      variant: "caption",
      color: "red",
      "data-testid": "DatePickerHeader-error-message",
      children: errorMessage
    }) : null]
  });
};

// Note: Replace # in the SVG code with %23, otherwise it will not work in the browser.
const endKeyboardSelectedSvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><rect x="0" y="4" width="22" height="32" fill="%23e2e6eb" /><circle cx="20" cy="20" r="18" fill="rgba(91, 170, 250, 0.7)" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const endSvg$1 = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><rect x="0" y="4" width="22" height="32" fill="%23e2e6eb" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const inRangeKeyboardSelectedSvg = `<svg width="48" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="40" fill="white" /><rect x="0" y="4" width="48" height="32" fill="%23e2e6eb" /><circle cx="24" cy="20" r="18" fill="rgba(91, 170, 250, 0.7)" /><circle cx="24" cy="20" r="16" fill="%23e1e6ec" /></svg>`;
const inRangeSvg$1 = `<svg width="48" height="40" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="48" height="40" fill="%23ffffff" /><rect x="0" y="4" width="48" height="32" fill="%23e2e6eb" /></svg>`;
const keyboardSelectedSvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="18" fill="rgba(91, 170, 250, 0.7)" /><circle cx="20" cy="20" r="16" fill="%23e1e6ec" /></svg>`;
const selectedSvg$1 = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const startEndSvg$1 = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const startSvg$1 = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><rect x="20" y="4" width="22" height="32" fill="%23e2e6eb" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const todaySvg$1 = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="16" fill="%23E6F8FD" /></svg>`;
/*
We are using background images to show the selected date, range start, range end, and in-range dates.
The background images are SVGs that are base64 encoded.
The alternative approach to use ::after and absolute positioning did not work well with the react-datepicker library.
The absolute positioning caused creation on new stack contexts and the z-index did not work as expected.
 */
const reactDatePickerStyleOverrides$1 = {
  '.react-datepicker': {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 'sm',
    fontWeight: 'normal',
    padding: {
      base: 1,
      mobileXL: 2
    },
    borderWidth: 0
  },
  '.react-datepicker *': {
    background: 'white',
    fontFamily: '"Plus Jakarta Sans", sans-serif'
  },
  '.react-datepicker__header': {
    userSelect: 'none',
    background: 'white',
    border: 'none',
    padding: '0'
  },
  '.react-datepicker__month-container': {
    float: 'none'
  },
  '.react-datepicker__month': {
    paddingTop: {
      base: 0,
      mobileXL: 1
    }
  },
  '.react-datepicker__day': {
    width: 10,
    height: 10,
    margin: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 0,
    ':hover': {
      borderRadius: 0
    },
    cursor: 'pointer',
    outline: 'none',
    color: 'black'
  },
  '.react-datepicker__day--disabled': {
    cursor: 'not-allowed',
    color: 'gray.400'
  },
  '.react-datepicker__aria-live': {
    display: 'none'
  },
  '.react-datepicker__day-name': {
    marginY: {
      base: 1,
      mobileXL: 2
    },
    marginX: 2,
    fontWeight: 'semibold',
    color: 'gray.600'
  }
};
// Below there are some instances where there is a /**/ inserted before the url of the background image property
// This is a solution to an a strange bug in how Chakra sometimes get confused by background images and thinks they are gradients
// Usually a good solution is to use the style prop instead of the sx prop, but here since we are overriding named classes, using this dumb hack makes more sense
// Relevant unresolved thread: https://github.com/chakra-ui/chakra-ui/issues/7548
const dateRangePickerStyleOverrides$1 = {
  [`.react-datepicker__day--today,
    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected,
    .react-datepicker__day--in-range,
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end,
    .react-datepicker__day--selecting-range-start,
    .react-datepicker__day--selecting-range-end`]: {
    background: 'white',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  },
  [`.react-datepicker__day--selected,
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end,
    .react-datepicker__day--selecting-range-start,
    .react-datepicker__day--selecting-range-end`]: {
    color: 'white',
    fontWeight: 'semibold'
  },
  [`.react-datepicker__day--today:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):not(.react-datepicker__day--selected)`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${todaySvg$1}')`,
    fontWeight: 'normal'
  },
  [`.react-datepicker__day--keyboard-selected.react-datepicker__day--today:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):not(.react-datepicker__day--selected)`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${keyboardSelectedSvg}')`
  },
  [`.react-datepicker__day--selected`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${selectedSvg$1}')`
  },
  [`.react-datepicker__day--in-range,
     .react-datepicker__day--in-selecting-range`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${inRangeSvg$1}')`
  },
  [`.react-datepicker__day--range-start,
    .react-datepicker__day--selecting-range-start`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${startSvg$1}')`
  },
  [`.react-datepicker__day--range-end,
    .react-datepicker__day--selecting-range-end
    `]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${endSvg$1}')`
  },
  [`.react-datepicker__day--range-start.react-datepicker__day--range-end,
    .react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${startEndSvg$1}')`
  },
  [`.react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${keyboardSelectedSvg}')`
  },
  [`.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range:not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${inRangeKeyboardSelectedSvg}')`
  },
  [`.react-datepicker__day--range-end.react-datepicker__day--keyboard-selected:not(.react-datepicker__day--range-start),
    .react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range-end:not(.react-datepicker__day--selecting-range-start)`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${endKeyboardSelectedSvg}')`
  }
};
const singleDatePickerStyleOverrides = {
  [`.react-datepicker__day--selected, .react-datepicker__day--today, .react-datepicker__day--keyboard-selected`]: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontWeight: 'semibold'
  },
  [`.react-datepicker__day--today`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${todaySvg$1}')`,
    fontWeight: 'normal'
  },
  [`.react-datepicker__day--keyboard-selected`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${keyboardSelectedSvg}')`
  },
  '.react-datepicker__day--selected': {
    color: 'white',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${selectedSvg$1}')`
  }
};
const multipleDatePickerStyleOverrides = {
  [`.react-datepicker__day--highlighted, .react-datepicker__day--keyboard-selected`]: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontWeight: 'semibold'
  },
  [`.react-datepicker__day--today`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${todaySvg$1}')`,
    fontWeight: 'normal'
  },
  [`.react-datepicker__day--keyboard-selected`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${keyboardSelectedSvg}')`
  },
  '.react-datepicker__day--highlighted': {
    color: 'white',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${selectedSvg$1}')`
  }
};

const SingleDatePicker = ({
  date,
  setDate,
  styleOverrides = {}
}) => {
  const minDate = dayjs().startOf('day').toDate();
  const formatWeekDay = nameOfDay => nameOfDay.substring(0, 2);
  return jsxRuntimeExports.jsx(Box, {
    sx: {
      ...reactDatePickerStyleOverrides$1,
      ...singleDatePickerStyleOverrides,
      ...styleOverrides
    },
    "data-testid": "SingleDatePicker-popper",
    children: jsxRuntimeExports.jsx(ReactDatePicker, {
      "data-testid": "SingleDatePicker",
      allowSameDay: true,
      onChange: setDate,
      selected: date,
      date: date,
      formatWeekDay: formatWeekDay,
      minDate: minDate,
      renderCustomHeader: props => jsxRuntimeExports.jsx(DatePickerHeader$1, {
        ...props
      }),
      inline: true
    })
  });
};

const MultipleDatesPicker$1 = ({
  dates,
  setDates,
  styleOverrides = {}
}) => {
  const minDate = dayjs().startOf('day').toDate();
  const maxDate = dayjs().add(29, 'day').endOf('day').toDate();
  const formatWeekDay = nameOfDay => nameOfDay.substring(0, 2);
  const onChange = selectedDates => {
    const selectedDate = selectedDates[0];
    // Allow the user to deselect a previously selected date by clicking on it again.
    const filteredDates = dates.filter(date => !dayjs(date).isSame(selectedDate, 'day'));
    if (filteredDates.length < dates.length) {
      // remove the selected date from the existing dates
      setDates(filteredDates);
    } else {
      // add the selected date to the existing dates
      setDates([...dates, selectedDate]);
    }
  };
  return jsxRuntimeExports.jsx(Box, {
    sx: {
      ...reactDatePickerStyleOverrides$1,
      ...multipleDatePickerStyleOverrides,
      ...styleOverrides
    },
    "data-testid": "MultipleDatesPicker-popper",
    children: jsxRuntimeExports.jsx(ReactDatePicker, {
      "data-testid": "MultipleDatesPicker",
      onChange: onChange,
      highlightDates: dates,
      selectsMultiple: true,
      formatWeekDay: formatWeekDay,
      minDate: minDate,
      maxDate: maxDate,
      selected: dates.length > 0 ? dates[dates.length - 1] : null,
      renderCustomHeader: props => jsxRuntimeExports.jsx(DatePickerHeader$1, {
        ...props
      }),
      inline: true
    })
  });
};

/**
 * Combines a date and a time into a single date object
 * @param {Dayjs|Date} date - The date object
 * @param {Dayjs|Date|string} time - The time string in HH:mm format or a date object
 * @param {string} timezone - The timezone to use
 */
const combineDateTime = (date, time, timezone = null) => {
  if (!date) {
    throw new Error('Date is required');
  }
  let hours;
  let minutes;
  if (typeof time === 'string') {
    [hours, minutes] = time.split(':').map(Number);
  } else {
    const timeDj = timezone ? dayjs(time).tz(timezone) : dayjs(time);
    hours = timeDj.get('hour');
    minutes = timeDj.get('minute');
  }
  if (timezone) {
    return dayjs(date).tz(timezone).set('hour', hours).set('minute', minutes).set('second', 0).set('millisecond', 0);
  }
  return dayjs(date).set('hour', hours).set('minute', minutes).set('second', 0).set('millisecond', 0);
};
const combineDateTimeToDate = (date, time, timezone = null) => {
  return combineDateTime(date, time, timezone).toDate();
};

const getMinDateTime = timezone => {
  const now = dayjs().tz(timezone).set('second', 0).set('millisecond', 0);
  return now.get('minute') < 30 ? now.set('minute', 0) : now.set('minute', 30);
};
const DateRangePicker$3 = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  timezone,
  styleOverrides = {}
}) => {
  const minDate = getMinDateTime(timezone).toDate();
  // We use local state to allow the user to select a range of dates before committing to context
  const [localStartDate, setLocalStartDate] = useState(startDate);
  const [localEndDate, setLocalEndDate] = useState(endDate);
  const formatWeekDay = nameOfDay => nameOfDay.substring(0, 2);
  const onChange = selectedDates => {
    // When user starts making the range selection, we receive array with one date value.
    // Once the user finishes the range selection then we get array with two date values.
    const [selectedStartDate, selectedEndDate] = selectedDates;
    const bothDatesSelected = Boolean(selectedStartDate && selectedEndDate);
    let eDate;
    setLocalStartDate(selectedStartDate);
    setLocalEndDate(selectedEndDate);
    // combineDateTime is used to preserve the original time of the start and end dates
    const sDate = combineDateTime(selectedStartDate, startDate, null);
    if (bothDatesSelected) {
      eDate = combineDateTime(selectedEndDate, endDate, null);
    } else {
      // User is in the middle of selecting a date range.
      // We set the end date to be 30 minutes after the start date.
      eDate = sDate.clone().add(30, 'minute');
    }
    setStartDate(sDate.toDate());
    setEndDate(eDate.toDate());
  };
  // Handle the case where the user selects a start or end date in the past
  // Set the start or end date to the minimum time of the current half hour
  useEffect(() => {
    if (localStartDate || localEndDate) {
      const minDateTime = getMinDateTime(timezone);
      const starts = dayjs(localStartDate).tz(timezone);
      const ends = dayjs(localEndDate).tz(timezone);
      if (starts.isBefore(minDateTime)) {
        const newStartDate = minDateTime.toDate();
        setStartDate(newStartDate);
        setLocalStartDate(newStartDate);
      }
      if (ends.isBefore(minDateTime)) {
        const newEndDate = minDateTime.add(30, 'minute').toDate();
        setEndDate(newEndDate);
        setLocalEndDate(newEndDate);
      }
    }
  }, [localStartDate, localEndDate, setStartDate, setEndDate, timezone]);
  return jsxRuntimeExports.jsx(Box, {
    paddingTop: "4",
    sx: {
      ...reactDatePickerStyleOverrides$1,
      ...dateRangePickerStyleOverrides$1,
      ...styleOverrides
    },
    "data-testid": "DateRangePicker-popper",
    children: jsxRuntimeExports.jsx(ReactDatePicker, {
      "data-testid": "DateRangePicker",
      allowSameDay: true,
      onChange: onChange,
      selected: localStartDate,
      startDate: localStartDate,
      endDate: localEndDate,
      selectsRange: true,
      formatWeekDay: formatWeekDay,
      minDate: minDate,
      renderCustomHeader: props => jsxRuntimeExports.jsx(DatePickerHeader$1, {
        ...props
      }),
      inline: true
    })
  });
};

// date and time formats
const TIME_DISPLAY = 'h:mm A';
const TIME_API = 'HH:mm:ss';
const SHORT_DATE_MONTH_NAME_DAY = 'MMM DD';
const SHORT_DATE_MONTH_DAY = 'MM/DD';
const LONG_DATE_DAY_NAME_MONTH_DAY = 'dddd, MMM D';
const LONG_DATE_MONTH_NAME_DAY_YEAR = 'MMM D, YYYY';
const LONG_DATE_DAY_NAME_MONTH_NAME_DAY_YEAR = 'dddd, MMM D, YYYY';
const HALF_HOUR_TIME_VALUES = ['00:00:00', '00:30:00', '01:00:00', '01:30:00', '02:00:00', '02:30:00', '03:00:00', '03:30:00', '04:00:00', '04:30:00', '05:00:00', '05:30:00', '06:00:00', '06:30:00', '07:00:00', '07:30:00', '08:00:00', '08:30:00', '09:00:00', '09:30:00', '10:00:00', '10:30:00', '11:00:00', '11:30:00', '12:00:00', '12:30:00', '13:00:00', '13:30:00', '14:00:00', '14:30:00', '15:00:00', '15:30:00', '16:00:00', '16:30:00', '17:00:00', '17:30:00', '18:00:00', '18:30:00', '19:00:00', '19:30:00', '20:00:00', '20:30:00', '21:00:00', '21:30:00', '22:00:00', '22:30:00', '23:00:00', '23:30:00'];
const VARIATION_DESKTOP_REFRESHED = 'refreshed';
/**
 * Formats a time string to a human-readable format (e.g. 12:30 PM)
 * @param {string} time - The time string (HH:mm:ss) to format
 */
const formatTime = time => {
  const [hours, minutes] = time.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, '0');
  return `${formattedHours}:${formattedMinutes} ${period}`;
};

// Note: Replace # in the SVG code with %23, otherwise it will not work in the browser.
const endSvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><rect x="0" y="4" width="22" height="32" fill="%23e2e6eb" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const inRangeSvg = `<svg width="48" height="40" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="48" height="40" fill="%23ffffff" /><rect x="0" y="4" width="48" height="32" fill="%23e2e6eb" /></svg>`;
const selectedSvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const startEndSvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const startSvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><rect x="20" y="4" width="22" height="32" fill="%23e2e6eb" /><circle cx="20" cy="20" r="16" fill="black" /></svg>`;
const todaySvg = `<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="white" /><circle cx="20" cy="20" r="16" fill="%23E6F8FD" /></svg>`;
/*
We are using background images to show the selected date, range start, range end, and in-range dates.
The background images are SVGs that are base64 encoded.
The alternative approach to use ::after and absolute positioning did not work well with the react-datepicker library.
The absolute positioning caused creation on new stack contexts and the z-index did not work as expected.
 */
const reactDatePickerStyleOverrides = {
  '.react-datepicker': {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 'sm',
    fontWeight: 'normal',
    padding: {
      base: 1,
      mobileXL: 3
    },
    borderWidth: 0
  },
  '.react-datepicker *': {
    background: 'white',
    fontFamily: '"Plus Jakarta Sans", sans-serif'
  },
  '.react-datepicker__header': {
    userSelect: 'none',
    background: 'white',
    border: 'none',
    padding: '0'
  },
  '.react-datepicker__month-container': {
    float: 'none'
  },
  '.react-datepicker__month': {
    paddingTop: {
      base: 0,
      mobileXL: 1
    }
  },
  '.react-datepicker__day': {
    width: 10,
    height: 10,
    margin: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 0,
    ':hover': {
      borderRadius: 0
    },
    cursor: 'pointer',
    outline: 'none',
    color: 'black'
  },
  '.react-datepicker__day--disabled': {
    cursor: 'not-allowed',
    color: 'gray.400'
  },
  '.react-datepicker__aria-live': {
    display: 'none'
  },
  '.react-datepicker__day-name': {
    marginY: {
      base: 1,
      mobileXL: 2
    },
    marginX: 2,
    fontWeight: 'semibold',
    color: 'gray.600'
  }
};
// Below there are some instances where there is a /**/ inserted before the url of the background image property
// This is a solution to an a strange bug in how Chakra sometimes get confused by background images and thinks they are gradients
// Usually a good solution is to use the style prop instead of the sx prop, but here since we are overriding named classes, using this dumb hack makes more sense
// Relevant unresolved thread: https://github.com/chakra-ui/chakra-ui/issues/7548
const dateRangePickerStyleOverrides = {
  [`.react-datepicker__day--today,
    .react-datepicker__day--selected,
    .react-datepicker__day--in-range,
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end`]: {
    background: 'white',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  },
  [`.react-datepicker__day--selected,
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end`]: {
    color: 'white',
    fontWeight: 'semibold'
  },
  [`.react-datepicker__day--today:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):not(.react-datepicker__day--selected)`]: {
    color: 'black',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${todaySvg}')`,
    fontWeight: 'normal'
  },
  [`.react-datepicker__day--selected`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${selectedSvg}')`
  },
  [`.react-datepicker__day--in-range,.react-datepicker__day--in-range:hover`]: {
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${inRangeSvg}')`
  },
  [`.react-datepicker__day.react-datepicker__day--range-start,.react-datepicker__day.react-datepicker__day--range-start:hover`]: {
    color: 'white',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${startSvg}')`
  },
  [`.react-datepicker__day.react-datepicker__day--range-end,.react-datepicker__day.react-datepicker__day--range-end:hover`]: {
    color: 'white',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${endSvg}')`
  },
  [`.react-datepicker__day.react-datepicker__day--range-start.react-datepicker__day--range-end`]: {
    color: 'white',
    backgroundImage: `/**/url('data:image/svg+xml;utf8,${startEndSvg}')`
  }
};

const DatePickerHeader = ({
  date,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
  decreaseMonth,
  increaseMonth,
  multipleDatesCount,
  errorMessage
}) => {
  const monthYear = dayjs(date).format('MMMM YYYY');
  const multipleDatesCountText = multipleDatesCount ? `${multipleDatesCount} ${multipleDatesCount === 1 ? 'day' : 'days'} selected` : '';
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsxs(Flex, {
      justifyContent: "center",
      alignItems: "center",
      gap: 2,
      "data-testid": "DatePickerHeader",
      children: [jsxRuntimeExports.jsx(Button, {
        "aria-label": "Previous month",
        variant: "tertiary",
        isDisabled: prevMonthButtonDisabled,
        onClick: decreaseMonth,
        color: "black",
        sx: {
          '&:hover': {
            color: 'black'
          }
        },
        "data-testid": "DatePickerHeader-prev-month-button",
        children: jsxRuntimeExports.jsx(Icon, {
          as: ChevronLeft,
          width: 6,
          height: 6,
          "data-testid": "DatePickerHeader-left-chevron-icon"
        })
      }), jsxRuntimeExports.jsx(Text, {
        fontWeight: "bold",
        fontSize: "base",
        "data-testid": "DatePickerHeader-month-year-text",
        children: monthYear
      }), jsxRuntimeExports.jsx(Button, {
        "aria-label": "Next month",
        variant: "tertiary",
        isDisabled: nextMonthButtonDisabled,
        onClick: increaseMonth,
        color: "black",
        sx: {
          '&:hover': {
            color: 'black'
          }
        },
        "data-testid": "DatePickerHeader-next-month-button",
        children: jsxRuntimeExports.jsx(Icon, {
          as: ChevronRight,
          width: 6,
          height: 6,
          "data-testid": "DatePickerHeader-right-chevron-icon"
        })
      })]
    }), !errorMessage && multipleDatesCount ? jsxRuntimeExports.jsx(Text, {
      textAlign: "center",
      variant: "caption",
      "data-testid": "DatePickerHeader-selected-count-text",
      children: multipleDatesCountText
    }) : null, errorMessage ? jsxRuntimeExports.jsx(Text, {
      textAlign: "center",
      variant: "caption",
      color: "red",
      "data-testid": "DatePickerHeader-error-message",
      children: errorMessage
    }) : null]
  });
};

const formattedTimes = HALF_HOUR_TIME_VALUES.map(time => {
  return {
    time,
    formattedTime: formatTime(time)
  };
});
const getTrimmedTimes = ({
  maximumTime,
  minimumTime
}) => {
  if (maximumTime === null && minimumTime === null) {
    return formattedTimes;
  }
  if (maximumTime) {
    const index = formattedTimes.findIndex(timeOption => timeOption.time === maximumTime);
    // Special case: Allow all times
    if (maximumTime === '00:00:00') {
      return formattedTimes;
    }
    return formattedTimes.slice(0, index);
  } else {
    const index = formattedTimes.findIndex(timeOption => timeOption.time === minimumTime);
    // Special case: Allow all times
    if (minimumTime === '23:30:00' || minimumTime === '00:00:00') {
      return formattedTimes;
    }
    return formattedTimes.slice(index + 1);
  }
};
const TimePicker = ({
  id,
  time,
  setTime,
  maximumTime,
  minimumTime,
  disabled = false,
  label,
  placeholder,
  'data-testid': dataTestId = 'TimePicker',
  onFocus,
  onBlur
}) => {
  // Condition: only one of minimumTime or maximumTime can be provided
  if (maximumTime && minimumTime) {
    throw new Error('Only one of minimumTime or maximumTime can be provided to TimePicker');
  }
  const trimmedTimes = useMemo(() => getTrimmedTimes({
    maximumTime,
    minimumTime
  }), [minimumTime, maximumTime]);
  return jsxRuntimeExports.jsx(RefreshedSelectInput, {
    id: id,
    "data-testid": dataTestId,
    label: label,
    isDisabled: disabled,
    icon: jsxRuntimeExports.jsx(Icon, {
      as: Clock
    }),
    iconSize: 18,
    iconColor: "black",
    fontWeight: "medium",
    fontSize: "base",
    backgroundColor: "white",
    height: "100%",
    lineHeight: "21px",
    formControlStyles: {
      height: '100%'
    },
    value: time,
    /*
    The Chakra UI Select component renders the placeholder as an option in the dropdown.
    To avoid this, we only render the placeholder if the time is not set.
     */
    placeholder: time ? null : placeholder,
    onChange: e => setTime(e.target.value),
    onFocus: onFocus,
    onBlur: onBlur,
    children: trimmedTimes.map(formattedTime => jsxRuntimeExports.jsx("option", {
      value: formattedTime.time,
      children: formattedTime.formattedTime
    }, formattedTime.formattedTime))
  });
};

const DateInput$1 = React.forwardRef(({
  id,
  value,
  isHighlighted,
  onClick,
  ...props
}, ref) => {
  return jsxRuntimeExports.jsx(Box, {
    ref: ref,
    flex: 1,
    sx: {
      '& .chakra-button': {
        paddingX: 3,
        paddingY: 3,
        lineHeight: '21px',
        minHeight: 0,
        color: 'black'
      }
    },
    "data-testid": id,
    ...props,
    height: "100%",
    children: jsxRuntimeExports.jsx(RefreshedButtonInput, {
      id: id,
      isHighlighted: isHighlighted,
      buttonValue: value ? dayjs(value).format(LONG_DATE_MONTH_NAME_DAY_YEAR) : 'Select date',
      rightElement: jsxRuntimeExports.jsx(Icon, {
        as: Calendar,
        width: 4.5,
        height: 4.5
      }),
      rightElementStyles: {
        zIndex: 'auto',
        pointerEvents: 'none'
      },
      onClick: onClick
    })
  });
});

const DatePicker = ({
  id,
  activePopover,
  mode,
  date,
  toggleDate,
  onChange,
  onTimePickerFocus,
  onTimePickerBlur,
  onDatePickerFocus,
  onDatePickerBlur,
  minDate,
  time,
  handleTimeChange,
  clearActivePopover,
  minimumTime,
  styleOverrides = {},
  pickerProps = {}
}) => {
  const handleToggleDate = () => {
    onDatePickerFocus?.();
    toggleDate();
  };
  const handleDateChange = date => {
    onDatePickerBlur?.();
    onChange(date);
  };
  const handleClickOutside = () => {
    // ignore events that are not relevant to this date picker
    if (!activePopover || mode !== activePopover) {
      return;
    }
    onDatePickerBlur?.();
    clearActivePopover();
  };
  return jsxRuntimeExports.jsxs(Flex, {
    gap: 4,
    "data-testid": id,
    sx: {
      '& .chakra-popover__popper': {
        zIndex: 'layer1'
      }
    },
    height: "100%",
    children: [jsxRuntimeExports.jsxs(Popover, {
      backgroundColor: "white",
      variant: "light",
      closeOnBlur: true,
      isOpen: activePopover === mode,
      placement: "bottom-start",
      children: [jsxRuntimeExports.jsx(PopoverTrigger, {
        children: jsxRuntimeExports.jsx(DateInput$1, {
          id: `${id}-DateInput`,
          isHighlighted: activePopover === mode,
          value: date,
          onClick: handleToggleDate
        })
      }), jsxRuntimeExports.jsx(PopoverContent, {
        hideArrow: true,
        hideCloseButton: true,
        padding: 0,
        position: "absolute",
        gutter: 8,
        top: "-8px",
        children: jsxRuntimeExports.jsx(Box, {
          sx: {
            ...reactDatePickerStyleOverrides,
            ...dateRangePickerStyleOverrides,
            ...styleOverrides
          },
          "data-testid": "DateRangePicker-popper",
          children: jsxRuntimeExports.jsx(ReactDatePicker, {
            "data-testid": "DateRangePicker-startdate",
            allowSameDay: true,
            onChange: handleDateChange,
            onClickOutside: handleClickOutside,
            selected: date,
            minDate: minDate,
            inline: true,
            // explicitly any to move on
            renderCustomHeader: props => jsxRuntimeExports.jsx(DatePickerHeader, {
              ...props
            }),
            ...pickerProps
          })
        })
      })]
    }), jsxRuntimeExports.jsx(Box, {
      flex: 1,
      sx: {
        '& .chakra-select': {
          padding: 3,
          fontWeight: 'normal'
        }
      },
      height: "100%",
      children: jsxRuntimeExports.jsx(TimePicker, {
        id: `${id}-TimePicker`,
        time: time,
        setTime: handleTimeChange,
        minimumTime: minimumTime(),
        // @ts-expect-error - TimePicker onClick prop handling
        onClick: clearActivePopover,
        onFocus: onTimePickerFocus,
        onBlur: onTimePickerBlur
      })
    })]
  });
};

const pluralize = (count, singular, plural) => {
  return count === 1 ? singular : plural;
};
const ReservationDuration = ({
  starts,
  ends
}) => {
  const duration = dayjs.duration(dayjs(ends).diff(dayjs(starts)));
  const days = duration.days() > 0 ? `${duration.format('D')} ${pluralize(duration.days(), 'day', 'days')}` : '';
  const remainingHours = duration.hours() > 0 ? `${duration.format('H')} ${pluralize(duration.hours(), 'hour', 'hours')}` : '';
  const remainingMinutes = duration.minutes() > 0 ? `${duration.format('m')} ${pluralize(duration.minutes(), 'minute', 'minutes')}` : '';
  let durationText = [days, remainingHours, remainingMinutes].filter(i => i.length).join(', ');
  // If the duration is exactly 1 day, we want to display it as 24 hours
  if (duration.days() === 1 && duration.hours() === 0 && duration.minutes() === 0) {
    durationText = '24 hours';
  }
  return jsxRuntimeExports.jsxs(Text, {
    as: "span",
    "data-testid": "DateRangePicker-ReservationDuration",
    backgroundColor: "background.gray",
    borderRadius: "md",
    paddingX: 3,
    paddingY: 2,
    children: ["Park for ", durationText]
  });
};

const createStoreImpl = createState => {
  let state;
  const listeners = /* @__PURE__ */new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach(listener => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const api = {
    setState,
    getState,
    getInitialState,
    subscribe
  };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = createState => createState ? createStoreImpl(createState) : createStoreImpl;

const identity = arg => arg;
function useStore$1(api, selector = identity) {
  const slice = React.useSyncExternalStore(api.subscribe, () => selector(api.getState()), () => selector(api.getInitialState()));
  React.useDebugValue(slice);
  return slice;
}

const getRecentPlaces = () => {
  try {
    const recentPlaces = window.localStorage.getItem('sh-recent-places');
    if (recentPlaces) {
      return JSON.parse(recentPlaces);
    } else {
      return [];
    }
  } catch (e) {
    console.error('Error reading recent places from localStorage', e);
    return [];
  }
};
const saveNewRecentPlace = newPlace => {
  const recentPlaces = getRecentPlaces();
  // Add the new place to the beginning of the list
  recentPlaces.unshift({
    ...newPlace,
    isRecentSearch: true
  });
  const dedupedObject = recentPlaces.reduce((acc, item) => {
    // Validate no two descriptions are the same (used to be place_id but didn't include airport)
    if (item.description && !acc[item.description]) {
      acc[item.description] = item;
    }
    return acc;
  }, {});
  const dedupedArray = Object.values(dedupedObject);
  // Limit to 3 recent places based on requirements
  if (dedupedArray.length > 3) {
    dedupedArray.pop();
  }
  try {
    window.localStorage.setItem('sh-recent-places', JSON.stringify(dedupedArray));
  } catch (e) {
    console.error('Error saving recent places to localStorage', e);
  }
};

const currentLocationPlaceholderSuggestion = {
  isParkingNearMe: true,
  description: 'Current Location',
  location: {
    latitude: 0,
    longitude: 0
  }
};
const awaitingHeader = {
  description: 'Type an address, place, city, airport, or event',
  isContent: true,
  isSection: true
};
const googleHeader = {
  description: 'Places',
  isContent: false,
  isSection: true
};
const eventHeader = {
  description: 'Upcoming Events',
  isContent: false,
  isSection: true
};
const airportHeader = {
  description: 'Airport Parking',
  isContent: false,
  isSection: true
};
const performerHeader = {
  description: 'Performers',
  isContent: false,
  isSection: true
};
const recentHeader = {
  description: 'Previous Searches',
  isContent: false,
  isSection: true
};
const checkArrayAndLengthExist = arr => Array.isArray(arr) && arr.length > 0;
// Takes nearby, google, and event autocomplete to combine then
const combineSuggestions = ({
  eventSuggestions = [],
  googleSuggestions = [],
  airportSuggestions = [],
  performerSuggestions = []
}) => {
  //Get recent places from local storage
  const recentPlaces = getRecentPlaces();
  //Only show recent places if there are no google suggestions, and there are airport suggestions
  const showRecentPlaces = Boolean(!checkArrayAndLengthExist(airportSuggestions) && !checkArrayAndLengthExist(googleSuggestions) && !checkArrayAndLengthExist(performerSuggestions));
  //Primary suggestions are considered googleSuggestions, eventSuggestions, airportSuggestions, and performerSuggestions
  const combinedPrimarySuggestions = [...(checkArrayAndLengthExist(airportSuggestions) ? [airportHeader, ...airportSuggestions] : []), ...(checkArrayAndLengthExist(googleSuggestions) ? [googleHeader, ...googleSuggestions] : []), ...(checkArrayAndLengthExist(performerSuggestions) ? [performerHeader] : []), ...(checkArrayAndLengthExist(performerSuggestions) ? performerSuggestions.map(perf => ({
    ...perf,
    performer: true
  })) : performerSuggestions), ...(checkArrayAndLengthExist(eventSuggestions) ? [eventHeader, ...eventSuggestions] : [])];
  const combinedSuggestions = [...(googleSuggestions !== null && googleSuggestions.length === 0 ? [awaitingHeader] : []), currentLocationPlaceholderSuggestion, ...(recentPlaces?.length && showRecentPlaces ? [recentHeader, ...recentPlaces] : [])];
  if (googleSuggestions === null) return combinedSuggestions.concat([{
    description: 'No results found'
  }]); //null comes back for no results found google - using as a circuit breaker
  return combinedSuggestions.concat(combinedPrimarySuggestions);
};

const isGoogleAutocompleteSuggestion = suggestion => suggestion?.place_id !== undefined || suggestion?.bypassForVenueUrl !== undefined || suggestion?.location !== undefined; //Allows for no place_id
const isEventSuggestion = suggestion => suggestion?.venue !== undefined;
const isPerformerSuggestion = suggestion => Boolean(suggestion?.performer);
const isAirportSuggestion = suggestion => suggestion?.iataCode !== undefined;
const isCurrentLocation = suggestion => suggestion?.isParkingNearMe !== undefined;
const isContentLabel = suggestion => suggestion?.isContent !== undefined && suggestion.isContent !== false;
const isSectionLabel = suggestion => suggestion?.isSection !== undefined && suggestion.isSection !== false;

const apiDateFormat = 'YYYY-MM-DD';
const apiDateTimeFormat = `${apiDateFormat}THH:mm`;
const expandedDesktopAutocompleteBoxStyles = {
  width: '110%',
  transition: 'width 0.2s ease-in-out'
};

/**
 * This function returns a URL object with the given params appended to the query string
 *
 * @param url - The URL to append the params to
 * @param params - The params to append to the URL
 * @param filterOutNullValues - Whether to filter out null values from the params
 * returns {URL} - The URL object with the params appended
 */
const urlWithParams = (url, params, filterOutNullValues = false) => {
  const urlObject = new URL(url);
  Object.entries(params).forEach(([key, value]) => {
    if (!filterOutNullValues || value != null) {
      urlObject.searchParams.append(key, String(value));
    }
  });
  return urlObject;
};

dayjs.extend(duration);
const roundStartTime = (datetime, timezone) => {
  const dt = dayjs().tz(timezone);
  return dt.minute() < 30 ? dt.minute(0) : dt.minute(30);
};
const getLocalTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
const getSearchWindow = timezone => {
  if (typeof timezone !== 'string') return {
    starts: '',
    ends: ''
  }; //Protection for type miss
  const starts = roundStartTime(undefined, timezone);
  const ends = dayjs(starts).add(dayjs.duration(3, 'hours'));
  return {
    starts: starts.format(apiDateTimeFormat),
    ends: ends.format(apiDateTimeFormat)
  };
};
const buildDestinationUrl = ({
  siteUrl,
  id,
  additionalParams = {}
}) => {
  const urlParams = {
    kind: 'destination',
    id,
    ...additionalParams
  };
  const searchUrl = urlWithParams(`${siteUrl}/search`, urlParams);
  return searchUrl.href;
};
const createDefaultAirportSearchWindow = timezone => ({
  starts: dayjs().tz(timezone).add(dayjs.duration(1, 'days')).set('hour', 12).set('minute', 0).set('second', 0).set('millisecond', 0).format(apiDateTimeFormat),
  ends: dayjs().tz(timezone).add(dayjs.duration(5, 'days')).set('hour', 12).set('minute', 0).set('second', 0).set('millisecond', 0).format(apiDateTimeFormat)
});
/**
 * Check if the Search-Component is being used on the Consumer-Web Search page on a desktop
 */
const isSearchOnDesktop = (eventMode, isMobile) => {
  return eventMode === 'search' && !isMobile;
};

const buildDestinationVenueUrl = ({
  eventDestinationsHash,
  place_id,
  siteUrl,
  dates = {}
}) => {
  if (place_id && eventDestinationsHash[place_id]) {
    try {
      const url = buildDestinationUrl({
        siteUrl,
        id: eventDestinationsHash[place_id]?.id,
        additionalParams: {
          ...dates
        }
      });
      return url;
    } catch {
      return undefined;
    }
  }
  return undefined;
};

// eslint-disable-next-line jsdoc/require-returns
/**
 *
 * When enter hit (13) select first suggestion
 */
const handleKeyDown = (evt, get) => {
  const eventMode = get().eventMode;
  const handleInputFocus = get().autocomplete.handleInputFocus;
  const setSuggestion = get().autocomplete.setSuggestion;
  const suggestions = get().autocomplete.suggestions();
  const currentIndex = get().autocomplete.currentIndex;
  const findParkingNearMe = get().autocomplete.findParkingNearMe;
  const setInputHasFocus = get().autocomplete.setInputHasFocus;
  const googleSuggestions = get().autocomplete.googleAutocomplete.googleSuggestions;
  const handleTrackSearchSuggestionSelected = get().autocomplete.handleTrackSearchSuggestionSelected;
  const debouncedSetInputFocusClosed = get().autocomplete.debouncedSetInputFocusClosed;
  const dateTimePickerRef = get().searchInput.dateTimePickerRef;
  const siteUrl = get().siteUrl;
  const eventDestinationsHash = get().eventDestinationsHash;
  const isMobile = get().isMobile;
  const datePopoverDisclosure = get().datePopoverDisclosure;
  const dateModalDisclosure = get().dateModalDisclosure;
  const relevantDisclosure = isMobile ? dateModalDisclosure : datePopoverDisclosure;
  const handleRelevantDisclosure = () => {
    if (eventMode !== 'search') {
      relevantDisclosure && relevantDisclosure.onOpen();
      dateTimePickerRef.current?.focus();
    }
  };
  handleInputFocus(); //Should have focus if you are in this key down
  const currentSuggestion = suggestions[currentIndex];
  if ((String(evt.key) === '13' || evt.key === 'Enter') && isCurrentLocation(currentSuggestion)) {
    findParkingNearMe();
    setInputHasFocus(false); // Not debounced to prevent delay
    handleRelevantDisclosure();
    dateTimePickerRef.current?.focus();
    return;
  }
  //if enter hit and suggestions are present
  if ((String(evt.key) === '13' || evt.key === 'Enter') && suggestions !== null && suggestions.length) {
    const isVenue = activeSuggestion => {
      if (isGoogleAutocompleteSuggestion(activeSuggestion) && eventDestinationsHash && siteUrl) {
        return buildDestinationVenueUrl({
          eventDestinationsHash,
          place_id: activeSuggestion.place_id,
          siteUrl
        });
      } else {
        return undefined;
      }
    };
    // if event pass to url
    //Minus one below to account for current location
    if (currentIndex >= 0) {
      const activeSuggestion = suggestions[currentIndex];
      handleTrackSearchSuggestionSelected(activeSuggestion);
      //Below const & if to support venue or event for enter
      const venueURl = isVenue(activeSuggestion);
      if (isEventSuggestion(activeSuggestion) || venueURl) {
        return window.location.href = venueURl || `${siteUrl}/search?kind=event&id=${activeSuggestion.id}`;
      }
      setSuggestion(activeSuggestion);
      setInputHasFocus(false); // Not debounced to prevent delay
      handleRelevantDisclosure();
      return;
    } else if (googleSuggestions !== null && googleSuggestions.length) {
      setSuggestion(googleSuggestions[0]);
      handleTrackSearchSuggestionSelected(suggestions[0]);
      handleRelevantDisclosure();
      return;
    } else {
      debouncedSetInputFocusClosed();
      return;
    }
  }
  return handleArrowKeyDown(evt.key, get); //Moved for readability
};
// Accessibility based on https://rebeccamdeprey.com/blog/building-an-accessible-autocomplete-component-with-react
const updateActiveDescendant = get => {
  const inputRef = get().autocomplete.inputRef;
  const currentIndex = get().autocomplete.currentIndex;
  const suggestions = get().autocomplete.suggestions;
  if (currentIndex >= 0 && currentIndex < Number(suggestions?.length)) {
    // Sets the aria-activedescendant attribute to the current index,
    // which represents a child in the listbox
    inputRef.current?.setAttribute('aria-activedescendant', `suggestion-${currentIndex}`);
  }
};
const updateIndex = (index, isDown = false, get) => {
  const setCurrentIndex = get().autocomplete.setCurrentIndex;
  const suggestions = get().autocomplete.suggestions();
  const activeSuggestion = suggestions[index];
  const modifier = isDown ? 1 : -1;
  if (activeSuggestion === undefined) {
    setCurrentIndex(index);
    return updateActiveDescendant(get);
  }
  //Below logic handle labels to skip them
  if (isContentLabel(activeSuggestion) || isSectionLabel(activeSuggestion)) {
    return updateIndex(index + modifier * 1, isDown, get);
  }
  setCurrentIndex(index);
  return updateActiveDescendant(get);
};
//Assumption here is the label will never be last, check recursively if the next is a label and ton select it
const handleArrowKeyDown = (key, get) => {
  const currentIndex = get().autocomplete.currentIndex;
  const suggestions = get().autocomplete.suggestions();
  // Based on the arrow key pressed, update the index of the active child
  // and then update the aria-activedescendant value
  if (key === 'ArrowDown') {
    if (currentIndex <= Number(suggestions?.length) - 2) {
      //Block if bottom
      return updateIndex(currentIndex + 1, true, get);
    }
  } else if (key === 'ArrowUp') {
    if (currentIndex > 0) {
      //Block if top
      return updateIndex(currentIndex - 1, false, get);
    }
  }
};

/**
 * Clears suggestions only
 */
const clearSuggestions = get => {
  const clearGoogleAutocomplete = get().autocomplete.googleAutocomplete.clearGoogleAutocomplete;
  const clearAirportAutocomplete = get().autocomplete.airportAutocomplete.clearAirportAutocomplete;
  clearGoogleAutocomplete();
  clearAirportAutocomplete();
};
/**
 * Clears relevant inputs and suggestions, and moves focus back
 */
const clearAll = get => {
  const setInputValue = get().autocomplete.setInputValue;
  const setSelectedSuggestion = get().autocomplete.setSelectedSuggestion;
  const setCurrentIndex = get().autocomplete.setCurrentIndex;
  const showEventSuggestions = get().showEventSuggestions();
  const inputRef = get().autocomplete.inputRef;
  const isMobile = get().isMobile;
  const mobileInputRef = get().autocomplete.mobileInputRef;
  const modalState = get().autocomplete.modalState;
  const {
    isOpen
  } = get().autocomplete.disclosure;
  const handleOnChangeForEvents = get().handleOnChangeForEvents;
  const showPerformerSuggestions = get().showPerformerSuggestions();
  const handleOnChangeForPerformers = get().handleOnChangeForPerformers;
  setInputValue('');
  clearSuggestions(get);
  setSelectedSuggestion(null);
  setCurrentIndex(-1);
  updateActiveDescendant(get);
  if (showEventSuggestions && handleOnChangeForEvents) {
    handleOnChangeForEvents('');
  }
  if (showPerformerSuggestions && handleOnChangeForPerformers) {
    handleOnChangeForPerformers('');
  }
  //isMobile, focus on mobile with modal open
  if (inputRef.current !== null && !isMobile) inputRef.current.focus(); //Not mobile focus on input
  if (isOpen && mobileInputRef.current !== null) mobileInputRef.current.focus(); // mobile and modal open focus on mobile input
  if (!isOpen && mobileInputRef.current === null) modalState.onOpen(); //open the modal for mobile users
};
/**
 *
 * Manage the input change for any input box
 */
const handleInputChange = (evt, get) => {
  const setInputValue = get().autocomplete.setInputValue;
  const setSelectedSuggestion = get().autocomplete.setSelectedSuggestion;
  const showEventSuggestions = get().showEventSuggestions();
  const handleOnChangeForEvents = get().handleOnChangeForEvents;
  const showPerformerSuggestions = get().showPerformerSuggestions();
  const handleOnChangeForPerformers = get().handleOnChangeForPerformers;
  const setIsInputInvalid = get().autocomplete.setIsInputInvalid;
  const airports = get().airports || [];
  const getAirportAutocomplete = get().autocomplete.airportAutocomplete.getAirportAutocomplete;
  const getGoogleAutocomplete = get().autocomplete.googleAutocomplete.getGoogleAutocomplete;
  const target = evt.target;
  setIsInputInvalid(false);
  setInputValue(target.value);
  if (showEventSuggestions && handleOnChangeForEvents) {
    handleOnChangeForEvents(target.value);
  }
  if (showPerformerSuggestions && handleOnChangeForPerformers) {
    handleOnChangeForPerformers(target.value);
  }
  setSelectedSuggestion(null); //clear selected if user types in something new
  if (target.value.length >= 3) {
    //Keep in line with production for launch
    getAirportAutocomplete(target.value, airports);
    getGoogleAutocomplete(target.value); //We want debounce not length based
  } else clearSuggestions(get);
};

/**
 * on blur as long as you are clicking away from the input select the first option.  If you click a suggestion, dont do anything
 * This feels overly complicated but I'm not ssure a better approach
 */
const handleInputBlur = (evt, get, findParkingSpotsButtonPartialStore) => {
  const setSuggestion = get().autocomplete.setSuggestion;
  const googleSuggestions = get().autocomplete.googleAutocomplete.googleSuggestions;
  const handleTrackSearchSuggestionSelected = get().autocomplete.handleTrackSearchSuggestionSelected;
  const debouncedSetInputFocusClosed = get().autocomplete.debouncedSetInputFocusClosed;
  const selectedSuggestion = get().autocomplete.selectedSuggestion;
  const setCurrentIndex = get().autocomplete.setCurrentIndex;
  const onBlur = get().onBlur;
  const {
    target,
    relatedTarget
  } = evt;
  if (relatedTarget?.className?.includes('autocomplete-clear')) return;
  const hasFocusMovedToASibling = target?.className?.includes('autocomplete-clear') && relatedTarget?.className?.includes('SearchWidget-popover-date-input') || target?.id === 'input-autocomplete' && relatedTarget?.className?.includes('SearchWidget-popover-date-input') || target?.id === 'input-autocomplete' && relatedTarget?.className?.includes('chakra-select');
  if (Array.isArray(googleSuggestions) && googleSuggestions.length && !selectedSuggestion?.description && (hasFocusMovedToASibling || !relatedTarget?.className?.includes('suggestion') && !relatedTarget?.className?.includes('popover') && !relatedTarget?.className?.includes('autocomplete'))) {
    handleTrackSearchSuggestionSelected(googleSuggestions[0]);
    setSuggestion(googleSuggestions[0]);
  } else if (hasFocusMovedToASibling && onBlur) {
    onBlur(findParkingSpotsButtonPartialStore(get));
  }
  setCurrentIndex(-1);
  debouncedSetInputFocusClosed();
};
// Unsure whats going on here, typed to handle
const debouncedSetInputFocusClosed = debounce(get => {
  const setInputHasFocus = get().autocomplete.setInputHasFocus;
  setInputHasFocus(false);
}, 300);
/**
 *
 * onClick of suggestion set the input value to what I want, store it in selectedSuggestion, focus on the search button, close modal
 */
const setSuggestion = (suggestion, skipScreenChanges = false, get) => {
  const parkingSubType = get().parkingSubType;
  const eventMode = get().eventMode;
  const dateModalDisclosure = get().dateModalDisclosure;
  const setInputValue = get().autocomplete.setInputValue;
  const setSelectedSuggestion = get().autocomplete.setSelectedSuggestion;
  const modalState = get().autocomplete.modalState;
  const isMobile = get().isMobile;
  setInputValue(suggestion.description); //Update input value
  setSelectedSuggestion(suggestion); //Save suggestion
  debouncedSetInputFocusClosed(get);
  if (isMobile && !skipScreenChanges) modalState.onClose();
  // Open the Date/Time picker modal after a user selects a suggestion
  // Skip Hourly Search as we show the date-picker along with location input
  if (isMobile && !(eventMode === 'search' && parkingSubType === 'hourly')) {
    dateModalDisclosure?.onOpen();
  }
};
const findParkingNearMe = get => {
  const setIsInputInvalid = get().autocomplete.setIsInputInvalid; // could just be set
  const handleTrackSearchSuggestionSelected = get().autocomplete.handleTrackSearchSuggestionSelected;
  const setSearchType = get().searchInput.setSearchType;
  const setIsLoading = get().searchInput.setIsLoading;
  const trackFindParkingNearMeClicked = get().trackFindParkingNearMeClicked;
  const setIsError = get().searchInput.setIsError;
  const isLoading = get().searchInput.isLoading;
  const setSuggestion = get().autocomplete.setSuggestion;
  setIsInputInvalid(false);
  // Ignore event if already searching
  if (isLoading) return;
  setSearchType('find-parking-near-me');
  setIsLoading(true);
  if (trackFindParkingNearMeClicked) trackFindParkingNearMeClicked();
  setSuggestion(currentLocationPlaceholderSuggestion);
  window.navigator.geolocation.getCurrentPosition(({
    coords
  }) => {
    const selection = {
      isParkingNearMe: true,
      description: 'Current Location',
      location: {
        latitude: coords.latitude,
        longitude: coords.longitude
      }
    };
    setSuggestion(selection, true);
    setIsLoading(false);
    handleTrackSearchSuggestionSelected(selection, true);
  }, err => {
    console.error('Error getting user location', err);
    clearAll(get);
    setIsError(true);
    setIsLoading(false);
    handleTrackSearchSuggestionSelected({
      description: 'Current Location'
    }, true);
  });
};

/**
 * Below is needed to support trackSearchSuggestionSelected
 */
const convertParkingType$1 = parkingType => parkingType === 'hourly' ? 'transient' : parkingType;

const _getSuggestionSpecificInfo = suggestion => {
  if (isGoogleAutocompleteSuggestion(suggestion)) return {
    description: suggestion.description,
    place_id: suggestion.place_id
  };else if (isEventSuggestion(suggestion)) return {
    description: suggestion.label,
    eventId: suggestion.id
  };else if (isPerformerSuggestion(suggestion)) return {
    description: suggestion.name
  };else if (isAirportSuggestion(suggestion)) return {
    description: suggestion.description
  };else if (isCurrentLocation(suggestion)) return {
    description: 'Current Location'
  };else return {
    description: 'Suggestion Not Found'
  };
};
const handleTrackSearchSuggestionSelected = (suggestion, get, useCurrentLocation, partialStore) => {
  const trackSearchSuggestionSelected = get().trackSearchSuggestionSelected;
  const parkingSubType = get().parkingSubType;
  const parkingType = get().parkingType;
  const inputValue = get().autocomplete.inputValue;
  if (trackSearchSuggestionSelected) {
    const specificSuggestion = _getSuggestionSpecificInfo(suggestion);
    trackSearchSuggestionSelected({
      userRawText: inputValue,
      parkingType: convertParkingType$1(parkingType),
      powerBooking: parkingSubType === 'power_booking',
      useCurrentLocation: useCurrentLocation,
      ...(useCurrentLocation ? suggestion : {}),
      ...specificSuggestion,
      ...(specificSuggestion?.place_id ? {
        placeId: specificSuggestion.place_id
      } : {})
    }, partialStore);
  }
};

const handleMobileOpen = get => {
  const mobileInputRef = get().autocomplete.mobileInputRef;
  const {
    onOpen
  } = get().autocomplete.disclosure;
  onOpen();
  if (mobileInputRef.current) {
    mobileInputRef.current.focus();
  }
};
const handleModalClose = get => {
  const googleSuggestions = get().autocomplete.googleAutocomplete.googleSuggestions;
  const {
    onClose
  } = get().autocomplete.disclosure;
  const selectedSuggestion = get().autocomplete.selectedSuggestion;
  const setSuggestion = get().autocomplete.setSuggestion;
  const setCurrentIndex = get().autocomplete.setCurrentIndex;
  const handleTrackSearchSuggestionSelected = get().autocomplete.handleTrackSearchSuggestionSelected;
  if (Array.isArray(googleSuggestions) && googleSuggestions.length && !selectedSuggestion?.description) {
    handleTrackSearchSuggestionSelected(googleSuggestions[0]);
    setSuggestion(googleSuggestions[0]);
  }
  setCurrentIndex(-1);
  onClose();
};

const findParkingSpotsButtonPartialStore = get => {
  const parkingType = get().parkingType;
  const parkingSubType = get().parkingSubType;
  const timezone = get().timezone;
  const dates = get().dates;
  const startTime = get().startTime;
  const endTime = get().endTime;
  const errorType = get().errorType;
  const startDate = get().startDate;
  const endDate = get().endDate;
  const monthlyStartDate = get().monthlyStartDate;
  const locationId = get().locationId;
  const locationKind = get().locationKind;
  const searchButtonRef = get().searchInput.searchButtonRef;
  const events = get().events;
  const defaultSuggestion = get().autocomplete.defaultSuggestion;
  const selectedSuggestion = get().autocomplete.selectedSuggestion;
  const setIsInputInvalid = get().autocomplete.setIsInputInvalid;
  return {
    parkingType,
    parkingSubType,
    timezone,
    dates,
    startTime,
    endTime,
    errorType: errorType(),
    startDate,
    endDate,
    monthlyStartDate,
    locationId,
    locationKind,
    searchButtonRef,
    events,
    defaultSuggestion,
    selectedSuggestion,
    setIsInputInvalid
  };
};

const createSearchAutocompleteSlice = (set, get, initialProps) => ({
  getAutocomplete: () => console.log('set to getGoogleAutocomplete from hook'),
  clearSuggestions: () => clearSuggestions(get),
  inputValue: initialProps?.defaultSuggestion?.description || '',
  setInputValue: inputValue => set({
    autocomplete: {
      ...get().autocomplete,
      inputValue
    }
  }),
  handleInputChange: evt => handleInputChange(evt, get),
  setSuggestion: (suggestion, skipScreenChanges) => setSuggestion(suggestion, skipScreenChanges, get),
  clearAll: () => clearAll(get),
  inputRef: {
    current: null
  },
  mobileInputRef: {
    current: null
  },
  handleKeyDown: evt => handleKeyDown(evt, get),
  modalState: {
    onOpen: () => handleMobileOpen(get),
    onClose: () => handleModalClose(get)
  },
  disclosure: {
    onOpen: () => {},
    onClose: () => {},
    isOpen: false
  },
  selectedSuggestion: initialProps?.defaultSuggestion || null,
  defaultSuggestion: initialProps?.defaultSuggestion,
  setSelectedSuggestion: selectedSuggestion => set({
    autocomplete: {
      ...get().autocomplete,
      selectedSuggestion
    }
  }),
  isInputInvalid: false,
  setIsInputInvalid: isInputInvalid => set({
    autocomplete: {
      ...get().autocomplete,
      isInputInvalid
    }
  }),
  handleInputBlur: evt => handleInputBlur(evt, get, findParkingSpotsButtonPartialStore),
  currentIndex: -1,
  findParkingNearMe: () => findParkingNearMe(get),
  handleInputFocus: () => set({
    autocomplete: {
      ...get().autocomplete,
      inputHasFocus: true
    }
  }),
  inputHasFocus: false,
  setCurrentIndex: currentIndex => set({
    autocomplete: {
      ...get().autocomplete,
      currentIndex
    }
  }),
  setInputHasFocus: inputHasFocus => set({
    autocomplete: {
      ...get().autocomplete,
      inputHasFocus
    }
  }),
  googleSuggestions: null,
  handleTrackSearchSuggestionSelected: (suggestion, useCurrentLocation) => {
    const partialStore = findParkingSpotsButtonPartialStore(get);
    return handleTrackSearchSuggestionSelected(suggestion, get, useCurrentLocation, partialStore);
  },
  debouncedSetInputFocusClosed: () => debouncedSetInputFocusClosed(get),
  isMobile: false,
  //Duplicate keys, to cleanup later
  allSuggestions: () => combineSuggestions({
    eventSuggestions: get().showEventSuggestions() ? get().searchEvents : [],
    googleSuggestions: get().autocomplete.googleAutocomplete.googleSuggestions,
    airportSuggestions: get().autocomplete.airportAutocomplete.airportSuggestions,
    performerSuggestions: get().showPerformerSuggestions() ? get().searchPerformers : []
  }),
  suggestions: () => combineSuggestions({
    eventSuggestions: get().showEventSuggestions() ? get().searchEvents : [],
    googleSuggestions: get().autocomplete.googleAutocomplete.googleSuggestions,
    airportSuggestions: get().autocomplete.airportAutocomplete.airportSuggestions,
    performerSuggestions: get().showPerformerSuggestions() ? get().searchPerformers : []
  }),
  airportAutocomplete: {
    airportSuggestions: [],
    clearAirportAutocomplete: () => {},
    getAirportAutocomplete: () => {}
  },
  //Any used below as I'm confused
  setAirportAutocomplete: props => {
    set({
      autocomplete: {
        ...get().autocomplete,
        airportAutocomplete: {
          getAirportAutocomplete: get().autocomplete.airportAutocomplete.getAirportAutocomplete,
          clearAirportAutocomplete: get().autocomplete.airportAutocomplete.clearAirportAutocomplete,
          airportSuggestions: get().autocomplete.airportAutocomplete.airportSuggestions,
          ...props
        }
      }
    });
  },
  googleAutocomplete: {
    googleSuggestions: [],
    clearGoogleAutocomplete: () => {},
    getGoogleAutocomplete: () => {}
  },
  //Any used below as I'm confused
  setGoogleAutocomplete: props => {
    set({
      autocomplete: {
        ...get().autocomplete,
        googleAutocomplete: {
          getGoogleAutocomplete: get().autocomplete.googleAutocomplete.getGoogleAutocomplete,
          clearGoogleAutocomplete: get().autocomplete.googleAutocomplete.clearGoogleAutocomplete,
          googleSuggestions: get().autocomplete.googleAutocomplete.googleSuggestions,
          ...props
        }
      }
    });
  },
  setDisclosure: disclosure => set({
    autocomplete: {
      ...get().autocomplete,
      disclosure
    }
  })
});

const createSearchInputSlice = (set, get) => ({
  searchType: '',
  setSearchType: searchType => set({
    searchInput: {
      ...get().searchInput,
      searchType
    }
  }),
  isLoading: false,
  setIsLoading: isLoading => set({
    searchInput: {
      ...get().searchInput,
      isLoading
    }
  }),
  isError: false,
  setIsError: isError => set({
    searchInput: {
      ...get().searchInput,
      isError
    }
  }),
  searchButtonRef: createRef(),
  dateTimePickerRef: createRef(),
  setDatePickerRef: ref => get().searchInput.dateTimePickerRef.current = ref
});

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop$2 = () => {};
const MistakenJSX = () => {
  return jsxRuntimeExports.jsx("div", {
    children: "this should be declared"
  });
};
const POWER_BOOKING_SOURCE = {
  monthly: 'monthly_midfunnel',
  transient: 'transient_midfunnel',
  monthly_homepage: 'monthly_homepage',
  transient_homepage: 'transient_homepage'
};
//Below function from src/common/components/search-widget/SearchWidget.tsx
const isEventTabActive = (events = []) => {
  const MIN_EVENT_COUNT = 5;
  const MIN_EVENT_START_DAYS = 7;
  const eventCount = events.length;
  const isEventStartingSoon = events.some(event => dayjs(event.starts).diff(dayjs(), 'days') < MIN_EVENT_START_DAYS);
  //TODO implement at a later date if needed
  // Prismic override: allow marketing team to override tab selection logic
  // if (Boolean(defaultTabOverride) && defaultTabOverride !== 'Event')
  //     return false;
  return eventCount >= MIN_EVENT_COUNT || isEventStartingSoon;
};
const createCommonSlice = (set, get, initialProps) => {
  const setBookingType = bookingType => {
    set({
      bookingType
    });
  };
  const setParkingType = parkingType => {
    let parkingSubType = 'hourly';
    if (parkingType === 'monthly') {
      parkingSubType = 'monthly';
    } else if (parkingType === 'airport') {
      parkingSubType = 'airport';
    } else if (parkingType === 'event') {
      parkingSubType = 'event';
    }
    const previousTab = get().parkingType;
    set({
      parkingType,
      parkingSubType
    });
    const trackSwitchedVerticalTabs = get().trackSwitchedVerticalTabs;
    if (trackSwitchedVerticalTabs) {
      trackSwitchedVerticalTabs({
        previousTab,
        selectedTab: parkingType
      });
    }
  };
  const setParkingSubType = parkingSubType => {
    const props = {
      newParkingSubType: parkingSubType,
      prevParkingSubType: get().parkingSubType,
      parkingType: get().parkingType
    };
    set({
      parkingSubType
    });
    const trackPowerBookingOpened = get().trackPowerBookingOpened;
    if (parkingSubType !== props.prevParkingSubType && parkingSubType === 'power_booking' && trackPowerBookingOpened) {
      trackPowerBookingOpened({
        source: get().parkingType === 'monthly' ? POWER_BOOKING_SOURCE.monthly_homepage : POWER_BOOKING_SOURCE.transient_homepage
      });
    }
    if (initialProps?.onParkingSubTypeChange) {
      initialProps.onParkingSubTypeChange(props);
    }
  };
  const setHasUserInteractedWithWidget = hasUserInteracted => {
    set({
      hasUserInteractedWithWidget: hasUserInteracted
    });
  };
  const setAirports = airports => {
    set({
      airports
    });
  };
  const events = get()?.events || initialProps?.events;
  const showEvents = isEventTabActive(events);
  //Note below logic considers monthly first, then events for SEO mode
  let defaultParkingType = initialProps?.parkingType === 'monthly' ? 'monthly' : showEvents ? 'event' : initialProps?.parkingType || 'hourly';
  // Search mode
  if (initialProps?.eventMode === 'search') {
    defaultParkingType = initialProps?.parkingType || 'hourly';
  }
  return {
    parkingType: defaultParkingType,
    parkingSubType: initialProps?.parkingSubType || 'hourly',
    bookingType: initialProps?.bookingType || 'single',
    setBookingType: initialProps?.setBookingType || setBookingType,
    setParkingType: initialProps?.setParkingType || setParkingType,
    setParkingSubType: initialProps?.setParkingSubType || setParkingSubType,
    hasUserInteractedWithWidget: false,
    setHasUserInteractedWithWidget,
    airports: initialProps?.airports || [],
    setAirports: setAirports,
    eventDestinationsHash: initialProps?.eventDestinationsHash || {},
    locationBias: initialProps?.locationBias || {
      latitude: 41.8839288418,
      longitude: -87.6309569143,
      country: 'us'
    },
    timezone: initialProps?.timezone || getLocalTimezone(),
    locationId: initialProps?.locationId,
    locationKind: initialProps?.locationKind,
    events: initialProps?.events || [],
    trackEventListItemSelected: initialProps?.trackEventListItemSelected || noop$2,
    trackSearchSuggestionSelected: initialProps?.trackSearchSuggestionSelected || noop$2,
    trackDateEntered: initialProps?.trackDateEntered || noop$2,
    trackErrorMessageDisplayed: initialProps?.trackErrorMessageDisplayed || noop$2,
    trackFindParkingNearMeClicked: initialProps?.trackFindParkingNearMeClicked || noop$2,
    trackPowerBookingOpened: initialProps?.trackPowerBookingOpened || noop$2,
    trackSwitchedVerticalTabs: initialProps?.trackSwitchedVerticalTabs || noop$2,
    PoweredByGoogle: initialProps?.PoweredByGoogle || jsxRuntimeExports.jsx(MistakenJSX, {}),
    FindParkingSpotsButton: initialProps?.FindParkingSpotsButton,
    googleMapsLibraries: initialProps?.googleMapsLibraries,
    searchEvents: initialProps?.searchEvents || [],
    handleOnChangeForEvents: initialProps?.handleOnChangeForEvents || noop$2,
    isMobile: initialProps?.isMobile || false,
    siteUrl: initialProps?.siteUrl || '',
    showEventSuggestions: () => get().parkingType !== 'monthly',
    dateTimePickerButtonLabel: initialProps?.dateTimePickerButtonLabel,
    searchPerformers: initialProps?.searchPerformers || [],
    showPerformerSuggestions: () => get().parkingType !== 'monthly',
    handleOnChangeForPerformers: initialProps?.handleOnChangeForPerformers || noop$2,
    useNewGooglePlacesApi: initialProps?.useNewGooglePlacesApi || false,
    eventPanel: {
      searchOnClick: initialProps?.eventPanel?.searchOnClick || noop$2
    },
    eventMode: initialProps?.eventMode || 'seo',
    dateTimeTooltipText: initialProps?.dateTimeTooltipText,
    onDateTimeTooltipClose: initialProps?.onDateTimeTooltipClose,
    onBlur: initialProps?.onBlur,
    onParkingChange: initialProps?.onParkingChange,
    variation: initialProps?.variation,
    isAdmin: initialProps?.isAdmin || false
  };
};

const createDateTimePickerSlice = (set, get, initProps) => {
  return {
    startDate: initProps?.startDate,
    endDate: initProps?.endDate,
    // Tracks if any of Date Range picker Dates or Times are active
    isDateRangeActive: false,
    minimumStartTime: () => {
      const timezone = get().timezone;
      const startDate = get().startDate;
      const isAdmin = get().isAdmin;
      const now = dayjs().tz(timezone).set('second', 0).set('millisecond', 0);
      const starts = dayjs(startDate).tz(timezone);
      if (isAdmin) {
        return HALF_HOUR_TIME_VALUES[0];
      }
      if (now.isSame(starts, 'date')) {
        const time = now.get('minute') < 30 ? now.set('minute', 0) : now.set('minute', 30);
        // shift back 30 minutes for the TimePicker minimumTime property
        return time.subtract(30, 'minute').format(TIME_API);
      } else {
        return HALF_HOUR_TIME_VALUES[0];
      }
    },
    minimumEndTime: () => {
      const timezone = get().timezone;
      const startDate = get().startDate;
      const endDate = get().endDate;
      const startDateObj = dayjs(startDate).tz(timezone);
      const endDateObj = dayjs(endDate).tz(timezone);
      const startTime = startDateObj.format(TIME_API);
      if (startDateObj.isSame(endDateObj, 'date')) {
        const startTimeIndex = HALF_HOUR_TIME_VALUES.findIndex(timeVal => timeVal === startTime);
        return HALF_HOUR_TIME_VALUES[startTimeIndex];
      } else {
        return HALF_HOUR_TIME_VALUES[0];
      }
    },
    syncDatePicker: false,
    setStartDate: startDate => {
      set({
        startDate
      });
    },
    setEndDate: endDate => {
      set({
        endDate
      });
    },
    setTimezone: timezone => {
      set({
        timezone
      });
    },
    setSyncDatePicker: syncDatePicker => {
      set({
        syncDatePicker
      });
    },
    setIsDateRangeActive: isDateRangeActive => {
      set({
        isDateRangeActive
      });
    },
    setDateDisclosures: ({
      datePopoverDisclosure,
      dateModalDisclosure
    }) => {
      set({
        datePopoverDisclosure,
        dateModalDisclosure
      });
    }
  };
};

const createMonthlyDateTimePickerSlice = (set, get, initProps) => {
  const originalMonthlyStartDate = dayjs().startOf('day').toDate();
  const setMonthlyStartDate = monthlyStartDate => set({
    monthlyStartDate
  });
  return {
    originalMonthlyStartDate,
    monthlyStartDate: initProps?.monthlyStartDate || originalMonthlyStartDate,
    setMonthlyStartDate: initProps?.setMonthlyStartDate || setMonthlyStartDate
  };
};

var ErrorType;
(function (ErrorType) {
  ErrorType["MISSING_DATES"] = "MISSING_DATES";
  ErrorType["MISSING_TIMES"] = "MISSING_TIMES";
})(ErrorType || (ErrorType = {}));
const getErrorMessage = errorType => {
  if (errorType === null) {
    return null;
  }
  return 'Select dates & times';
};
const getErrorAction = errorType => {
  switch (errorType) {
    case ErrorType.MISSING_DATES:
      return 'no date selected';
    case ErrorType.MISSING_TIMES:
      return 'no time selected';
    default:
      return 'no date selected';
  }
};
const createMultipleDatePickerSlice = (set, get, initProps) => {
  const setDates = dates => set({
    dates
  });
  const setStartTime = startTime => set({
    startTime
  });
  const setEndTime = endTime => set({
    endTime
  });
  const setHasUserInteracted = hasUserInteracted => set({
    hasUserInteracted
  });
  return {
    dates: initProps?.dates || [],
    startTime: initProps?.startTime,
    endTime: initProps?.endTime,
    hasUserInteracted: initProps?.hasUserInteracted || false,
    errorType: () => {
      const dates = get().dates;
      const startTime = get().startTime;
      const endTime = get().endTime;
      if (dates.length === 0) {
        return ErrorType.MISSING_DATES;
      }
      if (!startTime || !endTime) {
        return ErrorType.MISSING_TIMES;
      }
    },
    setDates: initProps?.setDates || setDates,
    setStartTime: initProps?.setStartTime || setStartTime,
    setEndTime: initProps?.setEndTime || setEndTime,
    setHasUserInteracted: initProps?.setHasUserInteracted || setHasUserInteracted
  };
};

const createSearchComponentStore = initProps => {
  return createStore((set, get, store) => {
    return {
      ...createCommonSlice(set, get, initProps),
      ...createDateTimePickerSlice(set, get, initProps),
      ...createMonthlyDateTimePickerSlice(set, get, initProps),
      ...createMultipleDatePickerSlice(set, get, initProps),
      searchInput: createSearchInputSlice(set, get),
      autocomplete: createSearchAutocompleteSlice(set, get, initProps)
    };
  });
};

const SearchComponentStoreContext = createContext(null);
const SearchComponentStoreProvider = ({
  children,
  clientRendered,
  ...initialProps
}) => {
  const storeRef = useRef(null);
  if (storeRef.current === null) {
    storeRef.current = createSearchComponentStore({
      timezone: clientRendered?.timezone,
      ...initialProps
    });
  }
  if (clientRendered) {
    const {
      handleOnChangeForEvents,
      searchEvents,
      googleMapsLibraries,
      isMobile,
      isTablet,
      timezone,
      searchPerformers,
      handleOnChangeForPerformers,
      useNewGooglePlacesApi,
      dateTimeTooltipText,
      onDateTimeTooltipClose,
      variation,
      isAdmin,
      events
    } = clientRendered;
    storeRef.current.setState({
      handleOnChangeForEvents,
      searchEvents,
      googleMapsLibraries,
      isMobile,
      isTablet,
      timezone,
      searchPerformers,
      handleOnChangeForPerformers,
      useNewGooglePlacesApi,
      dateTimeTooltipText,
      onDateTimeTooltipClose,
      variation,
      isAdmin,
      events
    });
  }
  return jsxRuntimeExports.jsx(SearchComponentStoreContext.Provider, {
    value: storeRef.current,
    children: children
  });
};
const useSearchComponentStore = () => {
  const store = useContext(SearchComponentStoreContext);
  if (!store) {
    throw new Error('useSearchComponentStore must be used within a SearchComponentStoreContext');
  }
  return store;
};
const useStore = selector => {
  const store = useSearchComponentStore();
  return useStore$1(store, selector);
};

const Label = ({
  label
}) => {
  const labelWithoutSpaces = label.replaceAll(' ', '');
  return jsxRuntimeExports.jsx(Box, {
    "data-testid": `DateRangeLabel-${labelWithoutSpaces}`,
    fontSize: "sm",
    fontWeight: "semibold",
    color: "text.secondary.light",
    marginBottom: 1,
    height: "100%",
    children: label
  });
};
const DateRangePicker$2 = ({
  startDate,
  endDate,
  minimumStartTime,
  minimumEndTime,
  setStartDate,
  setEndDate,
  timezone,
  styleOverrides = {},
  showParkingDuration = true
}) => {
  const [activePopover, setActivePopover] = useState(null);
  const setIsDateRangeActive = useStore(state => state.setIsDateRangeActive);
  const toggleStartDate = () => {
    setActivePopover('start');
  };
  const toggleEndDate = () => {
    setActivePopover('end');
  };
  const clearActivePopover = () => {
    setActivePopover(null);
  };
  const minDate = dayjs().tz(timezone).startOf('day').toDate();
  const startTime = startDate ? dayjs(startDate).tz(timezone).format(TIME_API) : '';
  const endTime = endDate ? dayjs(endDate).tz(timezone).format(TIME_API) : '';
  const handleStartTimeChange = time => {
    if (!startDate || !endDate) return;
    const newStartDate = combineDateTime(startDate, time, timezone);
    setStartDate(newStartDate.toDate());
    // When the start time is after the end time,
    // then update the end time to be 30 minutes ahead of the start time
    if (newStartDate.toDate() >= endDate) {
      setEndDate(newStartDate.add(30, 'minutes').toDate());
    }
  };
  const handleOnFocus = () => {
    setIsDateRangeActive(true);
  };
  const handleOnBlur = () => {
    setIsDateRangeActive(false);
  };
  const handleEndTimeChange = time => {
    setEndDate(combineDateTimeToDate(endDate, time, timezone));
  };
  const onChangeStart = selectedStartDate => {
    if (!selectedStartDate || !endDate || !startDate) return;
    const newStartDate = combineDateTime(selectedStartDate, startDate,
    // use the existing start date time
    timezone);
    setStartDate(newStartDate.toDate());
    // When the end date is before the start date,
    // then update the end date to be 30 minutes after the start date
    if (newStartDate.toDate() >= endDate) {
      setEndDate(newStartDate.add(30, 'minutes').toDate());
    } else {
      // Apply the 24-hour rate band https://spothero.atlassian.net/browse/DRAC-997
      const newEndTime = dayjs(newStartDate).tz(timezone).format(TIME_API);
      const newEndDate = combineDateTime(endDate, newEndTime, timezone).toDate();
      setEndDate(newEndDate);
    }
    clearActivePopover();
  };
  const onChangeEnd = selectedEndDate => {
    if (!selectedEndDate || !endDate || !startDate) return;
    const areStartAndNewEndOnSameDay = dayjs(selectedEndDate).tz(timezone).isSame(dayjs(startDate).tz(timezone), 'day');
    const startDateDayJs = dayjs(startDate).tz(timezone);
    // When the end date is on the same day as the start date,
    // then make end time 30 minutes after start time
    const newEndTime = areStartAndNewEndOnSameDay ? startDateDayJs.add(30, 'minutes').format(TIME_API) : startDateDayJs.format(TIME_API);
    setEndDate(combineDateTimeToDate(selectedEndDate, newEndTime, timezone));
    clearActivePopover();
  };
  return jsxRuntimeExports.jsxs(Flex, {
    flexDirection: "column",
    gap: 4,
    "data-testid": "DateRangePicker-popper",
    children: [jsxRuntimeExports.jsxs(Box, {
      children: [jsxRuntimeExports.jsx(Label, {
        label: "Start Time"
      }), jsxRuntimeExports.jsx(DatePicker, {
        id: "DateRange-StartDatePicker",
        mode: "start",
        activePopover: activePopover,
        date: startDate,
        toggleDate: toggleStartDate,
        onChange: onChangeStart,
        minDate: minDate,
        time: startTime,
        handleTimeChange: handleStartTimeChange,
        clearActivePopover: clearActivePopover,
        minimumTime: minimumStartTime,
        styleOverrides: styleOverrides,
        pickerProps: {
          selectsStart: true,
          startDate,
          endDate,
          id: 'DateRange-StartDatePicker'
        },
        onDatePickerFocus: handleOnFocus,
        onDatePickerBlur: handleOnBlur,
        onTimePickerFocus: handleOnFocus,
        onTimePickerBlur: handleOnBlur
      })]
    }), jsxRuntimeExports.jsxs(Box, {
      children: [jsxRuntimeExports.jsx(Label, {
        label: "End Time"
      }), jsxRuntimeExports.jsx(DatePicker, {
        id: "DateRange-EndDatePicker",
        mode: "end",
        activePopover: activePopover,
        date: endDate,
        toggleDate: toggleEndDate,
        onChange: onChangeEnd,
        minDate: startDate ?? minDate,
        time: endTime,
        handleTimeChange: handleEndTimeChange,
        clearActivePopover: clearActivePopover,
        minimumTime: minimumEndTime,
        styleOverrides: styleOverrides,
        pickerProps: {
          selectsEnd: true,
          startDate,
          endDate,
          id: 'DateRange-EndDatePicker'
        },
        onDatePickerFocus: handleOnFocus,
        onDatePickerBlur: handleOnBlur,
        onTimePickerFocus: handleOnFocus,
        onTimePickerBlur: handleOnBlur
      })]
    }), showParkingDuration && jsxRuntimeExports.jsx(ReservationDuration, {
      starts: startDate,
      ends: endDate
    })]
  });
};

const useShowLoader = (defaultValue = false) => {
  const [isLoaderShowing, setIsLoaderShowing] = useState(defaultValue);
  useEffect(() => {
    // Handle both pageshow and popstate events
    const handleNavigation = () => {
      setIsLoaderShowing(false);
    };
    window.addEventListener('pageshow', handleNavigation);
    window.addEventListener('popstate', handleNavigation);
    return () => {
      window.removeEventListener('pageshow', handleNavigation);
      window.removeEventListener('popstate', handleNavigation);
    };
  }, []);
  // Reset loader state when route changes
  useEffect(() => {
    return () => setIsLoaderShowing(false);
  }, []);
  return {
    isLoaderShowing,
    setIsLoaderShowing
  };
};

const toggleButtonStyles = {
  fontSize: 'sm',
  lineHeight: 6,
  paddingX: '30px',
  flex: '1 1 0px'
};

const useIsDesktopRefreshedVariation = () => {
  const variation = useStore(state => state.variation);
  const parkingSubType = useStore(state => state.parkingSubType);
  const isHourlyOrEventOrAirportParkingSubType = parkingSubType === 'hourly' || parkingSubType === 'event' || parkingSubType === 'airport';
  return variation === VARIATION_DESKTOP_REFRESHED && isHourlyOrEventOrAirportParkingSubType;
};

const HourlyToggleButton = ({
  isPowerBookingDisabled = false
}) => {
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const setParkingSubType = useStore(state => state.setParkingSubType);
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  const refreshedStyles = isDesktopRefreshedVariation ? {
    borderRadius: '8px'
  } : {};
  return jsxRuntimeExports.jsxs(ToggleButtonGroup, {
    value: parkingSubType,
    onChange: setParkingSubType,
    groupProps: {
      width: '100%'
    },
    buttonGroupStyles: refreshedStyles,
    childrenStyles: refreshedStyles,
    children: [jsxRuntimeExports.jsx(Button, {
      "aria-label": "Switch to single booking parking search",
      "data-testid": `ToggleButton-${parkingType}`,
      value: parkingType,
      width: "50%",
      ...toggleButtonStyles,
      children: "Single booking"
    }, parkingType), jsxRuntimeExports.jsx(Button, {
      "aria-label": "Switch to multiple bookings parking search",
      "data-testid": "ToggleButton-power_booking",
      value: "power_booking",
      width: "50%",
      ...toggleButtonStyles,
      isDisabled: isPowerBookingDisabled,
      children: "Multiple bookings"
    }, "power_booking")]
  }, parkingSubType);
};

const ToggleButton = ({
  isPowerBookingDisabled = false
}) => {
  const parkingSubType = useStore(state => state.parkingSubType);
  const setParkingSubType = useStore(state => state.setParkingSubType);
  return jsxRuntimeExports.jsxs(ToggleButtonGroup, {
    value: parkingSubType,
    onChange: setParkingSubType,
    groupProps: {
      width: '100%'
    },
    children: [jsxRuntimeExports.jsx(Button, {
      "aria-label": "Switch to monthly parking search",
      "data-testid": "ToggleButton-monthly",
      value: "monthly",
      width: "50%",
      ...toggleButtonStyles,
      children: "Full month"
    }, "monthly"), jsxRuntimeExports.jsx(Button, {
      "aria-label": "Switch to multiple days parking search",
      "data-testid": "ToggleButton-power_booking",
      value: "power_booking",
      width: "50%",
      ...toggleButtonStyles,
      isDisabled: isPowerBookingDisabled,
      children: "Multiple days"
    }, "power_booking")]
  });
};

const MonthlyDatePicker = () => {
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  const setMonthlyStartDate = useStore(state => state.setMonthlyStartDate);
  const eventMode = useStore(state => state.eventMode);
  const isMobile = useStore(state => state.isMobile);
  const isTextHidden = isMobile && eventMode === 'search';
  return jsxRuntimeExports.jsxs(Box, {
    "data-testid": "MonthlyDatePicker",
    children: [isTextHidden ? null : jsxRuntimeExports.jsx(Text, {
      variant: "caption",
      paddingY: 2,
      color: "gray.600",
      "data-testid": "DateRangePicker-text",
      children: "Select a start date for your monthly reservation"
    }), jsxRuntimeExports.jsx(Box, {
      minHeight: "10rem",
      backgroundColor: "white",
      children: jsxRuntimeExports.jsx(SingleDatePicker, {
        date: monthlyStartDate,
        setDate: setMonthlyStartDate
      })
    })]
  });
};

const useMobileMaxHeight = (pixels = 620) => {
  const [isMatch] = useMediaQuery(`(max-height: ${pixels}px)`);
  return isMatch;
};

const MultipleDatesPicker = () => {
  const isSmallMobile = useMobileMaxHeight();
  const parkingType = useStore(state => state.parkingType);
  const dates = useStore(state => state.dates);
  const setDates = useStore(state => state.setDates);
  const eventMode = useStore(state => state.eventMode);
  const label = parkingType === 'hourly' ? 'Multiple Bookings' : 'Multiple Days';
  const isMobile = useStore(state => state.isMobile);
  const isTextHidden = isMobile && eventMode === 'search';
  return jsxRuntimeExports.jsxs(Box, {
    "data-testid": "MultipleDatesPicker",
    children: [isTextHidden ? null : jsxRuntimeExports.jsxs(Text, {
      variant: "caption",
      paddingY: 2,
      color: "gray.600",
      display: isSmallMobile ? 'none' : 'block',
      "data-testid": "DateRangePicker-text",
      children: ["Come here often? Use ", label, " to make more than one reservation at the same spot"]
    }), jsxRuntimeExports.jsx(Box, {
      minHeight: "10rem",
      backgroundColor: "white",
      marginTop: isSmallMobile ? 1 : 0,
      children: jsxRuntimeExports.jsx(MultipleDatesPicker$1, {
        dates: dates,
        setDates: setDates
      })
    })]
  });
};

const DateRangePicker$1 = () => {
  const startDate = useStore(state => state.startDate);
  const endDate = useStore(state => state.endDate);
  const setStartDate = useStore(state => state.setStartDate);
  const setEndDate = useStore(state => state.setEndDate);
  const timezone = useStore(state => state.timezone);
  const syncDatePicker = useStore(state => state.syncDatePicker);
  const isSmallMobile = useMobileMaxHeight();
  return jsxRuntimeExports.jsxs(Box, {
    "data-testid": "DateRangePicker",
    children: [jsxRuntimeExports.jsx(Text, {
      variant: "caption",
      paddingY: {
        base: 1,
        mobileXL: 2
      },
      color: "gray.600",
      display: isSmallMobile ? 'none' : 'block',
      "data-testid": "DateRangePicker-text",
      children: "Select a single date or a range of several days\u2013 however long you need a spot!"
    }), jsxRuntimeExports.jsx(Box, {
      minHeight: "10rem",
      backgroundColor: "white",
      marginTop: isSmallMobile ? 1 : 0,
      children: startDate && endDate && jsxRuntimeExports.jsx(DateRangePicker$3, {
        startDate: startDate,
        endDate: endDate,
        setEndDate: setEndDate,
        setStartDate: setStartDate,
        timezone: timezone
      }, syncDatePicker ? 'key-sync' : 'key-no-sync')
    })]
  });
};

const DateRangePicker = () => {
  const startDate = useStore(state => state.startDate);
  const endDate = useStore(state => state.endDate);
  const minimumStartTime = useStore(state => state.minimumStartTime);
  const minimumEndTime = useStore(state => state.minimumEndTime);
  const setStartDate = useStore(state => state.setStartDate);
  const setEndDate = useStore(state => state.setEndDate);
  const timezone = useStore(state => state.timezone);
  const syncDatePicker = useStore(state => state.syncDatePicker);
  const isSmallMobile = useMobileMaxHeight();
  const eventMode = useStore(state => state.eventMode);
  const parkingType = useStore(state => state.parkingType);
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  return jsxRuntimeExports.jsx(Box, {
    "data-testid": "DateRangePicker",
    children: jsxRuntimeExports.jsx(Box, {
      minHeight: "10rem",
      backgroundColor: "white",
      marginTop: isSmallMobile ? 1 : 0,
      paddingTop: eventMode === 'search' ? 2 : 6,
      paddingBottom: eventMode === 'search' ? 0 : 4,
      children: startDate && endDate && jsxRuntimeExports.jsx(DateRangePicker$2, {
        startDate: startDate,
        endDate: endDate,
        setEndDate: setEndDate,
        setStartDate: setStartDate,
        timezone: timezone,
        minimumStartTime: minimumStartTime,
        minimumEndTime: minimumEndTime,
        showParkingDuration: !(eventMode === 'search' && parkingType === 'event') && !isDesktopRefreshedVariation // Hide duration for event search or desktop refreshed variation
      }, syncDatePicker ? 'key-sync' : 'key-no-sync')
    })
  });
};

const MultipleDatesTimePicker = () => {
  const isSmallMobile = useMobileMaxHeight();
  const parkingType = useStore(state => state.parkingType);
  const startTime = useStore(state => state.startTime);
  const endTime = useStore(state => state.endTime);
  const setStartTime = useStore(state => state.setStartTime);
  const setEndTime = useStore(state => state.setEndTime);
  const multipleDates = useStore(state => state.dates);
  const errorType = useStore(state => state.errorType);
  const hasUserInteracted = useStore(state => state.hasUserInteracted);
  const eventMode = useStore(state => state.eventMode);
  const label = parkingType === 'hourly' ? 'Multiple Bookings' : 'Multiple Days';
  const isMobile = useStore(state => state.isMobile);
  const handleStartTimeChange = time => {
    setStartTime(time);
  };
  const handleEndTimeChange = time => {
    setEndTime(time);
  };
  const multipleDatesCountText = multipleDates.length ? `${multipleDates.length} ${multipleDates.length === 1 ? 'day' : 'days'} selected` : '';
  const isErrorVisible = errorType() && hasUserInteracted;
  const isTextHidden = isMobile && eventMode === 'search';
  return jsxRuntimeExports.jsxs(Box, {
    paddingTop: {
      base: 3,
      mobileXL: 0
    },
    paddingBottom: {
      base: 2,
      mobileXL: 0
    },
    "data-testid": "MultipleDatesTimePicker",
    children: [isTextHidden ? null : jsxRuntimeExports.jsx(Text, {
      fontWeight: "semibold",
      paddingTop: {
        base: 0,
        mobileXL: 2
      },
      paddingBottom: 2,
      display: {
        base: isSmallMobile ? 'none' : 'block',
        mobileXL: 'none'
      },
      children: "Select enter and exit times"
    }), jsxRuntimeExports.jsxs(Grid, {
      templateColumns: {
        base: 'repeat(2, 1fr)',
        mobileXL: '1fr'
      },
      gap: 2,
      children: [jsxRuntimeExports.jsx(Text, {
        variant: "caption",
        fontWeight: {
          base: 'normal',
          mobileXL: 'semibold'
        },
        display: {
          base: 'none',
          mobileXL: 'block'
        },
        children: "Starting"
      }), jsxRuntimeExports.jsx(TimePicker
      //@ts-expect-error - this can be undefined
      , {
        //@ts-expect-error - this can be undefined
        time: startTime,
        setTime: handleStartTimeChange,
        maximumTime: endTime,
        label: "Enter After",
        placeholder: "Enter Time"
      }), jsxRuntimeExports.jsx(Text, {
        variant: "caption",
        fontWeight: {
          base: 'normal',
          mobileXL: 'semibold'
        },
        display: {
          base: 'none',
          mobileXL: 'block'
        },
        paddingTop: 4,
        children: "Ending"
      }), jsxRuntimeExports.jsx(TimePicker
      //@ts-expect-error - this can be undefined
      , {
        //@ts-expect-error - this can be undefined
        time: endTime,
        setTime: handleEndTimeChange,
        minimumTime: startTime,
        label: "Exit Before",
        placeholder: "Exit Time"
      })]
    }), !isMobile && jsxRuntimeExports.jsxs(Text, {
      variant: "caption",
      paddingTop: {
        base: 2,
        mobileXL: 4
      },
      color: "gray.600",
      "data-testid": "MultipleDateTimePicker-message",
      display: isSmallMobile ? 'none' : 'block',
      children: [label, ": The same enter and exit times will apply to each reservation"]
    }), !isErrorVisible && multipleDates.length ? jsxRuntimeExports.jsx(Text, {
      variant: "caption",
      "data-testid": "DatePickerHeader-selected-count-text",
      paddingTop: 4,
      display: isSmallMobile ? 'none' : 'block',
      children: multipleDatesCountText
    }) : null]
  });
};

const DateRangeTimePicker = () => {
  const isSmallMobile = useMobileMaxHeight();
  const startDate = useStore(state => state.startDate);
  const endDate = useStore(state => state.endDate);
  const setStartDate = useStore(state => state.setStartDate);
  const setEndDate = useStore(state => state.setEndDate);
  const minimumStartTime = useStore(state => state.minimumStartTime);
  const minimumEndTime = useStore(state => state.minimumEndTime);
  const timezone = useStore(state => state.timezone);
  const setSyncDatePicker = useStore(state => state.setSyncDatePicker);
  const startTime = dayjs(startDate).tz(timezone).format(TIME_API);
  const endTime = dayjs(endDate).tz(timezone).format(TIME_API);
  const handleStartTimeChange = time => {
    const newStartDate = combineDateTime(startDate, time, timezone);
    setStartDate(newStartDate.toDate());
    // when the start time is after the end time
    // then update the end time to be the 30 minutes ahead of the start time
    if (endDate instanceof Date && newStartDate.toDate() > endDate) {
      setEndDate(newStartDate.add(30, 'minutes').toDate());
    }
    // force the React-DatePicker component to re-render
    setSyncDatePicker(time === '23:30:00');
  };
  const handleEndTimeChange = time => {
    const newEndDate = combineDateTime(endDate, time, timezone);
    const newEndDateAsDate = newEndDate.toDate();
    setEndDate(newEndDateAsDate);
  };
  return jsxRuntimeExports.jsxs(Box, {
    paddingY: {
      base: 1,
      mobileXL: 4
    },
    "data-testid": "DateRangeTimePicker",
    children: [jsxRuntimeExports.jsx(Text, {
      fontWeight: "semibold",
      paddingY: 2,
      display: {
        base: isSmallMobile ? 'none' : 'block',
        mobileXL: 'none'
      },
      children: "Select enter and exit times"
    }), jsxRuntimeExports.jsxs(Grid, {
      templateColumns: {
        base: 'repeat(2, 1fr)',
        mobileXL: '1fr'
      },
      gap: 2,
      children: [jsxRuntimeExports.jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        children: [jsxRuntimeExports.jsx(Text, {
          variant: "caption",
          fontWeight: {
            base: 'normal',
            mobileXL: 'semibold'
          },
          children: "Starting"
        }), jsxRuntimeExports.jsx(Text, {
          fontSize: {
            base: 'base',
            mobileXL: 'sm'
          },
          "data-testid": "DateRangeTimePicker-start",
          children: startDate ? dayjs(startDate).tz(timezone).format(LONG_DATE_DAY_NAME_MONTH_DAY) : ''
        })]
      }), jsxRuntimeExports.jsx(TimePicker, {
        time: startTime,
        setTime: handleStartTimeChange,
        minimumTime: minimumStartTime(),
        label: "Enter After",
        "data-testid": "DateRangeTimePicker-enter"
      }), jsxRuntimeExports.jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: {
          base: 0,
          mobileXL: 4
        },
        children: [jsxRuntimeExports.jsx(Text, {
          variant: "caption",
          fontWeight: {
            base: 'normal',
            mobileXL: 'semibold'
          },
          children: "Ending"
        }), jsxRuntimeExports.jsx(Text, {
          fontSize: {
            base: 'base',
            mobileXL: 'sm'
          },
          "data-testid": "DateRangeTimePicker-end",
          children: endDate ? dayjs(endDate).tz(timezone).format(LONG_DATE_DAY_NAME_MONTH_DAY) : ''
        })]
      }), jsxRuntimeExports.jsx(TimePicker, {
        time: endTime,
        setTime: handleEndTimeChange,
        minimumTime: minimumEndTime(),
        label: "Exit Before",
        "data-testid": "DateRangeTimePicker-enter"
      })]
    })]
  });
};

const MonthlyDetails = () => {
  const isSmallMobile = useMobileMaxHeight();
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  return jsxRuntimeExports.jsxs(Flex
  // Fix width and height to prevent the popover from shifting when the date changes
  // Some days like Wednesday are longer than others like Monday
  , {
    // Fix width and height to prevent the popover from shifting when the date changes
    // Some days like Wednesday are longer than others like Monday
    width: {
      base: '100%',
      mobileXL: '160px'
    },
    height: {
      base: 'auto',
      mobileXL: '328px'
    },
    paddingTop: isSmallMobile ? 2 : 7,
    flexDirection: "column",
    justifyContent: "flex-end",
    "data-testid": "MonthlyDetails",
    children: [jsxRuntimeExports.jsx(Text, {
      variant: "caption",
      fontSize: "sm",
      fontWeight: "semibold",
      paddingY: 2,
      children: "Monthly parking"
    }), jsxRuntimeExports.jsx(Text, {
      variant: "caption",
      fontWeight: "semibold",
      children: "Starting"
    }), jsxRuntimeExports.jsx(Text, {
      fontSize: "sm",
      fontWeight: "normal",
      paddingBottom: isSmallMobile ? 2 : 5,
      children: dayjs(monthlyStartDate).format(LONG_DATE_DAY_NAME_MONTH_NAME_DAY_YEAR)
    })]
  });
};

const useFindParkingSpotsButtonPartialStore = () => {
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const timezone = useStore(state => state.timezone);
  const dates = useStore(state => state.dates);
  const startTime = useStore(state => state.startTime);
  const endTime = useStore(state => state.endTime);
  const errorType = useStore(state => state.errorType);
  const startDate = useStore(state => state.startDate);
  const endDate = useStore(state => state.endDate);
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  const locationId = useStore(state => state.locationId);
  const locationKind = useStore(state => state.locationKind);
  const searchButtonRef = useStore(state => state.searchInput.searchButtonRef);
  const events = useStore(state => state.events);
  const defaultSuggestion = useStore(state => state.autocomplete.defaultSuggestion);
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const setIsInputInvalid = useStore(state => state.autocomplete.setIsInputInvalid);
  return {
    parkingType,
    parkingSubType,
    timezone,
    dates,
    startTime,
    endTime,
    errorType: typeof errorType === 'function' ? errorType() : undefined,
    startDate,
    endDate,
    monthlyStartDate,
    locationId,
    locationKind,
    searchButtonRef,
    events,
    defaultSuggestion,
    selectedSuggestion,
    setIsInputInvalid
  };
};

const DateTimePicker = ({
  desktopSubmitButtonRef,
  onPowerBookingError,
  onClose,
  onSubmit
}) => {
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  const FindParkingSpotsButton = useStore(state => state.FindParkingSpotsButton);
  const dateTimePickerButtonLabel = useStore(state => state.dateTimePickerButtonLabel);
  const eventMode = useStore(state => state.eventMode);
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const isSmallMobile = useMobileMaxHeight();
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const isHourlyOrEventOrAirportParkingSubType = parkingSubType === 'hourly' || parkingSubType === 'event' || parkingSubType === 'airport';
  const getErrorType = useStore(state => state.errorType);
  const errorType = getErrorType();
  const isPowerBookingDisabled = isAirportSuggestion(selectedSuggestion) || parkingType === 'event';
  const setHasUserInteracted = useStore(state => state.setHasUserInteracted);
  const hasUserInteracted = useStore(state => state.hasUserInteracted);
  const FindParkingSpotsPartialStore = useFindParkingSpotsButtonPartialStore();
  const errorMessage = getErrorMessage(errorType || null);
  const handleSubmit = event => {
    setHasUserInteracted(true);
    if (parkingSubType === 'power_booking' && errorType) {
      onPowerBookingError && onPowerBookingError();
      return;
    }
    onSubmit && onSubmit();
    onClose && onClose(event);
  };
  const handleSearch = () => {
    onSubmit && onSubmit();
  };
  // Reset user interaction state when booking type changes
  useEffect(() => {
    setHasUserInteracted(false);
  }, [parkingSubType, setHasUserInteracted]);
  const showSearchButton = useMemo(() => {
    if (selectedSuggestion && parkingSubType !== 'power_booking') {
      return true;
    } else if (selectedSuggestion && parkingSubType === 'power_booking') {
      return !errorType;
    } else {
      return false;
    }
  }, [parkingSubType, errorType, selectedSuggestion]);
  const isMobile = useStore(state => state.isMobile);
  const isMobileSearch = isMobile && eventMode === 'search';
  const isMobileSeo = isMobile && eventMode === 'seo';
  const isSearchOnDesktop$1 = isSearchOnDesktop(eventMode, isMobile);
  return jsxRuntimeExports.jsxs(Box, {
    height: "100%",
    "data-testid": "DateTimePicker-wrapper",
    children: [isDesktopRefreshedVariation && jsxRuntimeExports.jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      children: jsxRuntimeExports.jsxs(Box, {
        width: "80%",
        children: [parkingType === 'hourly' && !isMobileSearch && jsxRuntimeExports.jsx(HourlyToggleButton, {
          isPowerBookingDisabled: isPowerBookingDisabled
        }), parkingType === 'monthly' && !isMobileSearch && jsxRuntimeExports.jsx(ToggleButton, {
          isPowerBookingDisabled: isPowerBookingDisabled
        })]
      })
    }), jsxRuntimeExports.jsxs(Flex, {
      flexDirection: {
        base: 'column',
        mobileXL: isDesktopRefreshedVariation ? 'column' : 'row'
      },
      "data-testid": "DateTimePicker",
      justifyContent: "space-between",
      height: "100%",
      children: [jsxRuntimeExports.jsxs(Box, {
        paddingRight: {
          base: 0,
          mobileXL: isDesktopRefreshedVariation ? 0 : 4
        },
        flex: {
          base: 0,
          mobileXL: 2
        },
        minWidth: {
          base: 'auto',
          mobileXL: '329px'
        },
        marginY: isDesktopRefreshedVariation && isSearchOnDesktop$1 && isHourlyOrEventOrAirportParkingSubType && 4,
        children: [!isDesktopRefreshedVariation && parkingType === 'hourly' && !isMobileSearch && jsxRuntimeExports.jsx(HourlyToggleButton, {
          isPowerBookingDisabled: isPowerBookingDisabled
        }), !isDesktopRefreshedVariation && parkingType === 'monthly' && !isMobileSearch && jsxRuntimeExports.jsx(ToggleButton, {
          isPowerBookingDisabled: isPowerBookingDisabled
        }), isHourlyOrEventOrAirportParkingSubType && (isDesktopRefreshedVariation || isMobile ? jsxRuntimeExports.jsx(DateRangePicker, {}) : jsxRuntimeExports.jsx(DateRangePicker$1, {})), parkingSubType === 'power_booking' && jsxRuntimeExports.jsx(MultipleDatesPicker, {}), parkingSubType === 'monthly' && jsxRuntimeExports.jsx(MonthlyDatePicker, {})]
      }), jsxRuntimeExports.jsxs(Flex, {
        flex: 1,
        flexDirection: "column",
        justifyContent: {
          base: isMobileSearch ? 'space-between' : isDesktopRefreshedVariation ? 'flex-start' : 'flex-end',
          mobileXL: 'flex-end'
        },
        alignItems: isDesktopRefreshedVariation && 'center',
        minWidth: {
          base: 'auto',
          mobileXL: '164px'
        },
        backgroundColor: {
          base: 'white',
          mobileXL: isDesktopRefreshedVariation ? 'white' : 'gray.50'
        },
        marginLeft: isDesktopRefreshedVariation ? -4 : 0,
        marginRight: {
          base: 0,
          mobileXL: -4
        },
        marginTop: {
          base: 0,
          mobileXL: -4
        },
        marginBottom: {
          base: 0,
          mobileXL: -4
        },
        padding: {
          base: 0,
          mobileXL: 4
        },
        children: [!isDesktopRefreshedVariation && isHourlyOrEventOrAirportParkingSubType && !isMobile && jsxRuntimeExports.jsx(DateRangeTimePicker, {}), parkingSubType === 'power_booking' && jsxRuntimeExports.jsx(MultipleDatesTimePicker, {}), parkingSubType === 'monthly' && jsxRuntimeExports.jsx(MonthlyDetails, {}), hasUserInteracted && errorMessage && parkingSubType === 'power_booking' ? jsxRuntimeExports.jsx(Alert, {
          status: "error",
          description: errorMessage,
          showIcon: false,
          "data-testid": "DateTimePicker-powerbookingError",
          sx: {
            '&.chakra-alert': {
              paddingX: 2,
              marginTop: isSmallMobile ? 0 : 2
            },
            '& .chakra-alert__desc': {
              fontSize: 'xs'
            }
          }
        }) : null, isMobileSeo && jsxRuntimeExports.jsx(Box, {
          marginY: 2,
          marginX: -4,
          borderTopWidth: 1,
          borderColor: "gray.100"
        }), showSearchButton ? jsxRuntimeExports.jsx(Flex, {
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          sx: {
            '& .find-parking-spots-button': {
              variant: 'primary',
              width: '100%',
              marginTop: {
                base: 2,
                mobileXL: 4
              },
              height: 10
            }
          },
          width: isDesktopRefreshedVariation ? '80%' : '100%',
          children: FindParkingSpotsButton ? jsxRuntimeExports.jsx(FindParkingSpotsButton, {
            label: "Search",
            onClick: handleSearch,
            partialStore: FindParkingSpotsPartialStore
          }) : jsxRuntimeExports.jsx(Button, {
            "data-testid": "DateTimePicker-submit-button",
            variant: "primary",
            width: "100%",
            marginTop: {
              base: 2,
              mobileXL: 4
            },
            onClick: handleSubmit,
            "aria-label": dateTimePickerButtonLabel || 'Submit',
            children: dateTimePickerButtonLabel || 'Submit'
          })
        }) : jsxRuntimeExports.jsx(Flex, {
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          children: jsxRuntimeExports.jsx(Button, {
            "aria-label": dateTimePickerButtonLabel ? dateTimePickerButtonLabel : selectedSuggestion && parkingSubType === 'power_booking' ? 'Search for parking' : 'Submit date and time',
            "data-testid": "DateTimePicker-submit-button",
            ref: desktopSubmitButtonRef,
            variant: "primary",
            width: isDesktopRefreshedVariation ? '80%' : '100%',
            marginTop: {
              base: 2,
              mobileXL: 4
            },
            onClick: handleSubmit,
            onKeyDown: event => {
              if (event.key === 'Enter') {
                event.preventDefault();
                handleSubmit(event);
              }
            },
            children: dateTimePickerButtonLabel ? dateTimePickerButtonLabel : selectedSuggestion && parkingSubType === 'power_booking' ? 'Search' : 'Submit'
          })
        })]
      })]
    })]
  });
};

const SearchWidgetModal = ({
  title,
  isOpen,
  onClose,
  children
}) => {
  return jsxRuntimeExports.jsxs(Modal, {
    isMobile: true,
    isOpen: isOpen,
    hideCloseButton: true,
    size: "full",
    onClose: onClose,
    contentStyling: {
      height: '100%'
    },
    children: [jsxRuntimeExports.jsxs(Flex, {
      position: "relative",
      "data-testid": "SearchWidgetModal-header",
      children: [jsxRuntimeExports.jsx(Button, {
        "aria-label": "Close modal",
        onClick: onClose,
        variant: "tertiary",
        position: "absolute",
        height: "100%",
        left: "3",
        sx: {
          '&:focus': {
            boxShadow: 'none'
          }
        },
        children: jsxRuntimeExports.jsx(Icon, {
          as: ArrowLeft,
          height: "6",
          width: "6",
          fill: "black"
        })
      }), jsxRuntimeExports.jsx(Heading, {
        as: "h4",
        width: "100%",
        textAlign: "center",
        fontWeight: "semibold",
        children: title
      })]
    }), jsxRuntimeExports.jsx(Box, {
      paddingX: 4,
      paddingTop: 4,
      paddingBottom: 0,
      "data-testid": "SearchWidgetModal-body",
      overflowY: "auto",
      height: "100%",
      children: children
    })]
  });
};

const SearchWidgetTooltip = ({
  onClose,
  text
}) => {
  const handleClose = e => {
    // Prevent event from reaching Popover
    e.stopPropagation();
    e.preventDefault();
    if (onClose) {
      onClose(e);
    }
  };
  if (!text) return null;
  return jsxRuntimeExports.jsxs(Flex, {
    position: "absolute",
    justifyContent: "space-between",
    background: "primary.default",
    color: "white",
    padding: 4,
    rounded: "md",
    boxShadow: "lg",
    marginTop: 2,
    className: "SearchWidgetTooltip",
    "data-testid": "SearchWidgetTooltip",
    onClick: handleClose,
    children: [jsxRuntimeExports.jsx(Box, {
      position: "absolute",
      top: "-10px",
      left: "10px",
      width: "0",
      height: "0",
      borderLeft: "10px solid transparent",
      borderRight: "10px solid transparent",
      borderBottom: "10px solid #1271eb" // primary.default
    }), jsxRuntimeExports.jsx(Text, {
      variant: "caption",
      sx: {
        fontWeight: 'semibold',
        textAlign: 'left'
      },
      alignSelf: "center",
      "data-testid": "SearchWidgetTooltip-text",
      children: text
    }), jsxRuntimeExports.jsx(Button, {
      "aria-label": "Close tooltip",
      variant: "tertiary",
      onClick: handleClose,
      color: "white",
      sx: {
        '&:hover': {
          color: 'white'
        }
      },
      "data-testid": "SearchWidgetTooltip-close-button",
      className: "SearchWidgetTooltip-close-button",
      children: jsxRuntimeExports.jsx(Icon, {
        as: X,
        width: 6,
        height: 6
      })
    })]
  });
};

const useIsDesktopDateInputHighlighted = () => {
  const isDatePopoverOpen = useStore(state => state.datePopoverDisclosure?.isOpen || false);
  const isDateRangeActive = useStore(state => state.isDateRangeActive);
  return isDatePopoverOpen && !isDateRangeActive;
};

const formatSingleDate = (date, timezone) => {
  if (!date) {
    return '';
  }
  const dayjsDate = dayjs(date).tz(timezone);
  const time = dayjsDate.format(TIME_DISPLAY);
  return `${dayjsDate.isSame(dayjs(), 'date') ? 'Today' : dayjsDate.format(SHORT_DATE_MONTH_NAME_DAY)}, ${time}`;
};
const formatDateRange = (starts, ends, timezone) => {
  if (!starts || !ends) {
    return '';
  }
  const startDate = dayjs(starts).tz(timezone);
  const endDate = dayjs(ends).tz(timezone);
  const startTime = startDate.format(TIME_DISPLAY);
  const endTime = endDate.format(TIME_DISPLAY);
  if (startDate.isSame(endDate, 'date')) {
    return `${startDate.isSame(dayjs(), 'date') ? 'Today' : startDate.format(SHORT_DATE_MONTH_NAME_DAY)}, ${startTime} - ${endTime}`;
  } else {
    return `${startDate.format(SHORT_DATE_MONTH_NAME_DAY)}, ${startTime} - ${endDate.format(SHORT_DATE_MONTH_NAME_DAY)}, ${endTime}`;
  }
};
const formatMultipleDates = (dates, startTime, endTime, maxDates = 5) => {
  if (dates.length === 0 || !startTime || !endTime) {
    return '';
  }
  const startTimeFormatted = combineDateTime(dates[0], startTime).format(TIME_DISPLAY);
  const endTimeFormatted = combineDateTime(dates[0], endTime).format(TIME_DISPLAY);
  if (dates.length >= maxDates) {
    return `${dates.length} dates, ${startTimeFormatted} - ${endTimeFormatted}`;
  }
  return dates.map(d => dayjs(d).format(SHORT_DATE_MONTH_DAY)).join(', ') + `, ${startTimeFormatted} - ${endTimeFormatted}`;
};
const formatMonthlyDate = date => {
  return dayjs(date).format(LONG_DATE_MONTH_NAME_DAY_YEAR);
};
const formatMonthlyDateShort = date => {
  return dayjs(date).format(SHORT_DATE_MONTH_NAME_DAY);
};
const DateInput = forwardRef(({
  placeholderText,
  onClick = null,
  onKeyPress = null,
  onInput = null,
  errorType = null,
  ...props
}, ref) => {
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  const dateTimeTooltipText = useStore(state => state.dateTimeTooltipText);
  const onDateTimeTooltipClose = useStore(state => state.onDateTimeTooltipClose);
  const isMobile = useStore(state => state.isMobile);
  const isTablet = useStore(state => state.isTablet);
  const parkingSubType = useStore(state => state.parkingSubType);
  const startDate = useStore(state => state.startDate);
  const endDate = useStore(state => state.endDate);
  const timezone = useStore(state => state.timezone);
  const dates = useStore(state => state.dates);
  const startTime = useStore(state => state.startTime);
  const endTime = useStore(state => state.endTime);
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  const eventMode = useStore(state => state.eventMode);
  const isDatePopoverOpen = useStore(state => state.datePopoverDisclosure?.isOpen || false);
  const showV2DateRangeInput = isMobile && (parkingSubType === 'hourly' || parkingSubType === 'event');
  const columnStyles = isSearchOnDesktop(eventMode, isMobile) ? {
    ...(isDesktopRefreshedVariation && isDatePopoverOpen ? {} : {
      borderLeft: 'none'
    }),
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    fontSize: {
      base: 'base',
      mobileXL: 'xs',
      desktop: 'base'
    }
  } : {};
  const showTooltip = isSearchOnDesktop(eventMode, isMobile) && !!dateTimeTooltipText;
  const desktopDateInputHighlighted = useIsDesktopDateInputHighlighted();
  const handleTooltipClose = () => {
    onDateTimeTooltipClose?.();
  };
  const handleFocus = event => {
    // Use focus to open the Date/Time popover on the Search desktop
    if (!isMobile && eventMode === 'search' && onKeyPress && event.relatedTarget // focus is not caused by a click on the input
    ) {
      // The onKeyPress only uses the event to prevent the default action
      onKeyPress(event);
    }
  };
  const inputValue = useMemo(() => {
    if (parkingSubType === 'hourly' || parkingSubType === 'event' || parkingSubType === 'airport') {
      return formatDateRange(startDate, endDate, timezone);
    }
    if (parkingSubType === 'power_booking') {
      const maxMultipleDates = isMobile || isTablet ? 3 : 4;
      return formatMultipleDates(dates, startTime, endTime, maxMultipleDates);
    }
    if (parkingSubType === 'monthly') {
      return formatMonthlyDate(monthlyStartDate);
    }
    return '';
  }, [parkingSubType, startDate, endDate, dates, startTime, endTime, monthlyStartDate, isMobile]);
  const formattedButtonValue = eventMode === 'search' ? jsxRuntimeExports.jsx(Box, {
    fontSize: {
      base: 'base',
      tablet: 'xs',
      desktop: 'base'
    },
    children: inputValue
  }) : inputValue;
  return jsxRuntimeExports.jsxs(Box, {
    minWidth: {
      base: '268px',
      desktop: '384px'
    },
    sx: {
      '& .chakra-button:focus': {
        ...(isSearchOnDesktop(eventMode, isMobile) ? {
          borderColor: 'gray.medium'
        } : {})
      }
    },
    children: [showV2DateRangeInput ? eventMode === 'search' ? jsxRuntimeExports.jsx(DateRangePicker, {}) : jsxRuntimeExports.jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [jsxRuntimeExports.jsx(RefreshedButtonInput, {
        label: "Start time",
        "aria-label": "Start time",
        buttonValue: formatSingleDate(startDate, timezone),
        onClick: onClick,
        leftElementStyles: {
          zIndex: 'auto',
          pointerEvents: 'none'
        },
        rightElementStyles: {
          zIndex: 'auto',
          pointerEvents: 'none'
        },
        leftElement: jsxRuntimeExports.jsx(Icon, {
          as: Clock,
          width: 4.5,
          height: 4.5
        }),
        rightElement: jsxRuntimeExports.jsx(Icon, {
          as: ChevronDown,
          cursor: "pointer",
          width: 4.5,
          height: 4.5
        }),
        isInvalid: Boolean(errorType),
        ...columnStyles,
        ...props
      }), jsxRuntimeExports.jsx(RefreshedButtonInput, {
        label: "End time",
        "aria-label": "End time",
        buttonValue: formatSingleDate(endDate, timezone),
        onClick: onClick,
        leftElementStyles: {
          zIndex: 'auto',
          pointerEvents: 'none'
        },
        rightElementStyles: {
          zIndex: 'auto',
          pointerEvents: 'none'
        },
        leftElement: jsxRuntimeExports.jsx(Icon, {
          as: Clock,
          width: 4.5,
          height: 4.5
        }),
        rightElement: jsxRuntimeExports.jsx(Icon, {
          as: ChevronDown,
          cursor: "pointer",
          width: 4.5,
          height: 4.5
        }),
        isInvalid: Boolean(errorType),
        ...columnStyles,
        ...props
      })]
    }) : isDesktopRefreshedVariation ? jsxRuntimeExports.jsx(Box, {
      sx: {
        '& .chakra-form__label': {
          paddingLeft: 10,
          paddingRight: 8,
          width: '100%'
        }
      },
      children: jsxRuntimeExports.jsx(RefreshedButtonInput, {
        ref: ref,
        isHighlighted: desktopDateInputHighlighted,
        label: jsxRuntimeExports.jsxs(Flex, {
          width: "100%",
          fontSize: {
            base: 'sm',
            mobileXL: 'xs',
            desktop: 'sm'
          },
          children: [jsxRuntimeExports.jsx(Box, {
            textAlign: "left",
            flexBasis: "50%",
            children: "Start time"
          }), jsxRuntimeExports.jsx(Box, {
            children: "End time"
          })]
        }),
        "aria-label": 'Starts',
        buttonValue: jsxRuntimeExports.jsxs(Flex, {
          width: "100%",
          children: [jsxRuntimeExports.jsx(Box, {
            textAlign: "left",
            flexBasis: "50%",
            children: formatSingleDate(startDate, timezone)
          }), jsxRuntimeExports.jsx(Box, {
            children: formatSingleDate(endDate, timezone)
          })]
        }),
        onClick: onClick,
        onKeyPress: onKeyPress,
        onInput: onInput,
        onFocus: handleFocus,
        leftElementStyles: {
          zIndex: 'auto',
          pointerEvents: 'none'
        },
        rightElementStyles: {
          zIndex: 'auto',
          pointerEvents: 'none'
        },
        leftElement: jsxRuntimeExports.jsx(Icon, {
          as: Calendar,
          width: 4.5,
          height: 4.5
        }),
        rightElement: jsxRuntimeExports.jsx(Icon, {
          as: isDatePopoverOpen ? ChevronUp : ChevronDown,
          cursor: "pointer",
          width: 4.5,
          height: 4.5
        }),
        isInvalid: Boolean(errorType),
        ...columnStyles,
        ...props
      })
    }) : jsxRuntimeExports.jsx(RefreshedButtonInput, {
      ref: ref,
      label: inputValue ? placeholderText : null,
      "aria-label": placeholderText,
      buttonValue: inputValue ? formattedButtonValue : placeholderText,
      onClick: onClick,
      onKeyPress: onKeyPress,
      onInput: onInput,
      onFocus: handleFocus,
      leftElementStyles: {
        zIndex: 'auto',
        pointerEvents: 'none'
      },
      rightElementStyles: {
        zIndex: 'auto',
        pointerEvents: 'none'
      },
      leftElement: jsxRuntimeExports.jsx(Icon, {
        as: Calendar,
        width: 4.5,
        height: 4.5
      }),
      rightElement: jsxRuntimeExports.jsx(Icon, {
        as: ChevronDown,
        cursor: "pointer",
        width: 4.5,
        height: 4.5
      }),
      isInvalid: Boolean(errorType),
      ...columnStyles,
      ...props
    }), showTooltip && jsxRuntimeExports.jsx(SearchWidgetTooltip, {
      text: dateTimeTooltipText,
      onClose: handleTooltipClose
    })]
  });
});

const hrStyle = {
  borderBottom: {
    base: '1px solid',
    tablet: '0px'
  },
  paddingBottom: {
    base: '3',
    tablet: '0'
  },
  borderColor: 'gray.200'
};
const CurrentLocation = () => {
  const currentIndex = useStore(state => state.autocomplete.currentIndex);
  const findParkingNearMe = useStore(state => state.autocomplete.findParkingNearMe);
  const isSelected = currentIndex === 0;
  return jsxRuntimeExports.jsx(ListItem, {
    ...hrStyle,
    id: `suggestion-0`,
    "aria-selected": isSelected,
    children: jsxRuntimeExports.jsx(Box, {
      paddingLeft: {
        base: '3',
        tablet: '0'
      },
      paddingY: {
        base: '2',
        tablet: '0'
      },
      children: jsxRuntimeExports.jsxs(Button, {
        "aria-label": "Use current location",
        variant: "tertiary",
        onClick: findParkingNearMe,
        paddingLeft: "8",
        position: "relative",
        "data-testid": "autocomplete-current-location",
        role: "option",
        "data-focus": isSelected ? true : undefined,
        isActive: isSelected,
        className: "autocomplete-current-location" //used by useAutocomplete
        ,
        tabindex: "-1",
        fontSize: "sm",
        children: [jsxRuntimeExports.jsx(Icon, {
          as: Center,
          position: "absolute",
          left: "1"
        }), "Use current location"]
      })
    })
  });
};

/**
 * Escapes special regex characters in a string.
 * @param str The string to escape.
 * returns - The escaped string.
 */
function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '$&');
}
/**
 * Builds a regex pattern from the target string.
 * Inserts \W* between characters to allow for special characters in the search string.
 * Replaces spaces with [\s/-]+ to allow for word delimiters.
 * @param targetString The string to match.
 * returns - A RegExp object.
 */
function buildRegex(targetString) {
  // Split target string by spaces to handle multi-word targets
  const words = targetString.split(/\s+/);
  // For each word, escape regex characters and insert \W* between letters
  const escapedWords = words.map(word => {
    return word.split('').map(char => escapeRegex(char)).join('\\W*');
  });
  // Join words with [\s/-]+ to allow for spaces, hyphens, or slashes between words
  const regexPattern = escapedWords.join('[\\s/-]+');
  // Create a case-insensitive regex
  return new RegExp(regexPattern, 'i');
}
/**
 * Highlights the matching part of the targetString based on the searchString.
 * @param searchString The string to match.
 * @param targetString The string to search within.
 * returns - An array of HighlightSegment objects indicating matched and unmatched parts.
 */
function highlightMatch(searchString, targetString) {
  if (!searchString) {
    // If targetString is empty, return the entire searchString as non-matching
    return [{
      text: targetString,
      match: false
    }];
  }
  // Build the regex pattern from the target string
  const regex = buildRegex(searchString);
  // Execute the regex on searchString
  const match = regex.exec(targetString);
  if (!match) {
    // No match found, return the entire string as non-matching
    return [{
      text: targetString,
      match: false
    }];
  }
  const matchStart = Number(match.index);
  const matchEnd = matchStart + match[0].length;
  const beforeMatch = targetString.substring(0, matchStart);
  const matchedText = targetString.substring(matchStart, matchEnd);
  const afterMatch = targetString.substring(matchEnd);
  const result = [];
  if (beforeMatch.length > 0) {
    result.push({
      text: beforeMatch,
      match: false
    });
  }
  result.push({
    text: matchedText,
    match: true
  });
  if (afterMatch.length > 0) {
    result.push({
      text: afterMatch,
      match: false
    });
  }
  return result;
}

const TextWithHighlightedMatchingSegment = ({
  searchString,
  targetString,
  style,
  ...props
}) => {
  const descriptionSegments = highlightMatch(searchString, targetString);
  return jsxRuntimeExports.jsx(Text, {
    textDecoration: "none",
    textTransform: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    sx: style,
    ...props,
    children: descriptionSegments.map(segment => segment.match ? jsxRuntimeExports.jsx("strong", {
      children: segment.text
    }) : jsxRuntimeExports.jsx("span", {
      children: segment.text
    }))
  });
};

const SuggestionIcons = {
  'airplane-filled': AirplaneFilled,
  search: Search
};
const AirportSuggestion = props => {
  const FindParkingSpotsPartialStore = useFindParkingSpotsButtonPartialStore();
  const {
    index,
    description,
    iconName = 'airplane-filled'
  } = props;
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const setParkingSubType = useStore(state => state.setParkingSubType);
  const setCurrentIndex = useStore(state => state.autocomplete.setCurrentIndex);
  const setSuggestion = useStore(state => state.autocomplete.setSuggestion);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const trackSearchSuggestionSelected = useStore(state => state.trackSearchSuggestionSelected);
  const id = `suggestion-${index}`;
  // When iconName is 'search', we render this Component as a GoogleSuggestion
  const googleSuggestionStyles = {
    color: 'black',
    width: 4,
    height: 4,
    marginRight: 3,
    marginLeft: {
      tablet: 1,
      base: 3
    }
  };
  const airportSuggestionStyles = {
    width: 5,
    height: 5,
    marginRight: 2,
    marginLeft: {
      base: 3,
      mobileXL: 1
    }
  };
  const handleOnClick = () => {
    if (trackSearchSuggestionSelected) {
      trackSearchSuggestionSelected({
        userRawText: inputValue,
        description: props.description,
        parkingType: 'airport',
        powerBooking: false,
        useCurrentLocation: false,
        placeId: props.place_id,
        iataCode: props.iataCode,
        isRecentSearch: props.isRecentSearch
      }, FindParkingSpotsPartialStore);
    }
    // We disable the power booking toggle when the user selects an airport
    if (parkingSubType === 'power_booking') {
      setParkingSubType(parkingType);
    }
    setSuggestion(props);
  };
  const handleOnHover = () => {
    setCurrentIndex(index);
  };
  return jsxRuntimeExports.jsx(ListItem, {
    role: "option",
    id: id,
    "aria-selected": false,
    "data-autocomplete": `airport_${description}`,
    marginBottom: "2",
    children: jsxRuntimeExports.jsxs(Button, {
      "aria-label": `Airport suggestion: ${description}`,
      onMouseOver: handleOnHover,
      variant: "tertiary",
      width: "100%",
      textAlign: "left",
      justifyContent: "flex-start",
      color: "text",
      className: "autocomplete-suggestion",
      "data-testid": props['data-testid'],
      isActive: false,
      onClick: handleOnClick,
      children: [jsxRuntimeExports.jsx(Icon, {
        as: SuggestionIcons[iconName],
        ...(iconName === 'search' ? googleSuggestionStyles : airportSuggestionStyles),
        "data-testid": "AirpotSuggestion-Icon",
        "data-testid-icon": iconName
      }), jsxRuntimeExports.jsx(TextWithHighlightedMatchingSegment, {
        searchString: inputValue,
        targetString: description,
        style: {
          fontSize: 'sm'
        }
      })]
    })
  });
};

const navigateTo = url => {
  window.location.assign(url);
};

const PerformerSuggestion = props => {
  const {
    isLoaderShowing,
    setIsLoaderShowing
  } = useShowLoader(false);
  const {
    index,
    name,
    url,
    id: propID
  } = props;
  const currentIndex = useStore(state => state.autocomplete.currentIndex);
  const setCurrentIndex = useStore(state => state.autocomplete.setCurrentIndex);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const trackSearchSuggestionSelected = useStore(state => state.trackSearchSuggestionSelected);
  //Plus one below to account for useLocation
  const id = `suggestion-${index}`;
  const isSelected = id === `suggestion-${currentIndex}`;
  const handleOnHover = () => {
    setCurrentIndex(index);
  };
  const handleButtonClick = e => {
    e.preventDefault();
    setIsLoaderShowing(true);
    if (trackSearchSuggestionSelected) {
      trackSearchSuggestionSelected({
        userRawText: inputValue,
        description: name,
        parkingType: 'event',
        powerBooking: false,
        eventId: propID,
        useCurrentLocation: false
      });
    }
    navigateTo(`${url}`);
  };
  return jsxRuntimeExports.jsxs(ListItem, {
    role: "option",
    id: id,
    "aria-selected": isSelected,
    className: "autocomplete-performer-suggestion",
    "data-autocomplete": `performer-${name}`,
    marginBottom: "2",
    children: [jsxRuntimeExports.jsxs(Button, {
      "aria-label": `Performer suggestion: ${name}`,
      onMouseOver: handleOnHover,
      variant: "tertiary",
      width: "100%",
      textAlign: "left",
      justifyContent: "start",
      color: "text",
      className: "autocomplete-suggestion",
      "data-testid": props['data-testid'],
      asAnchor: true,
      isActive: isSelected,
      href: `${url}`,
      onClick: handleButtonClick,
      children: [jsxRuntimeExports.jsx(Icon, {
        as: TicketEvent,
        color: "black",
        height: 4,
        width: 4,
        marginRight: 3,
        marginLeft: {
          tablet: 1,
          base: 3
        }
      }), jsxRuntimeExports.jsx(Text, {
        textAlign: "left",
        overflow: "hidden",
        textDecoration: "none",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: "inherit",
        fontSize: {
          base: 'sm'
        },
        fontWeight: "normal",
        children: name
      })]
    }), isLoaderShowing && jsxRuntimeExports.jsx(Flex, {
      alignSelf: "center",
      alignItems: "center",
      justifyContent: "center",
      width: 2,
      height: 2,
      children: jsxRuntimeExports.jsx(Loader, {
        size: 4,
        thickness: 10,
        color: "primary.default"
      })
    })]
  });
};

const EventLineItem = ({
  month,
  date,
  topText,
  bottomText,
  showDate,
  isSelected,
  styleOverride = {}
}) => jsxRuntimeExports.jsxs(Box, {
  "data-testid": "EventLineItem",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "90%" //Dont love this but it was too support the left chevron for events view - bottom makes it so if its only thing it goes 100%
  ,
  _last: {
    width: '100%'
  },
  paddingY: {
    base: '1',
    tablet: '0'
  },
  paddingLeft: {
    base: 0,
    mobileXL: 2
  },
  marginBottom: "1",
  gap: 2,
  _hover: showDate ? {
    '& .event-date': {
      transition: 'transform 0.1s ease-in',
      transform: 'scale(1)'
    }
  } : undefined,
  ...styleOverride,
  children: [showDate && jsxRuntimeExports.jsx(EventDate, {
    month: month,
    date: date
  }), jsxRuntimeExports.jsx(EventInfo, {
    topText: topText,
    bottomText: bottomText,
    showDate: showDate,
    isSelected: isSelected
  })]
});
const EventDate = ({
  month,
  date
}) => {
  const parkingType = useStore(state => state.parkingType);
  return jsxRuntimeExports.jsxs(Box, {
    "data-testid": "EventDate",
    className: "event-date" //Used for hover state
    ,
    minWidth: "36px",
    width: "36px",
    height: "38px",
    borderWidth: "1px",
    borderColor: "black",
    rounded: "md",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    transform: parkingType === 'event' ? undefined : 'scale(0.85)',
    children: [jsxRuntimeExports.jsx(Box, {
      bg: "primary.default",
      color: "white",
      fontSize: "xs",
      fontWeight: "semibold",
      px: 1,
      py: 0.5,
      textAlign: "center",
      textTransform: "uppercase",
      children: month
    }), jsxRuntimeExports.jsx(Flex, {
      flexGrow: 1,
      align: "center",
      justify: "center",
      backgroundColor: "white",
      color: "black",
      fontWeight: "bold",
      fontSize: "base",
      children: date
    })]
  });
};
const EventInfo = ({
  topText,
  bottomText,
  showDate,
  isSelected
}) => {
  const parkingType = useStore(state => state.parkingType);
  return jsxRuntimeExports.jsxs(Box, {
    paddingLeft: !showDate && {
      tablet: '8',
      base: '4'
    },
    width: "100%",
    overflow: "hidden",
    textDecoration: "none",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "data-testid": "EventInfo",
    children: [jsxRuntimeExports.jsx(Text, {
      "data-testid": "EventInfoTopText",
      width: {
        base: '100%',
        mobileXL: parkingType === 'event' ? '260px' : '100%'
      },
      overflow: "hidden",
      textDecoration: "none",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      color: "inherit",
      fontSize: {
        base: 'xs',
        mobileXL: 'sm'
      },
      fontWeight: "medium",
      children: topText
    }), jsxRuntimeExports.jsx(Text, {
      "data-testid": "EventInfoBottomText",
      className: "autocomplete-venue" //Used for hover state
      ,
      fontSize: "xs",
      fontWeight: "medium",
      color: isSelected ? 'inherit' : 'text.secondary.light',
      width: "100%",
      overflow: "hidden",
      textDecoration: "none",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      children: bottomText
    })]
  });
};

const EventSuggestion = props => {
  const {
    isLoaderShowing,
    setIsLoaderShowing
  } = useShowLoader(false);
  const {
    index,
    date = '',
    venue,
    label,
    id: propID
  } = props; //delete description from this
  const trackSearchSuggestionSelected = useStore(state => state.trackSearchSuggestionSelected);
  const siteUrl = useStore(state => state.siteUrl);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const currentIndex = useStore(state => state.autocomplete.currentIndex);
  const setCurrentIndex = useStore(state => state.autocomplete.setCurrentIndex);
  const suggestions = useStore(state => state.autocomplete.suggestions);
  //Plus one below to account for useLocation
  const id = `suggestion-${index}`;
  const isSelected = id === `suggestion-${currentIndex}`;
  const handleOnHover = () => {
    setCurrentIndex(index);
  };
  const handleButtonClick = e => {
    e.preventDefault();
    setIsLoaderShowing(true);
    const suggestion = suggestions().find(s => isEventSuggestion(s) && s.id === propID);
    if (suggestion && trackSearchSuggestionSelected) {
      trackSearchSuggestionSelected({
        userRawText: inputValue,
        suggestionType: suggestion.isSearchEvent ? 'event_title' : 'popular_event',
        description: suggestion.label,
        // @ts-expect-error place_id does not exist on FormattedSearchEvent
        placeId: suggestion.place_id,
        parkingType: 'event',
        powerBooking: false,
        eventId: suggestion.id,
        useCurrentLocation: false
      });
    }
    navigateTo(`${siteUrl}/search?kind=event&id=${propID}`);
  };
  const monthNDayArray = date.split(' ');
  const showDate = !(monthNDayArray.length !== 2);
  return jsxRuntimeExports.jsx(ListItem, {
    role: "option",
    id: id,
    "aria-selected": isSelected,
    className: "autocomplete-event-suggestion",
    "data-autocomplete": `event_${label}-${venue}`,
    marginBottom: "0",
    "data-city": props?.city,
    children: jsxRuntimeExports.jsxs(Button, {
      "aria-label": `Event suggestion: ${label}, ${venue}`,
      onMouseOver: handleOnHover,
      variant: "tertiary",
      width: "100%",
      textAlign: "left",
      color: "text",
      className: "autocomplete-suggestion",
      "data-testid": props['data-testid'],
      asAnchor: true,
      isActive: isSelected,
      href: `${siteUrl}/search?kind=event&id=${propID}`,
      onClick: handleButtonClick,
      children: [jsxRuntimeExports.jsx(EventLineItem, {
        month: monthNDayArray[0],
        date: monthNDayArray[1],
        topText: label,
        bottomText: venue,
        showDate: showDate,
        isSelected: isSelected
      }), isLoaderShowing && jsxRuntimeExports.jsx(Flex, {
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        width: 2,
        height: 2,
        children: jsxRuntimeExports.jsx(Loader, {
          size: 4,
          thickness: 10,
          color: "primary.default"
        })
      })]
    })
  });
};

/**
 * Below is needed to support trackSearchSuggestionSelected
 */
const convertParkingType = parkingType => parkingType === 'hourly' ? 'transient' : parkingType;

/**
 * This function checks for the local time offset being present on the date time string to figure out if you need to use it on the .tz function for dayjs
 * Regex in function validates if a offset is present to decide if its needed or not.
 *
 * @function offsetPresent
 * @param {string} str - A date time string that is ISO-8601 compliant.
 * @returns {boolean} The formatted date time string that the rest of the application expects.
 */
const offsetPresent = str => {
  const bool = /(Z|[+-](\d{2}:?\d{2}$)|([+-]\d{2}$))/.test(str);
  return bool;
};
/**
 * Date/time strings are returned from V2 Search in a different format from V1.
 * (They contain seconds and have time zones applied.)
 * This formats a date time string in the context of a provided time zone
 * so we can limit the downstream effects inside this application.
 *
 * @function formatDateTime
 * @see {@link https://api.spothero.com/v2/docs#operation/searchTransientParking|Documentation}
 * @param {string} dateTimeString - A date time string that is ISO-8601 compliant.
 * @param {string} timezone - A time zone string, e.g. America/Chicago.
 * @param {string} outputFormat - Format for the output; defaults to YYYY-MM-DDTHH:mm.
 * @returns {string} The formatted date time string that the rest of the application expects.
 */
const formatDateTime = (dateTimeString, timezone, outputFormat = apiDateTimeFormat) => {
  if (!dateTimeString) {
    return '';
  }
  if (timezone) {
    return dayjs(dateTimeString).tz(timezone, !offsetPresent(dateTimeString)).format(outputFormat);
  } else {
    return dayjs(dateTimeString).format(outputFormat);
  }
};

const reduceFn = () => {
  // @ts-expect-error Parameter curr implicitly has an any type.
  return (prev, curr, i, full) => {
    const last = full[i - 1];
    if (isValidElement(curr) || isValidElement(last)) {
      prev.push(curr);
    } else {
      const lastElement = prev.pop();
      const newString = typeof lastElement === 'string' ? String(lastElement) + String(curr) : String(curr); //Resolve issue with first word not being the one bolded
      prev.push(newString);
    }
    return prev;
  };
};
const GoogleSuggestion = suggestion => {
  const FindParkingSpotsPartialStore = useFindParkingSpotsButtonPartialStore();
  const {
    description,
    matched_substrings = [],
    index,
    place_id,
    bypassForVenueUrl
  } = suggestion;
  const setSuggestion = useStore(state => state.autocomplete.setSuggestion);
  const setIsInputInvalid = useStore(state => state.autocomplete.setIsInputInvalid);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const currentIndex = useStore(state => state.autocomplete.currentIndex);
  const endDate = useStore(state => state.endDate);
  const startDate = useStore(state => state.startDate);
  const timezone = useStore(state => state.timezone);
  const setCurrentIndex = useStore(state => state.autocomplete.setCurrentIndex);
  const eventDestinationsHash = useStore(state => state.eventDestinationsHash);
  const trackSearchSuggestionSelected = useStore(state => state.trackSearchSuggestionSelected);
  const siteUrl = useStore(state => state.siteUrl);
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const id = `suggestion-${index}`;
  const descriptionAsArray = description.split('');
  let currentLengthOffset = 0;
  matched_substrings.forEach(({
    length,
    offset
  }) => {
    const substring = jsxRuntimeExports.jsx(Text, {
      as: "b",
      fontSize: "sm",
      children: description.substring(offset, offset + length)
    }, offset);
    descriptionAsArray.splice(offset - currentLengthOffset, length, substring);
    currentLengthOffset += length - 1;
  });
  const destinationURL = useMemo(() => {
    if (eventDestinationsHash && place_id && eventDestinationsHash[place_id] && siteUrl) {
      try {
        // may want to update this to a wrapper as its just copied
        return buildDestinationVenueUrl({
          eventDestinationsHash,
          place_id,
          siteUrl,
          //Below enables the venue link to have the times inputted
          ...(Boolean(endDate) && Boolean(startDate) && Boolean(timezone) && {
            dates: {
              ends: formatDateTime(endDate?.toISOString(), timezone),
              starts: formatDateTime(startDate?.toISOString(), timezone)
            }
          })
        });
      } catch {
        return undefined;
      }
    } else if (bypassForVenueUrl) {
      return bypassForVenueUrl;
    }
  }, [eventDestinationsHash, place_id, siteUrl, endDate, startDate, timezone]);
  const asAnchor = parkingSubType === 'hourly' && Boolean(destinationURL);
  //If its a string and the last is a string, combine them.  otherwise push
  const renderArray = descriptionAsArray.reduce(reduceFn(), []).map(
  // @ts-expect-error Parameter stringsOrElements implicitly has an any type.
  stringsOrElements => isValidElement(stringsOrElements) ? stringsOrElements : jsxRuntimeExports.jsx("span", {
    children: stringsOrElements
  }, stringsOrElements) //Needed the words to have a key on them
  );
  const isSelected = id === `suggestion-${currentIndex}`;
  const handleOnClick = e => {
    // clear the input invalid state on new selection
    setIsInputInvalid(false);
    if (!asAnchor) {
      setSuggestion(suggestion);
      //Dont update input if this is an anchor for venues
    }
    if (trackSearchSuggestionSelected) trackSearchSuggestionSelected({
      userRawText: inputValue,
      description: suggestion.description,
      placeId: suggestion.place_id,
      parkingType: convertParkingType(parkingType),
      powerBooking: parkingSubType === 'power_booking',
      useCurrentLocation: false,
      googlePlacesTypes: suggestion.types,
      isRecentSearch: suggestion.isRecentSearch
    }, FindParkingSpotsPartialStore);
    if (asAnchor && destinationURL) {
      navigateTo(destinationURL);
    }
  };
  const handleOnHover = () => {
    setCurrentIndex(index);
  };
  return jsxRuntimeExports.jsx(ListItem, {
    paddingY: {
      base: '1',
      tablet: '0'
    },
    role: "option",
    id: id,
    "aria-selected": isSelected,
    className: "autocomplete-google-suggestion",
    "data-autocomplete": `google_${description}`,
    children: jsxRuntimeExports.jsxs(Button, {
      "aria-label": `Google suggestion: ${description}`,
      onClick: handleOnClick,
      onMouseOver: handleOnHover,
      variant: "tertiary",
      width: "100%",
      textAlign: "left",
      justifyContent: "flex-start",
      color: "text.primary.light",
      className: "autocomplete-suggestion",
      "data-testid": suggestion['data-testid'],
      asAnchor: asAnchor,
      href: destinationURL,
      isActive: isSelected,
      tabindex: "-1",
      children: [jsxRuntimeExports.jsx(Icon, {
        as: Search,
        color: "black",
        height: 4,
        width: 4,
        marginRight: 3,
        marginLeft: {
          tablet: 1,
          base: 3
        }
      }), jsxRuntimeExports.jsx(Text, {
        width: "100%",
        overflow: "hidden",
        textDecoration: "none",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        fontSize: "sm",
        children: renderArray
      })]
    })
  });
};

const _getSpotHeroAirport = (suggestion, airports) => {
  const suggestionPlaceId = suggestion.place_id;
  return airports?.find(airport => airport?.googlePlaceIds?.some(placeId => placeId === suggestionPlaceId));
};
const renderAutocompleteSuggestions = (result, i, airports) => {
  const spotheroAirport = _getSpotHeroAirport(result, airports);
  if (isCurrentLocation(result)) {
    return jsxRuntimeExports.jsx(CurrentLocation, {}, 'current-location');
  }
  if (spotheroAirport) {
    return jsxRuntimeExports.jsx(AirportSuggestion, {
      ...spotheroAirport,
      ...result,
      iconName: "search",
      index: i,
      "data-testid": `autocomplete-result-${i + 1}`
    });
  }
  if (isAirportSuggestion(result)) {
    return jsxRuntimeExports.jsx(AirportSuggestion, {
      ...result,
      index: i,
      "data-testid": `autocomplete-result-${i + 1}`
    });
  }
  if (isPerformerSuggestion(result)) {
    return jsxRuntimeExports.jsx(PerformerSuggestion, {
      ...result,
      index: i,
      "data-testid": `autocomplete-result-${i + 1}`
    });
  }
  if (isEventSuggestion(result)) {
    return jsxRuntimeExports.jsx(EventSuggestion, {
      ...result,
      index: i,
      "data-testid": `autocomplete-result-${i + 1}`
    });
  }
  if (isGoogleAutocompleteSuggestion(result)) {
    return jsxRuntimeExports.jsx(GoogleSuggestion, {
      ...result,
      index: i,
      "data-testid": `autocomplete-result-${i + 1}`
    });
  }
  if (isContentLabel(result)) {
    return jsxRuntimeExports.jsx(ListItem, {
      fontWeight: "normal",
      fontSize: "sm",
      color: "text.secondary.light",
      marginTop: "3",
      marginBottom: "4",
      children: result.description
    });
  }
  // Section Header
  return jsxRuntimeExports.jsx(ListItem, {
    fontWeight: "semibold",
    marginTop: "6",
    fontSize: "sm",
    children: result.description
  });
};

const AutocompleteResults = ({
  results
}) => {
  const airports = useStore(state => state.airports);
  return jsxRuntimeExports.jsx(List, {
    marginTop: "2",
    role: "listbox",
    id: "suggestion-box",
    sx: {
      'li[class="autocomplete-event-suggestion"]:first-of-type': {
        backgroundColor: 'yellow'
      },
      '& ~ .autocomplete-event-suggestion': {
        backgroundColor: 'yellow',
        _before: {
          content: '"I\'m here"'
        }
      }
    },
    children: results && Boolean(results.length) ? results.map((result, i) => jsxRuntimeExports.jsx(Box, {
      children: renderAutocompleteSuggestions(result, i, airports)
    }, `autocomplete-result-${i}`)) : jsxRuntimeExports.jsx(ListItem, {
      paddingY: {
        base: '2',
        tablet: '0'
      },
      paddingLeft: {
        tablet: '7',
        base: '4'
      },
      "data-testid": "autocomplete-instruction",
      children: "Type an address, place, city, airport, or event"
    })
  });
};

const AutocompleteBox = () => {
  const PoweredByGoogle = useStore(state => state.PoweredByGoogle);
  const suggestions = useStore(state => state.autocomplete.suggestions)();
  const inputHasFocus = useStore(state => state.autocomplete.inputHasFocus);
  const eventMode = useStore(state => state.eventMode);
  const isMobile = useStore(state => state.isMobile);
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  const isSearchOnDesktopWithRefreshedVariation = isSearchOnDesktop(eventMode, isMobile) && isDesktopRefreshedVariation;
  return jsxRuntimeExports.jsx(Box, {
    className: "autocomplete-box" //Used for focusWithin on parent
    ,
    visibility: {
      base: 'visible',
      tablet: inputHasFocus ? 'visible' : 'collapse'
    },
    minHeight: "16",
    ...(isSearchOnDesktop(eventMode, isMobile) && inputHasFocus ? isSearchOnDesktopWithRefreshedVariation ? {} : expandedDesktopAutocompleteBoxStyles : {}),
    maxHeight: {
      base: 'unset',
      desktop: '96'
    },
    overflow: "auto",
    width: "100%",
    position: {
      base: 'relative',
      tablet: 'absolute'
    },
    borderTop: isDesktopRefreshedVariation ? '1px' : 'none',
    borderWidth: {
      base: '0px',
      tablet: '1px'
    },
    borderColor: isSearchOnDesktop(eventMode, isMobile) || isDesktopRefreshedVariation ? 'gray.medium' : 'primary.default',
    boxShadow: isSearchOnDesktop(eventMode, isMobile) ? 'lg' : undefined,
    marginTop: isDesktopRefreshedVariation ? 0 : '-5px',
    paddingX: "3" //Same value as input
    ,
    background: "white",
    zIndex: "layer6",
    borderTopRadius: isDesktopRefreshedVariation ? 'base' : '0',
    borderBottomRadius: isDesktopRefreshedVariation ? 'base' : 'md',
    paddingBottom: {
      base: '64',
      desktop: 0
    },
    textAlign: "left",
    sx: {
      '.PoweredByGoogle': {
        backgroundColor: 'transparent',
        width: '100%',
        marginTop: 3,
        marginBottom: 3,
        float: 'left'
      }
    },
    children: jsxRuntimeExports.jsxs(Box, {
      marginTop: {
        tablet: isDesktopRefreshedVariation ? 0 : '1',
        base: '0'
      },
      borderTop: {
        tablet: isDesktopRefreshedVariation ? 0 : '1px solid',
        base: '0px'
      },
      borderTopColor: {
        tablet: isDesktopRefreshedVariation ? 'none' : 'gray.200',
        base: 'none'
      },
      children: [jsxRuntimeExports.jsx(AutocompleteResults, {
        results: suggestions
      }), jsxRuntimeExports.jsx(Box, {
        textAlign: "right",
        children: jsxRuntimeExports.jsx(PoweredByGoogle, {})
      })]
    })
  });
};

const ClearButton = () => {
  const clearAll = useStore(state => state.autocomplete.clearAll);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const handleInputBlur = useStore(state => state.autocomplete.handleInputBlur);
  const onBlur = useStore(state => state.onBlur);
  const findParkingSpotsStore = useFindParkingSpotsButtonPartialStore();
  const handleInputAutocompleteBlur = event => {
    const isLeavingAutocomplete = !event?.relatedTarget?.closest('.InputAutocomplete');
    if (isLeavingAutocomplete) {
      onBlur?.(findParkingSpotsStore);
    }
  };
  return jsxRuntimeExports.jsx(Button, {
    "aria-label": "Clear search input",
    variant: "tertiary",
    onClick: clearAll,
    onBlur: handleInputAutocompleteBlur,
    onKeyDown: event => {
      if (event.key === 'Tab') {
        handleInputBlur(event);
      }
    },
    opacity: !inputValue ? '0' : '1',
    visibility: !inputValue ? 'hidden' : 'visible',
    zIndex: "layer1",
    "data-testid": "autocomplete-clear",
    className: "autocomplete-clear" //used by InputAutocomplete for styling on this class.  Interaction with popover was tricky.
    ,
    children: jsxRuntimeExports.jsx(Icon, {
      as: XCircleFilled,
      fill: "gray.500"
    })
  });
};

//Testing file was difficult due to use of modal.  May return but not working on it currently
const MobileModal = ({
  children
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const handleInputChange = useStore(state => state.autocomplete.handleInputChange);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const mobileInputRef = useStore(state => state.autocomplete.mobileInputRef);
  const handleKeyDown = useStore(state => state.autocomplete.handleKeyDown);
  const setDisclosure = useStore(state => state.autocomplete.setDisclosure);
  const {
    onClose
  } = useStore(state => state.autocomplete.modalState);
  const searchButtonRef = useStore(state => state.searchInput.searchButtonRef);
  const isMobile = useStore(state => state.isMobile);
  const disclosure = useDisclosure();
  const {
    isOpen
  } = disclosure;
  useEffect(() => {
    setIsMounted(true);
  }, []);
  useEffect(() => {
    setDisclosure(disclosure);
  }, [disclosure]);
  // Prevent the modal from rendering on the server
  if (typeof window === 'undefined' || !isMounted) {
    return jsxRuntimeExports.jsx("div", {});
  }
  return isMobile ? jsxRuntimeExports.jsxs(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    hideCloseButton: true,
    size: 'full',
    contentStyling: {
      height: '100%',
      paddingBottom: 0
    },
    initialFocusRef: mobileInputRef,
    finalFocusRef: searchButtonRef,
    children: [jsxRuntimeExports.jsxs(Flex, {
      position: "relative",
      children: [jsxRuntimeExports.jsx(Button, {
        "aria-label": "Close modal",
        onClick: onClose,
        variant: "tertiary",
        position: "absolute",
        height: "100%",
        left: "3",
        children: jsxRuntimeExports.jsx(Icon, {
          as: ArrowLeft,
          height: "6",
          width: "6",
          fill: "black"
        })
      }), jsxRuntimeExports.jsx(Heading, {
        as: "h4",
        width: "100%",
        textAlign: "center",
        fontWeight: "500",
        children: "Enter a Destination"
      })]
    }), jsxRuntimeExports.jsx(Box, {
      padding: "3",
      position: "relative",
      children: jsxRuntimeExports.jsx(RefreshedInput, {
        label: "Where are you going?",
        placeholder: "",
        type: "text",
        onChange: handleInputChange,
        onKeyUp: handleKeyDown,
        value: inputValue,
        leftElement: jsxRuntimeExports.jsx(Icon, {
          as: Search,
          height: "100%"
        }),
        leftElementStyles: {
          height: 6,
          width: 6,
          zIndex: 'auto',
          left: '1.5rem'
        },
        ref: mobileInputRef,
        rightElement: jsxRuntimeExports.jsx(ClearButton, {}),
        id: "homepage-autocomplete-input_modal",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false",
        // Accessibility based on https://rebeccamdeprey.com/blog/building-an-accessible-autocomplete-component-with-react
        role: "combobox",
        "aria-controls": "suggestion-box",
        "aria-autocomplete": "list"
      })
    }), children]
  }) : jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: children
  });
};

const mapNewSuggestionsToLegacySuggestions = newSuggestions => {
  return newSuggestions?.map(suggestion => {
    return {
      description: suggestion?.placePrediction?.text?.text || '',
      place_id: suggestion?.placePrediction?.placeId || '',
      distance_meters: suggestion?.placePrediction?.distanceMeters || 0,
      matched_substrings: suggestion?.placePrediction?.text?.matches.map(match => ({
        length: match?.endOffset - match?.startOffset,
        offset: match?.startOffset
      })) || [],
      terms: suggestion?.placePrediction?.secondaryText?.text,
      types: suggestion?.placePrediction?.types
    };
  });
};
/**
 * Core google autocomplete
 * keeps a local state of google suggestions
 */
const useGoogleAutocomplete = () => {
  const [suggestion, setSuggestion] = useState([]);
  const locationBias = useStore(state => state.locationBias);
  const googleMapsLibraries = useStore(state => state.googleMapsLibraries);
  const setGoogleAutocomplete = useStore(state => state.autocomplete.setGoogleAutocomplete);
  const useNewGooglePlacesApi = useStore(state => state.useNewGooglePlacesApi);
  const userLocationBias = {
    location: locationBias,
    radius: 16000 // in meters ~10 mi
  };
  const {
    Place,
    AutocompleteSessionToken,
    AutocompleteService,
    AutocompleteSuggestion
  } = googleMapsLibraries?.places || {}; // New place
  const {
    Circle
  } = googleMapsLibraries?.maps || {}; // New place
  const {
    LatLng
  } = googleMapsLibraries?.core || {}; // New place
  const fetchGoogleAutocomplete = async (AutocompleteSuggestion, options) => {
    try {
      const optionsWithRestrictions = {
        ...options,
        includedRegionCodes: ['us', 'ca']
      };
      const {
        suggestions
      } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(optionsWithRestrictions);
      const mappedLegacySuggestions = mapNewSuggestionsToLegacySuggestions(suggestions);
      setSuggestion(mappedLegacySuggestions);
    } catch (e) {
      console.error('error:', e);
    }
  };
  const fetchGoogleAutocompleteSuggestions = useRef(debounce(fetchGoogleAutocomplete, 500));
  const getGoogleAutocomplete = async input => {
    if (Place && AutocompleteSessionToken && AutocompleteService && Circle && LatLng && AutocompleteSuggestion) {
      const token = new AutocompleteSessionToken();
      const service = new AutocompleteService();
      const options = {
        input: input,
        //Bounds commented until a future time when needed
        // ...(bounds && {
        //     locationBias: bounds,
        // }),
        ...(Boolean(locationBias && locationBias.latitude) && {
          locationBias: new Circle({
            center: new LatLng(Number(userLocationBias?.location?.latitude), Number(userLocationBias?.location?.longitude)),
            radius: userLocationBias?.radius
          })
        })
      };
      if (useNewGooglePlacesApi) {
        await fetchGoogleAutocompleteSuggestions.current(AutocompleteSuggestion, options);
      } else {
        const legacy_options = {
          ...options,
          componentRestrictions: {
            country: ['us', 'ca']
          },
          sessionToken: token
        };
        service.getPlacePredictions(legacy_options, suggestion =>
        // suggestion null && status ZERO_RESULTS were the options, instead using the null as the indicator
        setSuggestion(suggestion));
      }
    }
  };
  const clearGoogleAutocomplete = () => {
    fetchGoogleAutocompleteSuggestions.current.cancel();
    setSuggestion([]);
  };
  useEffect(() => {
    setGoogleAutocomplete({
      getGoogleAutocomplete,
      googleSuggestions: suggestion,
      clearGoogleAutocomplete
    });
  }, [getGoogleAutocomplete, setGoogleAutocomplete, suggestion, clearGoogleAutocomplete]);
  return {
    getGoogleAutocomplete,
    suggestion,
    clearGoogleAutocomplete
  };
};

const useGetAirportAutocomplete = () => {
  const setAirportAutocomplete = useStore(state => state.autocomplete.setAirportAutocomplete);
  const limit = 3;
  const [suggestion, setSuggestion] = useState([]);
  const getAirportAutocomplete = (searchTerm, suggestions) => {
    if (!searchTerm || !suggestions?.length) {
      setSuggestion([]);
      return [];
    }
    const matchesField = (field, searchTerm) => {
      // Match any character that is not a letter (a-z, A-Z) or a digit (0-9)
      // It is used to remove special characters from the airport fields
      const regex = /[^a-zA-Z0-9]/g;
      return field.replace(regex, '').toLowerCase().includes(searchTerm.replace(regex, '').toLowerCase());
    };
    const matches = [];
    suggestions.forEach(airport => {
      if (airport.iataCode?.toLowerCase() === searchTerm.toLowerCase()) {
        matches.unshift(airport);
      } else if (matchesField(airport.description, searchTerm) || matchesField(airport.city, searchTerm)) {
        matches.push(airport);
      }
    });
    setSuggestion(matches.slice(0, limit));
  };
  const clearAirportAutocomplete = () => {
    setSuggestion([]);
  };
  useEffect(() => {
    setAirportAutocomplete({
      getAirportAutocomplete,
      airportSuggestions: suggestion,
      clearAirportAutocomplete
    });
  }, [getAirportAutocomplete, setAirportAutocomplete, suggestion, clearAirportAutocomplete]);
  return {
    getAirportAutocomplete,
    suggestion,
    clearAirportAutocomplete
  };
};

const LocationAutocomplete = () => {
  const [readOnly, setReadonly] = useState(false);
  const isMobile = useStore(state => state.isMobile);
  const findParkingSpotsStore = useFindParkingSpotsButtonPartialStore();
  //Use effect and state needed to resolve hydration error on the readOnly
  useEffect(() => {
    setReadonly(Boolean(isMobile));
  }, [isMobile]);
  const handleInputChange = useStore(state => state.autocomplete.handleInputChange);
  const inputValue = useStore(state => state.autocomplete.inputValue);
  const inputRef = useStore(state => state.autocomplete.inputRef);
  const handleKeyDown = useStore(state => state.autocomplete.handleKeyDown);
  const {
    onOpen
  } = useStore(state => state.autocomplete.modalState);
  const isInputInvalid = useStore(state => state.autocomplete.isInputInvalid);
  const onBlur = useStore(state => state.onBlur);
  const handleInputBlur = useStore(state => state.autocomplete.handleInputBlur);
  const suggestions = useStore(state => state.autocomplete.suggestions);
  const inputHasFocus = useStore(state => state.autocomplete.inputHasFocus);
  const handleInputFocus = useStore(state => state.autocomplete.handleInputFocus);
  //Below are only used for useEffects
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const googleSuggestions = useStore(state => state.autocomplete.googleAutocomplete.googleSuggestions);
  const airportSuggestions = useStore(state => state.autocomplete.airportAutocomplete.airportSuggestions);
  const setCurrentIndex = useStore(state => state.autocomplete.setCurrentIndex);
  const eventMode = useStore(state => state.eventMode);
  const handleInputAutocompleteBlur = event => {
    handleInputBlur?.(event);
    const isLeavingAutocomplete = !event?.relatedTarget?.closest('.InputAutocomplete');
    if (isLeavingAutocomplete) {
      onBlur?.(findParkingSpotsStore);
    }
  };
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  const isSearchOnDesktopWithRefreshedVariation = isSearchOnDesktop(eventMode, isMobile) && isDesktopRefreshedVariation;
  const columnStyles = isSearchOnDesktop(eventMode, isMobile) ? inputHasFocus ? {} : {
    borderRight: 'none',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0'
  } : {};
  //MR TODO - unsure if this pattern works - VALIDATE
  useGoogleAutocomplete();
  useGetAirportAutocomplete();
  //below useeffects are moved from useAutocomplete - Unsure better location for them
  useEffect(() => {
    if (selectedSuggestion) {
      inputRef.current?.blur();
    }
  }, [selectedSuggestion]);
  useEffect(() => {
    if (googleSuggestions !== null && googleSuggestions?.length) {
      // exclude the airport suggestions from default index
      const airportSuggestionCount = airportSuggestions?.length ? airportSuggestions.length + 1 // exclude airport section header and suggestions
      : 0;
      const index = airportSuggestionCount + 2;
      setCurrentIndex(index);
    }
  }, [googleSuggestions, airportSuggestions]);
  return jsxRuntimeExports.jsxs(Box, {
    "data-testid": "InputAutocomplete",
    className: "InputAutocomplete",
    sx: {
      ...(isSearchOnDesktopWithRefreshedVariation && {
        '& #input-autocomplete': {
          fontSize: {
            base: 'base',
            mobileXL: 'xs',
            desktop: 'base'
          }
        }
      }),
      ...(inputHasFocus ? {
        height: 'auto',
        background: 'white'
      } : {}),
      ...(isSearchOnDesktop(eventMode, isMobile) && inputHasFocus ? {
        ...(isSearchOnDesktopWithRefreshedVariation ? {} : expandedDesktopAutocompleteBoxStyles),
        '& .chakra-input': {
          background: 'white'
        },
        '& .chakra-input__left-element, & .chakra-form__label': {
          zIndex: 2
        },
        '& .chakra-input:focus, & .chakra-input[data-focus]': {
          borderColor: isSearchOnDesktopWithRefreshedVariation ? 'primary.default' : 'gray.medium',
          ...(isSearchOnDesktopWithRefreshedVariation ? {
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0'
          } : {})
        }
      } : {})
    },
    position: "relative",
    children: [jsxRuntimeExports.jsx(RefreshedInput, {
      label: jsxRuntimeExports.jsx(Box, {
        as: "span",
        sx: {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          ...(isSearchOnDesktopWithRefreshedVariation && {
            fontSize: {
              base: 'sm',
              mobileXL: 'xs',
              desktop: 'sm'
            }
          })
        },
        children: "Where are you going?"
      }),
      placeholder: isInputInvalid ? '' : 'Enter your destination',
      type: "search",
      ref: inputRef,
      onChange: !isMobile ? handleInputChange : undefined,
      readOnly: readOnly,
      onClick: isMobile ? onOpen : undefined,
      onKeyUp: !isMobile ? handleKeyDown : undefined,
      onBlur: handleInputAutocompleteBlur,
      onFocus: handleInputFocus,
      value: inputValue,
      id: 'input-autocomplete',
      leftElement: jsxRuntimeExports.jsx(Icon, {
        as: Search,
        height: "100%"
      }),
      leftElementStyles: {
        height: 6,
        width: 6,
        zIndex: 'auto'
      },
      isInvalid: isInputInvalid,
      rightElement: jsxRuntimeExports.jsx(ClearButton, {}),
      rightElementStyles: {
        pointerEvents: !inputValue ? 'none' : 'auto',
        cursor: 'pointer'
      },
      "data-focus": inputHasFocus ? true : undefined,
      "data-testid": "input-autocomplete",
      autocomplete: "off",
      autocorrect: "off",
      autocapitalize: "off",
      spellcheck: "false",
      //Should the below three styles move to the design system?
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      // Accessibility based on https://rebeccamdeprey.com/blog/building-an-accessible-autocomplete-component-with-react
      role: "combobox",
      "aria-expanded": Number(suggestions()?.length) > 1,
      "aria-haspopup": "listbox",
      "aria-controls": "suggestion-box",
      "aria-autocomplete": "list",
      ...columnStyles
    }), jsxRuntimeExports.jsx(MobileModal, {
      children: jsxRuntimeExports.jsx(AutocompleteBox, {})
    })]
  });
};

const getAnalyticsParkingType = parkingSubType => {
  switch (parkingSubType) {
    case 'hourly':
      return 'transient';
    case 'monthly':
      return 'monthly';
    case 'power_booking':
      return 'power_booking';
  }
};

const usePageName = () => {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  if (pathname === '/') {
    return 'homepage';
  } else if (pathname.startsWith('/destination')) {
    return 'midfunnel_destination';
  } else if (pathname.startsWith('/city')) {
    return 'midfunnel_city';
  }
  return '';
};

const searchWidgetDateInputClass = 'chakra-button';
/**
 * Hook that handles blur event. It will call the callback function when the user clicks outside the element or the focus moves outside the element.
 */
const useDateInputBlur = (ref, callback) => {
  const isMobile = useStore(state => state.isMobile);
  useEffect(() => {
    const handleClickOutside = event => {
      // Check if the target is a tooltip close button. The tooltip close button contains an SVG element.
      // When a path inside the SVG is clicked, the target will be the path element.
      // We need to check if the closest parent element is the tooltip close button.
      const isTooltipCloseIcon = event.target?.closest('.SearchWidgetTooltip-close-button') !== null;
      if (!isMobile &&
      // not mobile
      ref && ref.current && !ref.current.contains(event.target) && !event.target?.classList?.contains(searchWidgetDateInputClass) && !isTooltipCloseIcon // not clicking on the tooltip close icon
      ) {
        callback();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, isMobile]);
};

const ButtonText = ({
  fontWeight = 'normal',
  dataTestId,
  children,
  ...restProps
}) => jsxRuntimeExports.jsx(Text, {
  display: "block",
  fontSize: "sm",
  lineHeight: "1.43",
  color: "black",
  paddingLeft: "4",
  fontWeight: fontWeight,
  "data-testid": dataTestId,
  textOverflow: "ellipsis",
  overflow: "hidden",
  textTransform: "none",
  ...restProps,
  children: children
});
const MobileToggleBase = ({
  onClick,
  topText,
  bottomText,
  eventIconData,
  styleProps,
  topTextStyleProps,
  bottomTextStyleProps,
  iconStyleProps
}) => {
  return jsxRuntimeExports.jsx(Button, {
    "aria-label": "Search toggle button",
    "box-sizing": "border-box",
    width: "100%",
    paddingX: "2",
    paddingY: "2",
    display: "block",
    textAlign: "left",
    borderColor: "gray.200",
    background: "transparent",
    _hover: {
      backgroundColor: 'transparent'
    },
    borderRadius: ".5rem",
    onClick: onClick,
    "data-testid": "search-toggle-component-button",
    overflow: "hidden",
    ...styleProps,
    children: jsxRuntimeExports.jsxs(Flex, {
      alignItems: "center",
      overflow: "hidden",
      children: [!eventIconData ? jsxRuntimeExports.jsx(Icon, {
        as: Search,
        fill: "black",
        height: "4.5",
        width: "4.5",
        role: "img",
        ...(iconStyleProps || {})
      }) : jsxRuntimeExports.jsx(EventDate, {
        ...eventIconData
      }), jsxRuntimeExports.jsxs(Box, {
        overflow: "hidden",
        children: [jsxRuntimeExports.jsx(ButtonText, {
          dataTestId: "search-toggle-component-button_top",
          ...topTextStyleProps,
          children: topText
        }), jsxRuntimeExports.jsx(ButtonText, {
          fontWeight: "medium",
          dataTestId: "search-toggle-component-button_bottom",
          ...bottomTextStyleProps,
          children: bottomText
        })]
      })]
    })
  });
};

const DesktopToggle = props => {
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const startDate = useStore(state => state.startDate);
  if (!isEventSuggestion(selectedSuggestion)) {
    return null;
  }
  //Logic for toggling event icon
  const eventIconData = {
    month: dayjs(startDate).format('MMM'),
    date: dayjs(startDate).format('DD')
  };
  const topText = selectedSuggestion.venueTitle ? `${selectedSuggestion.venueTitle} Events` : '';
  const bottomText = selectedSuggestion.eventTitle || '';
  return jsxRuntimeExports.jsx(Box, {
    "data-testid": "EventDesktopToggle",
    className: "EventDesktopToggle",
    children: jsxRuntimeExports.jsx(MobileToggleBase, {
      ...props,
      topText: topText,
      bottomText: bottomText,
      eventIconData: eventIconData,
      styleProps: {
        borderRight: 'none',
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
        fontSize: 'sm',
        paddingBottom: '6px'
      },
      topTextStyleProps: {
        fontSize: '0.85em',
        color: 'gray.dark'
      },
      bottomTextStyleProps: {
        fontSize: 'base',
        fontWeight: 'normal'
      },
      onClick: props.onClick
    })
  });
};

const useShowEventToggleOnDesktop = () => {
  const isMobile = useStore(state => state.isMobile);
  const defaultSuggestion = useStore(state => state.autocomplete?.defaultSuggestion);
  const eventMode = useStore(state => state.eventMode);
  const showEventOnDesktop = !isMobile && eventMode === 'search' && defaultSuggestion && isEventSuggestion(defaultSuggestion);
  return Boolean(showEventOnDesktop);
};

const whenHourlyPlaceholderText$1 = 'When do you need to park?';
const whenMonthlyPlaceholderText$1 = 'Monthly parking start date';
const noop$1 = () => '';
const SearchWidgetTab = () => {
  const FindParkingSpotsPartialStore = useFindParkingSpotsButtonPartialStore();
  const eventMode = useStore(state => state.eventMode);
  const onBlur = useStore(state => state.onBlur);
  const defaults = getSearchWindow(getLocalTimezone());
  const originalStartDate = dayjs(defaults.starts).toDate(); //Remove from store
  const originalEndDate = dayjs(defaults.ends).toDate();
  const setStartDate = useStore(state => state.setStartDate);
  const setEndDate = useStore(state => state.setEndDate);
  const timezone = useStore(state => state.timezone);
  const eventPanelSearchOnClick = useStore(state => state.eventPanel?.searchOnClick) || noop$1;
  const isDesktopRefreshedVariation = useIsDesktopRefreshedVariation();
  useEffect(() => {
    // Don't reset the date range if it's already set
    if (dateRangeStartDate && dateRangeEndDate) {
      return;
    }
    setStartDate(originalStartDate);
    setEndDate(originalEndDate);
  }, []);
  const [key, setKey] = React.useState(Date.now());
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const trackDateEntered = useStore(state => state.trackDateEntered);
  const trackErrorMessageDisplayed = useStore(state => state.trackErrorMessageDisplayed);
  const searchButtonRef = useStore(state => state.searchInput.searchButtonRef);
  const setDatePickerRef = useStore(state => state.searchInput.setDatePickerRef);
  const dateRangeStartDate = useStore(state => state.startDate);
  const dateRangeEndDate = useStore(state => state.endDate);
  const originalDateRangeStartDate = originalStartDate;
  const originalDateRangeEndDate = originalEndDate;
  const powerBookingDates = useStore(state => state.dates);
  const powerBookingStartTime = useStore(state => state.startTime);
  const powerBookingEndTime = useStore(state => state.endTime);
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  const originalMonthlyStartDate = useStore(state => state.originalMonthlyStartDate);
  const isMobile = useStore(state => state.isMobile);
  const popoverRef = useRef(undefined);
  const desktopSubmitButtonRef = useRef(undefined);
  const mobileInputRef = useRef(undefined);
  const desktopInputRef = useRef(undefined);
  const trackingPageName = usePageName();
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const getPowerBookingErrorType = useStore(state => state.errorType);
  const powerBookingErrorType = getPowerBookingErrorType();
  const hasUserInteracted = useStore(state => state.hasUserInteracted);
  const setHasUserInteracted = useStore(state => state.setHasUserInteracted);
  const setDateDisclosures = useStore(state => state.setDateDisclosures);
  const isAirport = isAirportSuggestion(selectedSuggestion || undefined);
  const inputHasFocus = useStore(state => state.autocomplete.inputHasFocus);
  const inputErrorType = parkingSubType === 'power_booking' && hasUserInteracted ? powerBookingErrorType : null;
  const whenPlaceholderText = parkingSubType === 'monthly' ? whenMonthlyPlaceholderText$1 : whenHourlyPlaceholderText$1;
  const dateModalDisclosure = useDisclosure();
  const {
    onOpen: onModalOpen,
    onClose: onModalClose,
    isOpen: isModalOpen
  } = dateModalDisclosure;
  const datePopoverDisclosure = useDisclosure();
  const {
    onOpen: onPopoverOpen,
    onClose: onPopoverClose,
    isOpen: isPopoverOpen
  } = datePopoverDisclosure;
  const isSearchOnDesktop$1 = isSearchOnDesktop(eventMode, isMobile);
  const isSearchOnDesktopRefreshedVariation = isSearchOnDesktop$1 && isDesktopRefreshedVariation;
  useEffect(() => {
    setDateDisclosures({
      datePopoverDisclosure,
      dateModalDisclosure
    });
  }, [datePopoverDisclosure, dateModalDisclosure]);
  const handlePopoverTriggerKeyPress = event => {
    event.preventDefault();
    onPopoverOpen();
  };
  const handlePopoverTriggerInput = () => {
    onPopoverOpen();
  };
  const handlePopoverClose = useCallback(event => {
    // The Popover's onClose event fires before the focus has updated.
    // Wait until the next tick so the focus can update first.
    // This allows us to check if the focus is still inside the popover
    // and avoid closing it when the Popover trigger is clicked.
    setTimeout(() => {
      const popoverNode = popoverRef.current;
      const activeElement = document.activeElement;
      // If focus is still within the popover, prevent closing
      if (popoverNode && activeElement && popoverNode.contains(activeElement) &&
      // Submit button is exception as we want to close the Popover when it is clicked
      !activeElement.classList.contains('chakra-button')) {
        return;
      }
      setKey(Date.now());
      if (parkingSubType === 'power_booking') {
        setHasUserInteracted(true);
      }
      // Focus on the Find Parking Spots button when the user presses Enter on the date input
      if (event?.type === 'keydown') {
        const keyDownEvent = event;
        const target = keyDownEvent.target;
        if (keyDownEvent?.key === 'Enter' && target?.tagName === 'BUTTON' && target?.textContent === 'Submit') {
          searchButtonRef.current?.focus();
        }
      }
      onPopoverClose();
      onBlur?.(FindParkingSpotsPartialStore);
    }, 0); // Wait for the next tick to allow focus to update
  }, [onPopoverClose, parkingSubType, searchButtonRef, setHasUserInteracted, FindParkingSpotsPartialStore, onBlur]);
  const handleModalClose = () => {
    if (parkingSubType === 'power_booking') {
      setHasUserInteracted(true);
    }
    onModalClose();
  };
  const handlePowerBookingError = () => {
    if (powerBookingErrorType) {
      const message = getErrorMessage(powerBookingErrorType);
      const action = getErrorAction(powerBookingErrorType);
      if (trackErrorMessageDisplayed) trackErrorMessageDisplayed({
        message: String(message),
        errorMessage: message,
        action: action,
        errorHeader: message,
        pageType: trackingPageName,
        parkingType: getAnalyticsParkingType(parkingSubType),
        currentScreenName: parkingType
      });
    }
  };
  const handleOnSubmit = () => {
    if (trackDateEntered) trackDateEntered({
      parkingSubType,
      dateRangeStartDate: dateRangeStartDate,
      dateRangeEndDate: dateRangeEndDate,
      originalDateRangeStartDate: originalDateRangeStartDate,
      originalDateRangeEndDate: originalDateRangeEndDate,
      powerBookingDates,
      powerBookingStartTime: String(powerBookingStartTime),
      powerBookingEndTime: String(powerBookingEndTime),
      monthlyStartDate,
      originalMonthlyStartDate
    }, FindParkingSpotsPartialStore);
  };
  useDateInputBlur(popoverRef, handlePopoverClose);
  useEffect(() => {
    setDatePickerRef(isMobile ? mobileInputRef.current : desktopInputRef.current);
  }, [isMobile, setDatePickerRef]);
  useEffect(() => {
    if (isAirport) {
      const searchWindow = createDefaultAirportSearchWindow(timezone);
      setStartDate(dayjs(searchWindow.starts).toDate());
      setEndDate(dayjs(searchWindow.ends).toDate());
    } else {
      // Don't reset the date range if it's already set
      if (dateRangeStartDate && dateRangeEndDate) {
        return;
      }
      setStartDate(originalDateRangeStartDate);
      setEndDate(originalDateRangeEndDate);
    }
  }, [isAirport, setStartDate, setEndDate]);
  const {
    update
  } = usePopper();
  useEffect(() => {
    const handleResize = () => {
      if (update) {
        update(); // Force the popover to update its position on window resize
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup the event listener
    };
  }, [update]);
  const initialFocusRef = selectedSuggestion ? searchButtonRef : desktopSubmitButtonRef;
  const showEventOnDesktop = useShowEventToggleOnDesktop();
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(Box, {
      sx: {
        '.autocomplete-clear': {
          opacity: isPopoverOpen ? 0 : undefined
        },
        // minWidth: '0' is critical for handling overflow properly on the EventDesktopToggle long text paragraph
        ...(showEventOnDesktop ? {
          minWidth: '0'
        } : {})
      },
      children: showEventOnDesktop ? jsxRuntimeExports.jsx(DesktopToggle, {
        onClick: eventPanelSearchOnClick
      }) : jsxRuntimeExports.jsx(LocationAutocomplete, {})
    }), jsxRuntimeExports.jsx(Box, {
      display: {
        base: 'block',
        mobileXL: 'none'
      },
      children: jsxRuntimeExports.jsx(DateInput, {
        "data-testid": "SearchWidget-modal-date-input",
        errorType: inputErrorType,
        ref: mobileInputRef,
        placeholderText: whenPlaceholderText,
        onClick: onModalOpen
      })
    }), jsxRuntimeExports.jsx(SearchWidgetModal, {
      title: whenPlaceholderText,
      isOpen: isModalOpen,
      onClose: handleModalClose,
      "data-testid": "SearchWidget-mobile",
      children: jsxRuntimeExports.jsx(DateTimePicker, {
        onClose: handleModalClose,
        onPowerBookingError: handlePowerBookingError,
        onSubmit: handleOnSubmit
      })
    }), jsxRuntimeExports.jsx(Box, {
      "data-testid": "SearchWidgetTab-desktop-container",
      display: {
        base: 'none',
        mobileXL: 'block'
      },
      sx: {
        ...(isSearchOnDesktop$1 ? {
          '& .chakra-form-control': {
            width: '100%'
          }
        } : {})
      },
      children: jsxRuntimeExports.jsxs(Popover, {
        isLazy: true,
        placement: "bottom",
        // modifiers is used to prevent the popover from flipping to the top when there is not enough space at the bottom
        // The page now scrolls to show the popover at bottom instead
        modifiers: [{
          name: 'flip',
          enabled: false // Disable automatic flipping
        }],
        // We handle closing this popover manually as we have nested Popovers (DateInput and this Popover)
        // and we don't want to close this Popover when interacting with the DateInput Popover
        // So we set closeOnBlur to false and handle closing manually
        closeOnBlur: false,
        isOpen: isPopoverOpen,
        onOpen: onPopoverOpen,
        onClose: handlePopoverClose,
        backgroundColor: "white",
        variant: "light",
        offset: [0, isDesktopRefreshedVariation ? 0 : isSearchOnDesktop$1 ? -55 : -62],
        initialFocusRef: initialFocusRef,
        children: [jsxRuntimeExports.jsx(PopoverTrigger, {
          children: jsxRuntimeExports.jsxs(Box, {
            position: "relative",
            children: [isSearchOnDesktop$1 && !(isSearchOnDesktopRefreshedVariation && inputHasFocus) && jsxRuntimeExports.jsx(Box, {
              position: "absolute",
              backgroundColor: "gray.200",
              width: "1px",
              top: 2,
              height: 10
            }), jsxRuntimeExports.jsx(DateInput, {
              ref: desktopInputRef,
              "data-testid": "SearchWidget-popover-date-input",
              className: "SearchWidget-popover-date-input" //Class used by useAutocomplete blur for validation
              ,
              errorType: inputErrorType,
              onInput: handlePopoverTriggerInput,
              onKeyPress: handlePopoverTriggerKeyPress,
              placeholderText: whenPlaceholderText
            })]
          })
        }), jsxRuntimeExports.jsx(Portal, {
          children: isPopoverOpen && jsxRuntimeExports.jsx(Box, {
            zIndex: "layer6",
            position: "relative",
            "data-testid": "SearchWidget-popover",
            className: "SearchWidget-popover",
            children: jsxRuntimeExports.jsx(PopoverContent, {
              ref: popoverRef,
              hideArrow: true,
              hideCloseButton: true,
              header: isDesktopRefreshedVariation ? undefined : jsxRuntimeExports.jsx(Box, {
                borderBottomWidth: 1,
                paddingBottom: 4,
                paddingLeft: 4,
                marginX: -4,
                marginBottom: 2,
                children: whenPlaceholderText
              }),
              maxWidth: {
                base: 0,
                mobileXL: '34rem'
              },
              minWidth: {
                base: 0,
                mobileXL: desktopInputRef.current?.offsetWidth
              },
              children: jsxRuntimeExports.jsx(DateTimePicker, {
                desktopSubmitButtonRef: desktopSubmitButtonRef,
                onPowerBookingError: handlePowerBookingError,
                onClose: handlePopoverClose,
                onSubmit: handleOnSubmit
              })
            })
          })
        })]
      }, key)
    })]
  });
};

function ShowMore({
  children,
  pageSize = 3,
  ...props
}) {
  const [currentPageSize, setCurrentPageSize] = useState(pageSize);
  if (!Array.isArray(children)) return null; //Early return to validate children exist
  if (children[0]?.props === undefined) return null; // Early return to ensure react element is passed, not string
  const isShowMoreVisible = currentPageSize < children.length;
  const filteredChildren = children.slice(0, currentPageSize);
  return jsxRuntimeExports.jsxs(Flex, {
    flexDirection: "column",
    children: [jsxRuntimeExports.jsx(Box, {
      children: filteredChildren
    }), isShowMoreVisible && jsxRuntimeExports.jsx(Button, {
      "aria-label": "Show more",
      variant: "secondary",
      onClick: () => setCurrentPageSize(children.length),
      marginY: 4,
      ...props,
      children: jsxRuntimeExports.jsx("span", {
        children: "Show More"
      })
    })]
  });
}

const hoverFocusStyle$1 = {
  borderRadius: 'md',
  backgroundColor: 'gray.50'
};
function EventListItem(props) {
  const timezone = useStore(state => state.timezone) || '';
  const trackEventListItemSelected = useStore(state => state.trackEventListItemSelected);
  const {
    isLoaderShowing,
    setIsLoaderShowing
  } = useShowLoader(false);
  useStore(state => state.siteUrl);
  const {
    event: {
      id: eventId,
      starts: eventStarts,
      ends: eventEnds,
      title: eventTitle,
      venue,
      location,
      destination_id: destinationId
    },
    eventUrl,
    index,
    eventListLength,
    showBookParkingButton = true,
    customTitle = ''
  } = props;
  const title = customTitle || eventTitle;
  const starts = dayjs(formatDateTime(eventStarts, timezone));
  let ends = undefined;
  if (eventEnds) ends = dayjs(formatDateTime(eventEnds, timezone));
  const onEventListItemSelected = async () => {
    if (trackEventListItemSelected) trackEventListItemSelected({
      source: 'midfunnel',
      index: index + 1,
      eventId: Number(eventId),
      eventName: eventTitle
    });
  };
  const handleClick = async () => {
    setIsLoaderShowing(true);
    await onEventListItemSelected();
  };
  const endDateFormat = !ends || ends.isSame(starts, 'day') ? 'h:mm A' : 'ddd, h:mm A';
  return jsxRuntimeExports.jsxs(Button, {
    "aria-label": `Change event: ${title}, ${starts.format('ddd, h:mm A')}`,
    onClick: handleClick,
    variant: "tertiary",
    width: "100%",
    textAlign: "left",
    color: "text",
    "data-testid": props['data-testid'],
    asAnchor: true,
    display: "flex",
    justifyContent: "space-between",
    href: eventUrl,
    paddingX: 'px',
    paddingY: 3.5,
    _hover: {
      desktop: hoverFocusStyle$1,
      base: {}
    },
    _focus: hoverFocusStyle$1,
    padding: 'pickle',
    sx: {
      // create a bottom border that spans the width of the button except for the border radius
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: {
          base: 0,
          mobileXL: 2
        },
        right: 2,
        height: '1px',
        backgroundColor: 'gray.50',
        display: index === eventListLength - 1 ? 'none' : 'block'
      }
    },
    children: [jsxRuntimeExports.jsx(EventLineItem, {
      topText: title,
      bottomText: `${starts.format('ddd, h:mm A')} - ${(ends || starts).format(endDateFormat)}`,
      month: starts.format('MMM'),
      date: starts.format('DD'),
      showDate: true
    }), jsxRuntimeExports.jsxs(Box, {
      paddingRight: "2",
      flexGrow: {
        base: '1',
        mobileXL: '0'
      },
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "start",
      gap: 0,
      children: [showBookParkingButton && !isLoaderShowing && jsxRuntimeExports.jsx(Text, {
        display: {
          base: 'none',
          mobileXL: 'block'
        },
        color: "primary.default",
        fontSize: "sm",
        fontWeight: "semibold",
        children: "Book Parking"
      }), isLoaderShowing ? jsxRuntimeExports.jsx(Flex, {
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        width: 2,
        height: 2,
        children: jsxRuntimeExports.jsx(Loader, {
          size: 4,
          thickness: 10,
          color: "primary.default"
        })
      }) : jsxRuntimeExports.jsx(Icon, {
        color: {
          base: 'black',
          mobileXL: 'primary.default'
        },
        marginTop: 0.5,
        width: "4.5",
        height: "4.5",
        as: ChevronRight
      })]
    })]
  });
}

var isToday$2 = {exports: {}};

var isToday$1 = isToday$2.exports;
var hasRequiredIsToday;
function requireIsToday() {
  if (hasRequiredIsToday) return isToday$2.exports;
  hasRequiredIsToday = 1;
  (function (module, exports) {
    !function (e, o) {
      module.exports = o() ;
    }(isToday$1, function () {

      return function (e, o, t) {
        o.prototype.isToday = function () {
          var e = "YYYY-MM-DD",
            o = t();
          return this.format(e) === o.format(e);
        };
      };
    });
  })(isToday$2);
  return isToday$2.exports;
}

var isTodayExports = requireIsToday();
var isToday = /*@__PURE__*/getDefaultExportFromCjs(isTodayExports);

var isTomorrow$2 = {exports: {}};

var isTomorrow$1 = isTomorrow$2.exports;
var hasRequiredIsTomorrow;
function requireIsTomorrow() {
  if (hasRequiredIsTomorrow) return isTomorrow$2.exports;
  hasRequiredIsTomorrow = 1;
  (function (module, exports) {
    !function (o, e) {
      module.exports = e() ;
    }(isTomorrow$1, function () {

      return function (o, e, t) {
        e.prototype.isTomorrow = function () {
          var o = "YYYY-MM-DD",
            e = t().add(1, "day");
          return this.format(o) === e.format(o);
        };
      };
    });
  })(isTomorrow$2);
  return isTomorrow$2.exports;
}

var isTomorrowExports = requireIsTomorrow();
var isTomorrow = /*@__PURE__*/getDefaultExportFromCjs(isTomorrowExports);

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
//https://stackoverflow.com/a/47225591
function partition(array, isValid) {
  return array.reduce(
  // @ts-expect-error Type mismatch
  ([pass, fail], elem) => {
    return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
  }, [[], []]);
}
/**
 * Following function breaks out today, tomorrow, and the rest of events for grouping
 *
 * https://www.figma.com/design/sYYOX6weBr7OlhxxrRWgyF/search-2.0?node-id=3049-12293&t=ACaNXEkxmCooJhW7-1
 * if there is an event today = "Happening today"
 * if there is no event today but there is tomorrow = "Happening tommorrow"
 * if there is no event today or tomorrow = no label/movement
 */
const mapEventsList = (events, timezone) => {
  //@ts-expect-error Type Event must have a [Symbol. iterator]() method that returns an iterator.
  const [filterToday, restOfEventsPartial] = partition(events, e => dayjs(formatDateTime(e.starts, timezone)).isToday());
  //@ts-expect-error Type Event must have a [Symbol. iterator]() method that returns an iterator.
  const [filterTomorrow, restOfEventsFull] = partition(restOfEventsPartial, e => dayjs(formatDateTime(e.starts, timezone)).isTomorrow());
  if (filterToday.length !== 0) {
    return {
      Happening_today: filterToday,
      Coming_soon: restOfEventsPartial
    };
  } else if (filterTomorrow.length !== 0) {
    return {
      Happening_tomorrow: filterTomorrow,
      Coming_soon: restOfEventsFull
    };
  } else {
    return {
      Coming_soon: restOfEventsFull
    };
  }
};

const EventEmptyStateSvg = () => jsxRuntimeExports.jsxs("svg", {
  width: "88px",
  height: "88px",
  viewBox: "0 0 88 88",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "event-upcoming-image",
  children: [jsxRuntimeExports.jsx("title", {
    id: "svgTitle",
    children: "No Upcoming Events"
  }), jsxRuntimeExports.jsx("desc", {
    id: "svgDesc",
    children: "There are no upcoming events at this venue."
  }), jsxRuntimeExports.jsx("defs", {
    children: jsxRuntimeExports.jsx("path", {
      d: "M44.3391461,-0.0004 C20.3121798,-0.0004 0.83352809,19.6996 0.83352809,43.9996 L0.83352809,43.9996 C0.83352809,68.3006 20.3121798,87.9996 44.3391461,87.9996 L44.3391461,87.9996 C68.3671011,87.9996 87.844764,68.3006 87.844764,43.9996 L87.844764,43.9996 C87.844764,19.6996 68.3671011,-0.0004 44.3391461,-0.0004 Z",
      id: "path-1"
    })
  }), jsxRuntimeExports.jsx("g", {
    id: "Destination-Pages-&-Event-Pages---AT",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: jsxRuntimeExports.jsx("g", {
      id: "A.3-desktop-empty-state",
      transform: "translate(-532.000000, -382.000000)",
      children: jsxRuntimeExports.jsxs("g", {
        id: "Group-33",
        transform: "translate(532.000000, 382.000000)",
        children: [jsxRuntimeExports.jsx("mask", {
          id: "mask-2",
          fill: "white",
          children: jsxRuntimeExports.jsx("use", {
            xlinkHref: "#path-1"
          })
        }), jsxRuntimeExports.jsx("g", {
          id: "Clip-2"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-1",
          fill: "#E5E7EA",
          mask: "url(#mask-2)",
          points: "-3.60997753 47.4466 97.2617528 47.4466 97.2617528 35.3436 -3.60997753 35.3436"
        }), jsxRuntimeExports.jsx("path", {
          d: "M0.356251685,28.5239 C1.8324764,27.7659 12.0562966,23.8649 12.0562966,23.8649 C12.0562966,23.8649 18.0650157,25.7609 18.8026337,25.5979 C19.5412404,25.4359 27.5522067,23.4309 28.2898247,23.3769 C29.0284315,23.3229 37.671218,26.0859 38.6204315,25.9779 C39.5686562,25.8689 48.9500494,23.5399 49.6886562,23.4309 C50.4262742,23.3229 60.3346787,28.6319 60.8616899,28.4699 C61.3887011,28.3069 68.2398472,22.2389 68.2398472,22.2389 C68.2398472,22.2389 75.3025888,27.3859 76.7788135,27.3319 C78.2540494,27.2779 89.2322966,23.5939 89.2322966,23.5939 L89.6535101,38.7099 L0.832835955,38.6549 L0.356251685,28.5239 Z",
          id: "Fill-3",
          fill: "#F1F1F1",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M12.067964,23.8857 C14.4686831,27.6847 18.8587955,34.7187 21.270391,38.5867 L22.1513798,38.5877 L18.240818,25.5207 C17.0978067,25.4267 13.2218517,24.2437 12.067964,23.8857",
          id: "Fill-4",
          fill: "#EAEAEA",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M28.5559011,23.3886 L35.462418,38.5956 L38.0252944,38.5966 L38.1123056,25.8916 C36.731991,25.7616 30.5611146,23.8386 28.5559011,23.3886",
          id: "Fill-5",
          fill: "#EAEAEA",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M60.5453843,28.3886 C60.0786876,28.5326 52.2753618,24.3956 49.9675865,23.5126 L53.9137438,38.6076 L58.1861933,38.6106 L60.576036,28.3756 C60.5641708,28.3816 60.5542831,28.3856 60.5453843,28.3886",
          id: "Fill-6",
          fill: "#EAEAEA",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M78.2572135,38.623 L76.7819775,27.206 C76.6554157,27.232 76.5476404,27.248 76.4626067,27.251 C75.196,27.297 69.8141573,23.512 68.3132135,22.438 C70.0119101,25.84 73.276809,33.014 75.8001348,38.622 L78.2572135,38.623 Z",
          id: "Fill-7",
          fill: "#EAEAEA",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M33.473618,8.3554 C32.6381124,8.2804 31.8035955,8.8024 31.3537079,9.6234 C30.6477303,9.4734 29.940764,9.4734 29.2337978,9.6974 C28.7839101,8.9524 28.0779326,8.5794 27.3066966,8.6534 C26.1508315,8.6534 25.2520449,9.3244 25.2520449,10.1444 C25.2520449,10.2194 25.2520449,10.2934 25.3163146,10.4424 C24.9949663,10.3684 24.673618,10.3684 24.3522697,10.3684 C22.9393258,10.3684 21.7824719,10.8154 21.7824719,11.3374 L35.4649888,11.3374 C35.5292584,11.2634 35.5935281,11.1884 35.5935281,11.1134 C35.7210787,10.8904 35.7853483,10.5924 35.7853483,10.2934 C35.7210787,9.1754 34.6937528,8.3554 33.473618,8.3554",
          id: "Fill-8",
          fill: "#E5E7EA",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-9",
          fill: "#F4F6F9",
          mask: "url(#mask-2)",
          points: "-4.94382022 99.9746 91.8729888 99.9746 91.8729888 47.2146 -4.94382022 47.2146"
        }), jsxRuntimeExports.jsx("path", {
          d: "M24.8909483,43.6811 L23.6381843,43.6811 C23.4275775,43.6811 23.2565213,43.5081 23.2565213,43.2951 L23.2565213,28.1531 C23.2565213,27.5901 23.7083865,27.1331 24.2650607,27.1331 C24.8217348,27.1331 25.2736,27.5901 25.2736,28.1531 L25.2736,43.2951 C25.2736,43.5081 25.1015551,43.6811 24.8909483,43.6811",
          id: "Fill-10",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M20.756827,34.1831 L20.756827,34.1831 C20.3741753,34.1831 20.0637034,33.8691 20.0637034,33.4821 L20.0637034,29.8381 C20.0637034,29.4511 20.3741753,29.1371 20.756827,29.1371 C21.1404674,29.1371 21.4509393,29.4511 21.4509393,29.8381 L21.4509393,33.4821 C21.4509393,33.8691 21.1404674,34.1831 20.756827,34.1831",
          id: "Fill-11",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M27.7312719,36.1123 L27.6581034,36.1123 C27.3130247,36.1123 27.0341933,35.8303 27.0341933,35.4813 L27.0341933,32.2163 C27.0341933,31.8683 27.3130247,31.5853 27.6581034,31.5853 L27.7312719,31.5853 C28.0753618,31.5853 28.355182,31.8683 28.355182,32.2163 L28.355182,35.4813 C28.355182,35.8303 28.0753618,36.1123 27.7312719,36.1123",
          id: "Fill-12",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M27.7312719,36.1123 L25.2366202,36.1123 C24.8915416,36.1123 24.6127101,35.8303 24.6127101,35.4813 C24.6127101,35.1333 24.8915416,34.8503 25.2366202,34.8503 L27.7312719,34.8503 C28.0753618,34.8503 28.355182,35.1333 28.355182,35.4813 C28.355182,35.8303 28.0753618,36.1123 27.7312719,36.1123",
          id: "Fill-13",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M23.9195865,34.1831 L20.7565303,34.1831 C20.3738787,34.1831 20.0634067,33.8691 20.0634067,33.4821 L20.0634067,33.1771 C20.0634067,32.7901 20.3738787,32.4761 20.7565303,32.4761 L23.9195865,32.4761 C24.3022382,32.4761 24.6127101,32.7901 24.6127101,33.1771 L24.6127101,33.4821 C24.6127101,33.8691 24.3022382,34.1831 23.9195865,34.1831",
          id: "Fill-14",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M67.982373,43.7417 L67.1508225,43.7417 C67.0054742,43.7417 66.8868225,43.6217 66.8868225,43.4747 L66.8868225,33.2697 C66.8868225,32.8907 67.190373,32.5827 67.5661034,32.5827 C67.9418337,32.5827 68.2473618,32.8907 68.2473618,33.2697 L68.2473618,43.4747 C68.2473618,43.6217 68.1277213,43.7417 67.982373,43.7417",
          id: "Fill-15",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M65.2014742,37.3364 L65.2014742,37.3364 C64.942418,37.3364 64.7328,37.1244 64.7328,36.8634 L64.7328,34.4064 C64.7328,34.1454 64.942418,33.9334 65.2014742,33.9334 C65.4595416,33.9334 65.6691596,34.1454 65.6691596,34.4064 L65.6691596,36.8634 C65.6691596,37.1244 65.4595416,37.3364 65.2014742,37.3364",
          id: "Fill-16",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M69.9038382,38.6377 L69.8544,38.6377 C69.6220404,38.6377 69.4331865,38.4477 69.4331865,38.2117 L69.4331865,36.0107 C69.4331865,35.7757 69.6220404,35.5847 69.8544,35.5847 L69.9038382,35.5847 C70.1361978,35.5847 70.3250517,35.7757 70.3250517,36.0107 L70.3250517,38.2117 C70.3250517,38.4477 70.1361978,38.6377 69.9038382,38.6377",
          id: "Fill-17",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M69.9038382,38.6377 L68.2219506,38.6377 C67.9886022,38.6377 67.8007371,38.4477 67.8007371,38.2117 C67.8007371,37.9767 67.9886022,37.7867 68.2219506,37.7867 L69.9038382,37.7867 C70.1361978,37.7867 70.3250517,37.9767 70.3250517,38.2117 C70.3250517,38.4477 70.1361978,38.6377 69.9038382,38.6377",
          id: "Fill-18",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("path", {
          d: "M67.3334472,37.3364 L65.2016719,37.3364 C64.9426157,37.3364 64.7329978,37.1244 64.7329978,36.8634 L64.7329978,36.6584 C64.7329978,36.3974 64.9426157,36.1854 65.2016719,36.1854 L67.3334472,36.1854 C67.5925034,36.1854 67.8011326,36.3974 67.8011326,36.6584 L67.8011326,36.8634 C67.8011326,37.1244 67.5925034,37.3364 67.3334472,37.3364",
          id: "Fill-19",
          fill: "#5C7996",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("polyline", {
          id: "Stroke-20",
          stroke: "#FFBF02",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          mask: "url(#mask-2)",
          points: "9.98028764 54.0234 44.8332315 54.0234 74.8194787 54.0234"
        }), jsxRuntimeExports.jsx("line", {
          x1: "44.8941393",
          y1: "71.333",
          x2: "44.832836",
          y2: "54.023",
          id: "Stroke-21",
          stroke: "#FFBF02",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("line", {
          x1: "55.0792",
          y1: "54.0712",
          x2: "67.3863461",
          y2: "71.3332",
          id: "Stroke-22",
          stroke: "#FFBF02",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("line", {
          x1: "64.8645034",
          y1: "54.0234",
          x2: "82.8273798",
          y2: "67.5224",
          id: "Stroke-23",
          stroke: "#FFBF02",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("line", {
          x1: "34.9185978",
          y1: "54.0234",
          x2: "22.4018337",
          y2: "71.3334",
          id: "Stroke-24",
          stroke: "#FFBF02",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("line", {
          x1: "24.9430562",
          y1: "54.0234",
          x2: "4.42026966",
          y2: "69.2604",
          id: "Stroke-25",
          stroke: "#FFBF02",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          mask: "url(#mask-2)"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-26",
          fill: "#FFBF02",
          mask: "url(#mask-2)",
          points: "35.0210337 52.8096 43.5590112 52.8096 43.5590112 51.5246 35.0210337 51.5246"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-27",
          fill: "#FFBF02",
          mask: "url(#mask-2)",
          points: "25.0513258 52.8096 33.5893034 52.8096 33.5893034 51.5246 25.0513258 51.5246"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-28",
          fill: "#FFBF02",
          mask: "url(#mask-2)",
          points: "15.081618 52.8096 23.6195955 52.8096 23.6195955 51.5246 15.081618 51.5246"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-29",
          fill: "#FFBF02",
          mask: "url(#mask-2)",
          points: "44.9917303 52.8096 53.5297079 52.8096 53.5297079 51.5246 44.9917303 51.5246"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-30",
          fill: "#FFBF02",
          mask: "url(#mask-2)",
          points: "54.9604494 52.8096 63.4994157 52.8096 63.4994157 51.5246 54.9604494 51.5246"
        }), jsxRuntimeExports.jsx("polygon", {
          id: "Fill-31",
          fill: "#FFBF02",
          mask: "url(#mask-2)",
          points: "64.9301573 52.8096 73.4691236 52.8096 73.4691236 51.5246 64.9301573 51.5246"
        }), jsxRuntimeExports.jsx("path", {
          d: "M60.6207281,15.5332 C59.7852225,15.4582 58.9507056,15.9802 58.4998292,16.8002 C57.7948404,16.6512 57.0878742,16.6512 56.3809079,16.8752 C55.9310202,16.1292 55.2250427,15.7572 54.4538067,15.8312 C53.2979416,15.8312 52.3991551,16.5022 52.3991551,17.3222 C52.3991551,17.3972 52.3991551,17.4712 52.462436,17.6202 C52.1410876,17.5462 51.8207281,17.5462 51.498391,17.5462 C50.086436,17.5462 48.929582,17.9932 48.929582,18.5152 L62.6120989,18.5152 C62.6753798,18.4402 62.7406382,18.3662 62.7406382,18.2912 C62.8681888,18.0682 62.9324584,17.7692 62.9324584,17.4712 C62.8681888,16.3532 61.8408629,15.5332 60.6207281,15.5332",
          id: "Fill-32",
          fill: "#E5E7EA",
          mask: "url(#mask-2)"
        })]
      })
    })
  })]
});

const NoEvents = () => jsxRuntimeExports.jsxs(Flex, {
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: 60,
  textAlign: "center",
  children: [jsxRuntimeExports.jsx(EventEmptyStateSvg, {}), jsxRuntimeExports.jsxs(Text, {
    marginTop: 4,
    "data-testid": "event-upcoming-text",
    children: ["There are no upcoming events at this venue. ", jsxRuntimeExports.jsx("br", {}), "Please try again later."]
  })]
});
const TabSeo = () => {
  const events = useStore(state => state.events);
  const timezone = useStore(state => state.timezone);
  const siteUrl = useStore(state => state.siteUrl);
  const isMobile = useStore(state => state.isMobile);
  const mappedEvents = mapEventsList(events || [], timezone || null);
  const mappedEventsKeys = Object.keys(mappedEvents);
  const isComingSoonEventTypeOnly = mappedEventsKeys.length === 1 && mappedEventsKeys[0] === 'Coming_soon';
  const mapEventItem = events => {
    return events.map((event, index) => {
      const {
        id
      } = event;
      const eventUrl = `${siteUrl}/search?kind=event&id=${id}`;
      return jsxRuntimeExports.jsx(EventListItem, {
        event: event,
        eventUrl: eventUrl,
        index: index,
        eventListLength: events.length
      }, id);
    });
  };
  const hasEvents = Boolean(events?.length);
  const eventList = hasEvents ?
  // @ts-expect-error Type mismatch
  mappedEventsKeys.map(key => {
    const mappedEvent = mappedEvents[key];
    const mappedEventItems = mappedEvent ? mapEventItem(mappedEvent) : [];
    const showMorePresent = isMobile && key === 'Coming_soon';
    return jsxRuntimeExports.jsxs(Box, {
      borderBottom: "1px solid",
      borderColor: "gray.light",
      marginBottom: "7",
      children: [isComingSoonEventTypeOnly ? null : jsxRuntimeExports.jsx(Text, {
        fontSize: "sm",
        color: "text.secondary.light",
        marginLeft: "1" //Match date/time
        ,
        marginBottom: "2",
        fontWeight: "medium",
        children: key.replace('_', ' ')
      }), showMorePresent ? jsxRuntimeExports.jsx(ShowMore, {
        marginBottom: 0,
        children: mappedEventItems
      }) : mappedEventItems]
    }, key);
  }) : [];
  return (
    //below adds scrolling on events, NO INDICATOR currently.  Height assumed bit taller than largest from design system
    jsxRuntimeExports.jsx(Box, {
      overflow: "auto",
      maxHeight: {
        desktop: '30rem',
        base: 'none'
      },
      children: hasEvents ? jsxRuntimeExports.jsx(Box, {
        children: eventList
      }) : jsxRuntimeExports.jsx(NoEvents, {})
    })
  );
};

const hoverFocusStyle = {
  borderRadius: 'md',
  backgroundColor: 'gray.50'
};
const noop = () => '';
const EventChangeToggle = () => {
  const timezone = useStore(state => state.timezone) || '';
  const eventPanelSearchOnclick = useStore(state => state.eventPanel?.searchOnClick) || noop;
  const eventStarts = useStore(state => {
    return state.autocomplete.defaultSuggestion?.eventStart;
  }) || '';
  const eventEnds = useStore(state => {
    return state.autocomplete.defaultSuggestion?.eventEnd;
  }) || '';
  const eventTitle = useStore(state => state.autocomplete.defaultSuggestion?.eventTitle) || '';
  const starts = dayjs(formatDateTime(eventStarts, timezone));
  let ends = undefined;
  if (eventEnds) ends = dayjs(formatDateTime(eventEnds, timezone));
  const handleClick = async () => {
    eventPanelSearchOnclick();
  };
  const endDateFormat = !ends || ends.isSame(starts, 'day') ? 'h:mm A' : 'ddd, h:mm A';
  return jsxRuntimeExports.jsx(Box, {
    children: jsxRuntimeExports.jsxs(Button, {
      "aria-label": `Change event: ${eventTitle}, ${starts.format('ddd, h:mm A')}`,
      onClick: handleClick,
      variant: "tertiary",
      width: "100%",
      textAlign: "left",
      color: "text",
      "data-testid": 'event-change-toggle',
      asAnchor: true,
      display: "flex",
      justifyContent: "space-between",
      border: "1px solid",
      borderColor: "accent",
      borderRadius: "8px",
      paddingY: 2,
      paddingX: 2,
      _hover: {
        desktop: hoverFocusStyle,
        base: {}
      },
      _focus: hoverFocusStyle,
      padding: 'pickle',
      sx: {
        // create a bottom border that spans the width of the button except for the border radius
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: {
            base: 0,
            mobileXL: 2
          },
          right: 2,
          height: '1px',
          backgroundColor: 'gray.50'
        }
      },
      children: [jsxRuntimeExports.jsx(EventLineItem, {
        topText: eventTitle,
        bottomText: `Event time: ${starts.format('ddd, h:mm A')} - ${(ends || starts).format(endDateFormat)}`,
        month: starts.format('MMM'),
        date: starts.format('DD'),
        showDate: true,
        styleOverride: {
          padding: 0,
          paddingLeft: 0,
          margin: 0
        }
      }), jsxRuntimeExports.jsx(Box, {
        paddingRight: "2",
        flexGrow: {
          base: '1',
          mobileXL: '0'
        },
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "start",
        gap: 0,
        children: jsxRuntimeExports.jsx(Icon, {
          color: {
            base: 'black',
            mobileXL: 'primary.default'
          },
          marginTop: 0.5,
          width: "4.5",
          height: "4.5",
          as: ChevronRight
        })
      })]
    })
  });
};

const EventOffsetNote = ({
  showActions = false
}) => {
  const eventMode = useStore(state => state.eventMode);
  const defaultSuggestion = useStore(state => state.autocomplete.defaultSuggestion);
  const timezone = useStore(state => state.timezone);
  dayjs.tz.setDefault(timezone);
  //If the user has edited values, starts/ends exists in the url params.  This check for that then does an early release
  const {
    starts,
    ends
  } = Object.fromEntries(new URLSearchParams(location.search));
  //@ts-expect-error - error to fix
  const eventParkingWindowStarts = defaultSuggestion?.parkingWindow?.starts;
  //@ts-expect-error - error to fix
  const eventParkingWindowEnds = defaultSuggestion?.parkingWindow?.ends;
  const originalStartDate = defaultSuggestion?.eventStart;
  const originalEndDate = defaultSuggestion?.eventEnd;
  // /* isParkingStartSameAsSearchReq and isParkingEndSameAsSearchReq ensures that we do not show offset text when user updates data and time */
  const isParkingStartSameAsSearchReq = dayjs(eventParkingWindowStarts).isSame(dayjs(starts));
  const isParkingEndSameAsSearchReq = dayjs(eventParkingWindowEnds).isSame(dayjs(ends));
  if ((starts || ends) && !(isParkingStartSameAsSearchReq || isParkingEndSameAsSearchReq)) {
    return jsxRuntimeExports.jsx(Box, {
      "data-testid": "userEditedEventTime",
      display: "none"
    });
  }
  //Below is logic for deciding if we show the message past the search request
  const parkingStartOffset = dayjs.tz(originalStartDate, timezone).diff(dayjs.tz(eventParkingWindowStarts), 'minute');
  const parkingEndOffset = dayjs.tz(eventParkingWindowEnds).diff(dayjs.tz(originalEndDate, timezone), 'minute');
  /* Offset minutes can be set to 0 or 30 in admin. Hence converting the difference to get minutes offset */
  const parkingStartOffsetHours = Math.floor(parkingStartOffset / 60);
  const parkingEndOffsetHours = Math.floor(parkingEndOffset / 60);
  const parkingStartOffsetMinutes = parkingStartOffset % 60;
  const parkingEndOffsetMinutes = parkingEndOffset % 60;
  const isNotAllZeroOffset = Boolean(parkingStartOffsetHours || parkingStartOffsetMinutes || parkingEndOffsetHours || parkingEndOffsetMinutes);
  const isValidOffset = parkingStartOffsetHours >= 0 && parkingStartOffsetMinutes >= 0 && parkingEndOffsetHours >= 0 && parkingEndOffsetMinutes >= 0;
  const showOffsetText = !showActions && isNotAllZeroOffset && isValidOffset;
  const parkingStartOffsetMinutesText = parkingStartOffsetMinutes > 0 ? '30 minutes' : '';
  const parkingEndOffsetMinutesText = parkingEndOffsetMinutes > 0 ? '30 minutes' : '';
  const parkingStartOffsetHoursText = parkingStartOffsetHours === 1 ? `${parkingStartOffsetHours} hour` : parkingStartOffsetHours === 0 && parkingStartOffsetMinutes > 0 ? '' : `${parkingStartOffsetHours} hours`;
  const parkingEndOffsetHoursText = parkingEndOffsetHours === 1 ? `${parkingEndOffsetHours} hour` : parkingEndOffsetHours === 0 && parkingEndOffsetMinutes > 0 ? '' : `${parkingEndOffsetHours} hours`;
  // reset default timezone
  dayjs.tz.setDefault();
  return showOffsetText ? jsxRuntimeExports.jsxs(Box, {
    fontSize: "xs",
    "data-testid": "SpotListSearchControlsEvent-offset-note",
    marginTop: eventMode === 'search' ? 0 : '3',
    paddingX: 3,
    paddingY: 2,
    backgroundColor: "background.gray",
    borderRadius: "md",
    children: ["We added ", parkingStartOffsetHoursText, ' ', parkingStartOffsetMinutesText, " before the event and", ' ', parkingEndOffsetHoursText, " ", parkingEndOffsetMinutesText, " after.", ' ', jsxRuntimeExports.jsxs(Popover, {
      variant: "dark",
      placement: "top",
      flip: false,
      children: [jsxRuntimeExports.jsx(PopoverTrigger, {
        children: jsxRuntimeExports.jsx(Button, {
          variant: "tertiary",
          "data-testid": "SpotListSearchControlsEvent-offset-button",
          "aria-label": "Learn more about event parking time",
          children: jsxRuntimeExports.jsx(Icon, {
            alt: "Info Circle Icon",
            as: FilledInfoCircle,
            fontSize: "s",
            fill: "black"
          })
        })
      }), jsxRuntimeExports.jsx(PopoverContent, {
        outline: "0",
        fontWeight: "normal",
        "data-testid": "SpotListSearchControlsEvent-offset-content",
        children: "Take some extra time and make space for life. Many of our partner operators have special event rates, and give you the added time at no extra cost."
      })]
    })]
  }) : null;
};

//ALOT OF THIS IS COPYPASTA FROM SEARCHWIDGET - IDEAL STATE WOULD BE TO COMPONENTIZE A LOT OF THIS
const whenHourlyPlaceholderText = 'When do you need to park?';
const whenMonthlyPlaceholderText = 'Monthly parking start date';
const TabSearch = () => {
  const FindParkingSpotsButton = useStore(state => state.FindParkingSpotsButton);
  const FindParkingSpotsPartialStore = useFindParkingSpotsButtonPartialStore();
  const defaults = getSearchWindow(getLocalTimezone());
  const originalStartDate = dayjs(defaults.starts).toDate(); //Remove from store
  const originalEndDate = dayjs(defaults.ends).toDate();
  const setStartDate = useStore(state => state.setStartDate);
  const setEndDate = useStore(state => state.setEndDate);
  const timezone = useStore(state => state.timezone);
  useEffect(() => {
    // Don't reset the date range if it's already set
    if (dateRangeStartDate && dateRangeEndDate) {
      return;
    }
    setStartDate(originalStartDate);
    setEndDate(originalEndDate);
  }, []);
  const [key, setKey] = React.useState(Date.now());
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const trackDateEntered = useStore(state => state.trackDateEntered);
  const trackErrorMessageDisplayed = useStore(state => state.trackErrorMessageDisplayed);
  const searchButtonRef = useStore(state => state.searchInput.searchButtonRef);
  const setDatePickerRef = useStore(state => state.searchInput.setDatePickerRef);
  const dateRangeStartDate = useStore(state => state.startDate);
  const dateRangeEndDate = useStore(state => state.endDate);
  const originalDateRangeStartDate = originalStartDate;
  const originalDateRangeEndDate = originalEndDate;
  const powerBookingDates = useStore(state => state.dates);
  const powerBookingStartTime = useStore(state => state.startTime);
  const powerBookingEndTime = useStore(state => state.endTime);
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  const originalMonthlyStartDate = useStore(state => state.originalMonthlyStartDate);
  const isMobile = useStore(state => state.isMobile);
  const popoverRef = useRef(undefined);
  const desktopSubmitButtonRef = useRef(undefined);
  const mobileInputRef = useRef(undefined);
  const desktopInputRef = useRef(undefined);
  const trackingPageName = usePageName();
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const getPowerBookingErrorType = useStore(state => state.errorType);
  const powerBookingErrorType = getPowerBookingErrorType();
  const hasUserInteracted = useStore(state => state.hasUserInteracted);
  const setHasUserInteracted = useStore(state => state.setHasUserInteracted);
  const setDateDisclosures = useStore(state => state.setDateDisclosures);
  const isAirport = isAirportSuggestion(selectedSuggestion || undefined);
  const inputErrorType = parkingSubType === 'power_booking' && hasUserInteracted ? powerBookingErrorType : null;
  const whenPlaceholderText = parkingSubType === 'monthly' ? whenMonthlyPlaceholderText : whenHourlyPlaceholderText;
  const dateModalDisclosure = useDisclosure();
  const {
    onOpen: onModalOpen,
    onClose: onModalClose,
    isOpen: isModalOpen
  } = dateModalDisclosure;
  const datePopoverDisclosure = useDisclosure();
  const {
    onOpen: onPopoverOpen,
    onClose: onPopoverClose,
    isOpen: isPopoverOpen
  } = datePopoverDisclosure;
  useEffect(() => {
    setDateDisclosures({
      datePopoverDisclosure,
      dateModalDisclosure
    });
  }, [datePopoverDisclosure, dateModalDisclosure]);
  const handlePopoverTriggerKeyPress = event => {
    event.preventDefault();
    onPopoverOpen();
  };
  const handlePopoverTriggerInput = () => {
    onPopoverOpen();
  };
  const handlePopoverClose = useCallback(event => {
    setKey(Date.now());
    if (parkingSubType === 'power_booking') {
      setHasUserInteracted(true);
    }
    // Focus on the Find Parking Spots button when the user presses Enter on the date input
    if (event?.type === 'keydown') {
      const keyDownEvent = event;
      const target = keyDownEvent.target;
      if (keyDownEvent?.key === 'Enter' && target?.tagName === 'BUTTON' && target?.textContent === 'Submit') {
        searchButtonRef.current?.focus();
      }
    }
    onPopoverClose();
  }, [onPopoverClose, parkingSubType, searchButtonRef, setHasUserInteracted]);
  const handleModalClose = () => {
    if (parkingSubType === 'power_booking') {
      setHasUserInteracted(true);
    }
    onModalClose();
  };
  const handlePowerBookingError = () => {
    if (powerBookingErrorType) {
      const message = getErrorMessage(powerBookingErrorType);
      const action = getErrorAction(powerBookingErrorType);
      if (trackErrorMessageDisplayed) trackErrorMessageDisplayed({
        message: String(message),
        errorMessage: message,
        action: action,
        errorHeader: message,
        pageType: trackingPageName,
        parkingType: getAnalyticsParkingType(parkingSubType),
        currentScreenName: parkingType
      });
    }
  };
  const handleOnSubmit = () => {
    if (trackDateEntered) trackDateEntered({
      parkingSubType,
      dateRangeStartDate: dateRangeStartDate,
      dateRangeEndDate: dateRangeEndDate,
      originalDateRangeStartDate: originalDateRangeStartDate,
      originalDateRangeEndDate: originalDateRangeEndDate,
      powerBookingDates,
      powerBookingStartTime: String(powerBookingStartTime),
      powerBookingEndTime: String(powerBookingEndTime),
      monthlyStartDate,
      originalMonthlyStartDate
    });
  };
  useDateInputBlur(popoverRef, handlePopoverClose);
  useEffect(() => {
    setDatePickerRef(isMobile ? mobileInputRef.current : desktopInputRef.current);
  }, [isMobile, setDatePickerRef]);
  useEffect(() => {
    if (isAirport) {
      const searchWindow = createDefaultAirportSearchWindow(timezone);
      setStartDate(dayjs(searchWindow.starts).toDate());
      setEndDate(dayjs(searchWindow.ends).toDate());
    } else {
      // Don't reset the date range if it's already set
      if (dateRangeStartDate && dateRangeEndDate) {
        return;
      }
      setStartDate(originalDateRangeStartDate);
      setEndDate(originalDateRangeEndDate);
    }
  }, [isAirport, setStartDate, setEndDate]);
  const {
    update
  } = usePopper();
  useEffect(() => {
    const handleResize = () => {
      if (update) {
        update(); // Force the popover to update its position on window resize
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup the event listener
    };
  }, [update]);
  const initialFocusRef = selectedSuggestion ? searchButtonRef : desktopSubmitButtonRef;
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [jsxRuntimeExports.jsx(EventChangeToggle, {}), jsxRuntimeExports.jsx(Box, {
      display: {
        base: 'block',
        mobileXL: 'none'
      },
      children: jsxRuntimeExports.jsx(DateInput, {
        "data-testid": "SearchWidget-modal-date-input",
        errorType: inputErrorType,
        ref: mobileInputRef,
        placeholderText: whenPlaceholderText,
        onClick: onModalOpen
      })
    }), jsxRuntimeExports.jsx(SearchWidgetModal, {
      title: whenPlaceholderText,
      isOpen: isModalOpen,
      onClose: handleModalClose,
      "data-testid": "SearchWidget-mobile",
      children: jsxRuntimeExports.jsx(DateTimePicker, {
        onClose: handleModalClose,
        onPowerBookingError: handlePowerBookingError,
        onSubmit: handleOnSubmit
      })
    }), jsxRuntimeExports.jsx(Box, {
      display: {
        base: 'none',
        mobileXL: 'block'
      },
      children: jsxRuntimeExports.jsxs(Popover, {
        isLazy: true,
        isOpen: isPopoverOpen,
        onOpen: onPopoverOpen,
        onClose: handlePopoverClose,
        backgroundColor: "white",
        variant: "light",
        offset: [0, -62],
        initialFocusRef: initialFocusRef,
        children: [jsxRuntimeExports.jsx(PopoverTrigger, {
          children: jsxRuntimeExports.jsx(DateInput, {
            ref: desktopInputRef,
            "data-testid": "SearchWidget-popover-date-input",
            className: "SearchWidget-popover-date-input" //Class used by useAutocomplete blur for validation
            ,
            errorType: inputErrorType,
            onInput: handlePopoverTriggerInput,
            onKeyPress: handlePopoverTriggerKeyPress,
            placeholderText: whenPlaceholderText
          })
        }), jsxRuntimeExports.jsx(Portal, {
          children: jsxRuntimeExports.jsx(Box, {
            zIndex: "layer3",
            position: "relative",
            "data-testid": "SearchWidget-popover",
            children: jsxRuntimeExports.jsx(PopoverContent, {
              ref: popoverRef,
              hideArrow: true,
              hideCloseButton: true,
              header: jsxRuntimeExports.jsx(Box, {
                borderBottomWidth: 1,
                paddingBottom: 2,
                paddingLeft: 4,
                marginX: -4,
                marginBottom: 2,
                children: whenPlaceholderText
              }),
              maxWidth: {
                base: 0,
                mobileXL: '34rem'
              },
              children: jsxRuntimeExports.jsx(DateTimePicker, {
                desktopSubmitButtonRef: desktopSubmitButtonRef,
                onPowerBookingError: handlePowerBookingError,
                onClose: handlePopoverClose,
                onSubmit: handleOnSubmit
              })
            })
          })
        })]
      }, key)
    }), EventOffsetNote ? jsxRuntimeExports.jsx(EventOffsetNote, {}) : null, FindParkingSpotsButton ? jsxRuntimeExports.jsx(FindParkingSpotsButton, {
      partialStore: FindParkingSpotsPartialStore
    }) : null]
  });
};

const SearchWidgetEventTab = () => {
  const eventMode = useStore(state => state.eventMode);
  return eventMode === 'seo' ? jsxRuntimeExports.jsx(TabSeo, {}) : jsxRuntimeExports.jsx(TabSearch, {});
};

const LocationGetError = () => {
  const isError = useStore(state => state.searchInput.isError);
  const setIsError = useStore(state => state.searchInput.setIsError);
  return jsxRuntimeExports.jsxs(Modal, {
    size: "sm",
    isOpen: isError,
    hasHeader: true,
    onClose: () => setIsError(false),
    hasFooter: false,
    children: [jsxRuntimeExports.jsx(ModalHeader, {
      children: jsxRuntimeExports.jsx(Heading, {
        as: "h4",
        children: "Location Services Disabled"
      })
    }), jsxRuntimeExports.jsxs(ModalBody, {
      display: "block",
      children: [' ', jsxRuntimeExports.jsx(Text, {
        variant: "body2",
        marginBottom: 4,
        children: "We cannot show parking nearest you because location sharing has been disabled on your browser. To find parking near your current location, go to \"Preferences\" in your Internet browser's settings and allow SpotHero to see your location."
      }), jsxRuntimeExports.jsx(Text, {
        variant: "body2",
        children: "If you do not want to share your location, you can find parking by entering an address or place into the search field."
      })]
    })]
  });
};

const getAirportsLocal = async siteUrl => {
  try {
    const airports = window.localStorage.getItem('sh-airports-local');
    if (airports) {
      return JSON.parse(airports);
    } else {
      return await getAirports(siteUrl);
    }
  } catch (e) {
    console.error('Error reading recent places from localStorage', e);
    return [];
  }
};
const saveAirportsLocal = airports => {
  try {
    window.localStorage.setItem('sh-airports-local', JSON.stringify(airports));
  } catch (e) {
    console.error('Error saving recent places to localStorage', e);
  }
};
const getAirports = async siteUrl => {
  try {
    const res = await fetch(`${siteUrl}/api/v1/airports/`);
    const json = await res.json();
    const airports = json.data.results.map(airport => ({
      city: airport.city,
      iataCode: airport.iata_code,
      description: airport.name,
      googlePlaceIds: airport.google_place_ids
    }));
    saveAirportsLocal(airports);
    return airports;
  } catch {
    return [];
  }
};

const SearchWidget = () => {
  const defaultSuggestion = useStore(state => state.autocomplete?.defaultSuggestion);
  const isMobile = useStore(state => state.isMobile);
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  const setParkingType = useStore(state => state.setParkingType);
  const onParkingChange = useStore(state => state.onParkingChange);
  const events = useStore(state => state.events) || [];
  const eventMode = useStore(state => state.eventMode);
  const setSelectedSuggestion = useStore(state => state.autocomplete.setSelectedSuggestion);
  const setAirports = useStore(state => state.setAirports);
  const siteUrl = useStore(state => state.siteUrl);
  const FindParkingSpotsButton = useStore(state => state.FindParkingSpotsButton);
  const FindParkingSpotsPartialStore = useFindParkingSpotsButtonPartialStore();
  const showEventTab = eventMode === 'search' ? defaultSuggestion && isEventSuggestion(defaultSuggestion) : events.length || parkingType === 'event';
  const showToggleButtonGroup = !(eventMode === 'search' && parkingSubType === 'power_booking');
  const showEventToggleOnDesktop = useShowEventToggleOnDesktop();
  const handleParkingTypeChange = e => {
    const newParkingType = e.target.value;
    setParkingType(newParkingType);
    if (onParkingChange) {
      onParkingChange({
        ...FindParkingSpotsPartialStore,
        parkingType: newParkingType,
        parkingSubType: newParkingType
      });
    }
  };
  const handleParkingTypeToggleChange = newParkingType => {
    setParkingType(newParkingType);
    // Restore the event suggestion when the parking type is changes back to 'event'
    if (eventMode === 'search' && newParkingType === 'event' && defaultSuggestion) {
      setSelectedSuggestion(defaultSuggestion);
    }
  };
  const isAirportSearch = parkingType === 'airport' && eventMode === 'search';
  useEffect(() => {
    const populateAirports = async () => {
      if (setAirports && siteUrl) {
        const airports = await getAirportsLocal(siteUrl);
        setAirports(airports);
      }
    };
    populateAirports();
  }, [setAirports, siteUrl]);
  const showToggleInDesktop = !showEventToggleOnDesktop && !isAirportSearch;
  const showToggleInMobile = showToggleButtonGroup && !isAirportSearch;
  if (isSearchOnDesktop(eventMode, isMobile)) {
    return jsxRuntimeExports.jsxs(Flex, {
      gap: 0,
      backgroundColor: "white",
      rounded: "lg",
      "data-testid": "SearchWidget",
      className: "SearchWidget",
      display: "grid",
      gridTemplateColumns: !showToggleInDesktop ? '2fr 2fr' : '1fr 2fr 2fr',
      children: [showToggleInDesktop && jsxRuntimeExports.jsx(Box, {
        marginRight: 2,
        sx: {
          '.chakra-select': {
            paddingTop: 'var(--chakra-sizes-5-5)',
            paddingBottom: '2'
          }
        },
        children: jsxRuntimeExports.jsxs(RefreshedSelectInput, {
          label: "Reservation Type",
          value: parkingType,
          onChange: handleParkingTypeChange,
          minWidth: "130px",
          minHeight: "56px" //Added as sometimes the height ends up at 55.5
          ,
          marginRight: 2,
          "data-testid": "SearchWidget-Select",
          id: "SearchWidget-Select",
          fontSize: "base" // Ensure same font as input
          ,
          fontWeight: "normal" // Ensure same font as input
          ,
          lineHeight: "24px" // Static as design needed it to be specific
          ,
          children: [jsxRuntimeExports.jsx("option", {
            value: "hourly",
            children: "Hourly/Daily"
          }), jsxRuntimeExports.jsx("option", {
            value: "monthly",
            children: "Monthly"
          })]
        })
      }), jsxRuntimeExports.jsx(SearchWidgetTab, {})]
    });
  }
  // TODO: Line in between toggle group selector buttons
  return jsxRuntimeExports.jsxs(Flex, {
    flexDirection: "column",
    gap: 4,
    backgroundColor: "white",
    rounded: "lg",
    "data-testid": "SearchWidget",
    className: "SearchWidget",
    children: [jsxRuntimeExports.jsx(LocationGetError, {}), showToggleInMobile && jsxRuntimeExports.jsxs(ToggleButtonGroup, {
      "data-testid": "SearchWidget-ToggleButtonGroup",
      "data-test-value": parkingType,
      value: parkingType,
      onChange: handleParkingTypeToggleChange,
      groupProps: {
        width: '100%'
      },
      display: "flex",
      children: [showEventTab ? jsxRuntimeExports.jsx(Button, {
        "aria-label": "Switch to events parking search",
        "data-testid": "SearchWidget-ToggleButton-event",
        value: "event",
        ...toggleButtonStyles,
        children: "Events"
      }, "event") : jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) //Has to be fragment as ToggleButtonGroup doesn't support non react element children
      , jsxRuntimeExports.jsx(Button, {
        "aria-label": "Switch to hourly/daily parking search",
        "data-testid": "SearchWidget-ToggleButton-hourly",
        value: "hourly",
        ...toggleButtonStyles,
        children: "Hourly/Daily"
      }, "hourly"), jsxRuntimeExports.jsx(Button, {
        "data-testid": "SearchWidget-ToggleButton-monthly",
        value: "monthly",
        ...toggleButtonStyles,
        children: "Monthly"
      }, "monthly")]
    }), parkingType === 'event' ? jsxRuntimeExports.jsx(SearchWidgetEventTab, {}) : jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [jsxRuntimeExports.jsx(SearchWidgetTab, {}), FindParkingSpotsButton && jsxRuntimeExports.jsx(FindParkingSpotsButton, {
        partialStore: FindParkingSpotsPartialStore
      })]
    })]
  });
};

const MobileToggle = props => {
  const selectedSuggestion = useStore(state => state.autocomplete.selectedSuggestion);
  const defaultSuggestion = useStore(state => state.autocomplete.defaultSuggestion);
  const monthlyStartDate = useStore(state => state.monthlyStartDate);
  const powerBookingDates = useStore(state => state.dates);
  const startTime = useStore(state => state.startTime);
  const endTime = useStore(state => state.endTime);
  const startDate = useStore(state => state.startDate);
  const endDate = useStore(state => state.endDate);
  const timezone = useStore(state => state.timezone);
  const parkingType = useStore(state => state.parkingType);
  const parkingSubType = useStore(state => state.parkingSubType);
  let topText = selectedSuggestion?.description || '';
  let bottomText;
  let eventIconData = undefined;
  //Logic for toggling what to show bottom
  if (parkingType === 'monthly') {
    bottomText = `Monthly parking starting ${formatMonthlyDateShort(monthlyStartDate)}`;
  } else {
    bottomText = formatDateRange(startDate, endDate, timezone);
  }
  //Logic for toggling event icon
  if (isEventSuggestion(selectedSuggestion)) {
    eventIconData = {
      month: dayjs(startDate).format('MMM'),
      date: dayjs(startDate).format('DD')
    };
    topText = selectedSuggestion.eventTitle || '';
    bottomText = formatDateRange(startDate, endDate, timezone);
  }
  if (parkingType === 'event' && defaultSuggestion && isEventSuggestion(defaultSuggestion)) {
    eventIconData = {
      month: dayjs(startDate).format('MMM'),
      date: dayjs(startDate).format('DD')
    };
    topText = defaultSuggestion.eventTitle || '';
    bottomText = formatDateRange(startDate, endDate, timezone);
  }
  //Logic for powerbooking
  if (parkingSubType === 'power_booking') {
    bottomText = formatMultipleDates(powerBookingDates, startTime, endTime);
  }
  return jsxRuntimeExports.jsx(MobileToggleBase, {
    ...props,
    topText: topText,
    bottomText: bottomText,
    eventIconData: eventIconData
  });
};

export { DateRangePicker$3 as DateRangePicker, DateRangePicker$2 as DateRangePickerV2, EventListItem, MultipleDatesPicker$1 as MultipleDatesPicker, SearchWidget as SearchComponent, MobileToggle as SearchComponentMobileToggle, SearchComponentStoreProvider, SearchWidgetTooltip, SingleDatePicker, TimePicker, isAirportSuggestion, isGoogleAutocompleteSuggestion, saveNewRecentPlace, useFindParkingSpotsButtonPartialStore, useShowLoader };
//# sourceMappingURL=index.esm.js.map
